var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { noop, makeDestructurable, camelize, toValue, isClient, isObject, tryOnScopeDispose, isIOS, tryOnMounted, notNullish, objectOmit, promiseTimeout, until, increaseWithUnit, objectEntries, createSingletonPromise, useTimeoutFn, pausableWatch, toRef, createEventHook, computedWithControl, timestamp, pausableFilter, watchIgnorable, debounceFilter, createFilterWrapper, bypassFilter, toRefs, useIntervalFn, containsProp, hasOwn, throttleFilter, useDebounceFn, useThrottleFn, clamp, syncRef, objectPick, tryOnUnmounted, watchWithFilter, tryOnBeforeUnmount, identity, isDef, isWorker } from '@vueuse/shared';
export * from '@vueuse/shared';
import { isRef, ref, shallowRef, watchEffect, computed, inject, isVue3, version, defineComponent, h, TransitionGroup, shallowReactive, Fragment, watch, getCurrentInstance, customRef, onUpdated, onMounted, isVue2, readonly, nextTick, reactive, markRaw, unref, getCurrentScope, set, del, isReadonly, onBeforeUpdate } from 'vue-demi';
function computedAsync(evaluationCallback, initialState, optionsOrRef) {
    var _this = this;
    var options;
    if (isRef(optionsOrRef)) {
        options = {
            evaluating: optionsOrRef
        };
    }
    else {
        options = optionsOrRef || {};
    }
    var _j = options.lazy, lazy = _j === void 0 ? false : _j, _k = options.evaluating, evaluating = _k === void 0 ? void 0 : _k, _l = options.shallow, shallow = _l === void 0 ? true : _l, _m = options.onError, onError = _m === void 0 ? noop : _m;
    var started = ref(!lazy);
    var current = shallow ? shallowRef(initialState) : ref(initialState);
    var counter = 0;
    watchEffect(function (onInvalidate) { return __awaiter(_this, void 0, void 0, function () {
        var counterAtBeginning, hasFinished, result, e_1;
        return __generator(this, function (_j) {
            switch (_j.label) {
                case 0:
                    if (!started.value)
                        return [2 /*return*/];
                    counter++;
                    counterAtBeginning = counter;
                    hasFinished = false;
                    if (evaluating) {
                        Promise.resolve().then(function () {
                            evaluating.value = true;
                        });
                    }
                    _j.label = 1;
                case 1:
                    _j.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, evaluationCallback(function (cancelCallback) {
                            onInvalidate(function () {
                                if (evaluating)
                                    evaluating.value = false;
                                if (!hasFinished)
                                    cancelCallback();
                            });
                        })];
                case 2:
                    result = _j.sent();
                    if (counterAtBeginning === counter)
                        current.value = result;
                    return [3 /*break*/, 5];
                case 3:
                    e_1 = _j.sent();
                    onError(e_1);
                    return [3 /*break*/, 5];
                case 4:
                    if (evaluating && counterAtBeginning === counter)
                        evaluating.value = false;
                    hasFinished = true;
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); });
    if (lazy) {
        return computed(function () {
            started.value = true;
            return current.value;
        });
    }
    else {
        return current;
    }
}
function computedInject(key, options, defaultSource, treatDefaultAsFactory) {
    var source = inject(key);
    if (defaultSource)
        source = inject(key, defaultSource);
    if (treatDefaultAsFactory)
        source = inject(key, defaultSource, treatDefaultAsFactory);
    if (typeof options === "function") {
        return computed(function (ctx) { return options(source, ctx); });
    }
    else {
        return computed({
            get: function (ctx) { return options.get(source, ctx); },
            set: options.set
        });
    }
}
function createReusableTemplate(options) {
    if (options === void 0) { options = {}; }
    if (!isVue3 && !version.startsWith("2.7.")) {
        if (process.env.NODE_ENV !== "production")
            throw new Error("[VueUse] createReusableTemplate only works in Vue 2.7 or above.");
        return;
    }
    var _j = options.inheritAttrs, inheritAttrs = _j === void 0 ? true : _j;
    var render = shallowRef();
    var define = /* #__PURE__ */ defineComponent({
        setup: function (_, _j) {
            var slots = _j.slots;
            return function () {
                render.value = slots.default;
            };
        }
    });
    var reuse = /* #__PURE__ */ defineComponent({
        inheritAttrs: inheritAttrs,
        setup: function (_, _j) {
            var attrs = _j.attrs, slots = _j.slots;
            return function () {
                var _a;
                if (!render.value && process.env.NODE_ENV !== "production")
                    throw new Error("[VueUse] Failed to find the definition of reusable template");
                var vnode = (_a = render.value) == null ? void 0 : _a.call(render, __assign(__assign({}, keysToCamelKebabCase(attrs)), { $slots: slots }));
                return inheritAttrs && (vnode == null ? void 0 : vnode.length) === 1 ? vnode[0] : vnode;
            };
        }
    });
    return makeDestructurable({ define: define, reuse: reuse }, [define, reuse]);
}
function keysToCamelKebabCase(obj) {
    var newObj = {};
    for (var key in obj)
        newObj[camelize(key)] = obj[key];
    return newObj;
}
function createTemplatePromise(options) {
    if (options === void 0) { options = {}; }
    if (!isVue3) {
        if (process.env.NODE_ENV !== "production")
            throw new Error("[VueUse] createTemplatePromise only works in Vue 3 or above.");
        return;
    }
    var index = 0;
    var instances = ref([]);
    function create() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var props = shallowReactive({
            key: index++,
            args: args,
            promise: void 0,
            resolve: function () {
            },
            reject: function () {
            },
            isResolving: false,
            options: options
        });
        instances.value.push(props);
        props.promise = new Promise(function (_resolve, _reject) {
            props.resolve = function (v) {
                props.isResolving = true;
                return _resolve(v);
            };
            props.reject = _reject;
        }).finally(function () {
            props.promise = void 0;
            var index2 = instances.value.indexOf(props);
            if (index2 !== -1)
                instances.value.splice(index2, 1);
        });
        return props.promise;
    }
    function start() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (options.singleton && instances.value.length > 0)
            return instances.value[0].promise;
        return create.apply(void 0, __spreadArray([], __read(args), false));
    }
    var component = /* #__PURE__ */ defineComponent(function (_, _j) {
        var slots = _j.slots;
        var renderList = function () { return instances.value.map(function (props) {
            var _a;
            return h(Fragment, { key: props.key }, (_a = slots.default) == null ? void 0 : _a.call(slots, props));
        }); };
        if (options.transition)
            return function () { return h(TransitionGroup, options.transition, renderList); };
        return renderList;
    });
    component.start = start;
    return component;
}
function createUnrefFn(fn) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return fn.apply(this, args.map(function (i) { return toValue(i); }));
    };
}
function unrefElement(elRef) {
    var _a;
    var plain = toValue(elRef);
    return (_a = plain == null ? void 0 : plain.$el) != null ? _a : plain;
}
var defaultWindow = isClient ? window : void 0;
var defaultDocument = isClient ? window.document : void 0;
var defaultNavigator = isClient ? window.navigator : void 0;
var defaultLocation = isClient ? window.location : void 0;
function useEventListener() {
    var _j, _k;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var target;
    var events;
    var listeners;
    var options;
    if (typeof args[0] === "string" || Array.isArray(args[0])) {
        _j = __read(args, 3), events = _j[0], listeners = _j[1], options = _j[2];
        target = defaultWindow;
    }
    else {
        _k = __read(args, 4), target = _k[0], events = _k[1], listeners = _k[2], options = _k[3];
    }
    if (!target)
        return noop;
    if (!Array.isArray(events))
        events = [events];
    if (!Array.isArray(listeners))
        listeners = [listeners];
    var cleanups = [];
    var cleanup = function () {
        cleanups.forEach(function (fn) { return fn(); });
        cleanups.length = 0;
    };
    var register = function (el, event, listener, options2) {
        el.addEventListener(event, listener, options2);
        return function () { return el.removeEventListener(event, listener, options2); };
    };
    var stopWatch = watch(function () { return [unrefElement(target), toValue(options)]; }, function (_j) {
        var _k = __read(_j, 2), el = _k[0], options2 = _k[1];
        cleanup();
        if (!el)
            return;
        var optionsClone = isObject(options2) ? __assign({}, options2) : options2;
        cleanups.push.apply(cleanups, __spreadArray([], __read(events.flatMap(function (event) {
            return listeners.map(function (listener) { return register(el, event, listener, optionsClone); });
        })), false));
    }, { immediate: true, flush: "post" });
    var stop = function () {
        stopWatch();
        cleanup();
    };
    tryOnScopeDispose(stop);
    return stop;
}
var _iOSWorkaround = false;
function onClickOutside(target, handler, options) {
    if (options === void 0) { options = {}; }
    var _j = options.window, window = _j === void 0 ? defaultWindow : _j, _k = options.ignore, ignore = _k === void 0 ? [] : _k, _l = options.capture, capture = _l === void 0 ? true : _l, _m = options.detectIframe, detectIframe = _m === void 0 ? false : _m;
    if (!window)
        return noop;
    if (isIOS && !_iOSWorkaround) {
        _iOSWorkaround = true;
        Array.from(window.document.body.children).forEach(function (el) { return el.addEventListener("click", noop); });
        window.document.documentElement.addEventListener("click", noop);
    }
    var shouldListen = true;
    var shouldIgnore = function (event) {
        return ignore.some(function (target2) {
            if (typeof target2 === "string") {
                return Array.from(window.document.querySelectorAll(target2)).some(function (el) { return el === event.target || event.composedPath().includes(el); });
            }
            else {
                var el = unrefElement(target2);
                return el && (event.target === el || event.composedPath().includes(el));
            }
        });
    };
    var listener = function (event) {
        var el = unrefElement(target);
        if (!el || el === event.target || event.composedPath().includes(el))
            return;
        if (event.detail === 0)
            shouldListen = !shouldIgnore(event);
        if (!shouldListen) {
            shouldListen = true;
            return;
        }
        handler(event);
    };
    var cleanup = [
        useEventListener(window, "click", listener, { passive: true, capture: capture }),
        useEventListener(window, "pointerdown", function (e) {
            var el = unrefElement(target);
            shouldListen = !shouldIgnore(e) && !!(el && !e.composedPath().includes(el));
        }, { passive: true }),
        detectIframe && useEventListener(window, "blur", function (event) {
            setTimeout(function () {
                var _a;
                var el = unrefElement(target);
                if (((_a = window.document.activeElement) == null ? void 0 : _a.tagName) === "IFRAME" && !(el == null ? void 0 : el.contains(window.document.activeElement))) {
                    handler(event);
                }
            }, 0);
        })
    ].filter(Boolean);
    var stop = function () { return cleanup.forEach(function (fn) { return fn(); }); };
    return stop;
}
function createKeyPredicate(keyFilter) {
    if (typeof keyFilter === "function")
        return keyFilter;
    else if (typeof keyFilter === "string")
        return function (event) { return event.key === keyFilter; };
    else if (Array.isArray(keyFilter))
        return function (event) { return keyFilter.includes(event.key); };
    return function () { return true; };
}
function onKeyStroke() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var key;
    var handler;
    var options = {};
    if (args.length === 3) {
        key = args[0];
        handler = args[1];
        options = args[2];
    }
    else if (args.length === 2) {
        if (typeof args[1] === "object") {
            key = true;
            handler = args[0];
            options = args[1];
        }
        else {
            key = args[0];
            handler = args[1];
        }
    }
    else {
        key = true;
        handler = args[0];
    }
    var _j = options.target, target = _j === void 0 ? defaultWindow : _j, _k = options.eventName, eventName = _k === void 0 ? "keydown" : _k, _l = options.passive, passive = _l === void 0 ? false : _l, _m = options.dedupe, dedupe = _m === void 0 ? false : _m;
    var predicate = createKeyPredicate(key);
    var listener = function (e) {
        if (e.repeat && toValue(dedupe))
            return;
        if (predicate(e))
            handler(e);
    };
    return useEventListener(target, eventName, listener, passive);
}
function onKeyDown(key, handler, options) {
    if (options === void 0) { options = {}; }
    return onKeyStroke(key, handler, __assign(__assign({}, options), { eventName: "keydown" }));
}
function onKeyPressed(key, handler, options) {
    if (options === void 0) { options = {}; }
    return onKeyStroke(key, handler, __assign(__assign({}, options), { eventName: "keypress" }));
}
function onKeyUp(key, handler, options) {
    if (options === void 0) { options = {}; }
    return onKeyStroke(key, handler, __assign(__assign({}, options), { eventName: "keyup" }));
}
var DEFAULT_DELAY = 500;
var DEFAULT_THRESHOLD = 10;
function onLongPress(target, handler, options) {
    var _a, _b;
    var elementRef = computed(function () { return unrefElement(target); });
    var timeout;
    var posStart;
    var startTimestamp;
    var hasLongPressed = false;
    function clear() {
        if (timeout) {
            clearTimeout(timeout);
            timeout = void 0;
        }
        posStart = void 0;
        startTimestamp = void 0;
        hasLongPressed = false;
    }
    function onRelease(ev) {
        var _a2, _b2, _c;
        var _j = __read([startTimestamp, posStart, hasLongPressed], 3), _startTimestamp = _j[0], _posStart = _j[1], _hasLongPressed = _j[2];
        clear();
        if (!(options == null ? void 0 : options.onMouseUp) || !_posStart || !_startTimestamp)
            return;
        if (((_a2 = options == null ? void 0 : options.modifiers) == null ? void 0 : _a2.self) && ev.target !== elementRef.value)
            return;
        if ((_b2 = options == null ? void 0 : options.modifiers) == null ? void 0 : _b2.prevent)
            ev.preventDefault();
        if ((_c = options == null ? void 0 : options.modifiers) == null ? void 0 : _c.stop)
            ev.stopPropagation();
        var dx = ev.x - _posStart.x;
        var dy = ev.y - _posStart.y;
        var distance = Math.sqrt(dx * dx + dy * dy);
        options.onMouseUp(ev.timeStamp - _startTimestamp, distance, _hasLongPressed);
    }
    function onDown(ev) {
        var _a2, _b2, _c, _d;
        if (((_a2 = options == null ? void 0 : options.modifiers) == null ? void 0 : _a2.self) && ev.target !== elementRef.value)
            return;
        clear();
        if ((_b2 = options == null ? void 0 : options.modifiers) == null ? void 0 : _b2.prevent)
            ev.preventDefault();
        if ((_c = options == null ? void 0 : options.modifiers) == null ? void 0 : _c.stop)
            ev.stopPropagation();
        posStart = {
            x: ev.x,
            y: ev.y
        };
        startTimestamp = ev.timeStamp;
        timeout = setTimeout(function () {
            hasLongPressed = true;
            handler(ev);
        }, (_d = options == null ? void 0 : options.delay) != null ? _d : DEFAULT_DELAY);
    }
    function onMove(ev) {
        var _a2, _b2, _c, _d;
        if (((_a2 = options == null ? void 0 : options.modifiers) == null ? void 0 : _a2.self) && ev.target !== elementRef.value)
            return;
        if (!posStart || (options == null ? void 0 : options.distanceThreshold) === false)
            return;
        if ((_b2 = options == null ? void 0 : options.modifiers) == null ? void 0 : _b2.prevent)
            ev.preventDefault();
        if ((_c = options == null ? void 0 : options.modifiers) == null ? void 0 : _c.stop)
            ev.stopPropagation();
        var dx = ev.x - posStart.x;
        var dy = ev.y - posStart.y;
        var distance = Math.sqrt(dx * dx + dy * dy);
        if (distance >= ((_d = options == null ? void 0 : options.distanceThreshold) != null ? _d : DEFAULT_THRESHOLD))
            clear();
    }
    var listenerOptions = {
        capture: (_a = options == null ? void 0 : options.modifiers) == null ? void 0 : _a.capture,
        once: (_b = options == null ? void 0 : options.modifiers) == null ? void 0 : _b.once
    };
    var cleanup = [
        useEventListener(elementRef, "pointerdown", onDown, listenerOptions),
        useEventListener(elementRef, "pointermove", onMove, listenerOptions),
        useEventListener(elementRef, ["pointerup", "pointerleave"], onRelease, listenerOptions)
    ];
    var stop = function () { return cleanup.forEach(function (fn) { return fn(); }); };
    return stop;
}
function isFocusedElementEditable() {
    var activeElement = document.activeElement, body = document.body;
    if (!activeElement)
        return false;
    if (activeElement === body)
        return false;
    switch (activeElement.tagName) {
        case "INPUT":
        case "TEXTAREA":
            return true;
    }
    return activeElement.hasAttribute("contenteditable");
}
function isTypedCharValid(_j) {
    var keyCode = _j.keyCode, metaKey = _j.metaKey, ctrlKey = _j.ctrlKey, altKey = _j.altKey;
    if (metaKey || ctrlKey || altKey)
        return false;
    if (keyCode >= 48 && keyCode <= 57)
        return true;
    if (keyCode >= 65 && keyCode <= 90)
        return true;
    if (keyCode >= 97 && keyCode <= 122)
        return true;
    return false;
}
function onStartTyping(callback, options) {
    if (options === void 0) { options = {}; }
    var _j = options.document, document2 = _j === void 0 ? defaultDocument : _j;
    var keydown = function (event) {
        !isFocusedElementEditable() && isTypedCharValid(event) && callback(event);
    };
    if (document2)
        useEventListener(document2, "keydown", keydown, { passive: true });
}
function templateRef(key, initialValue) {
    if (initialValue === void 0) { initialValue = null; }
    var instance = getCurrentInstance();
    var _trigger = function () {
    };
    var element = customRef(function (track, trigger) {
        _trigger = trigger;
        return {
            get: function () {
                var _a, _b;
                track();
                return (_b = (_a = instance == null ? void 0 : instance.proxy) == null ? void 0 : _a.$refs[key]) != null ? _b : initialValue;
            },
            set: function () {
            }
        };
    });
    tryOnMounted(_trigger);
    onUpdated(_trigger);
    return element;
}
function useMounted() {
    var isMounted = ref(false);
    var instance = getCurrentInstance();
    if (instance) {
        onMounted(function () {
            isMounted.value = true;
        }, isVue2 ? void 0 : instance);
    }
    return isMounted;
}
function useSupported(callback) {
    var isMounted = useMounted();
    return computed(function () {
        isMounted.value;
        return Boolean(callback());
    });
}
function useMutationObserver(target, callback, options) {
    if (options === void 0) { options = {}; }
    var _j = options.window, window = _j === void 0 ? defaultWindow : _j, mutationOptions = __rest(options, ["window"]);
    var observer;
    var isSupported = useSupported(function () { return window && "MutationObserver" in window; });
    var cleanup = function () {
        if (observer) {
            observer.disconnect();
            observer = void 0;
        }
    };
    var targets = computed(function () {
        var value = toValue(target);
        var items = (Array.isArray(value) ? value : [value]).map(unrefElement).filter(notNullish);
        return new Set(items);
    });
    var stopWatch = watch(function () { return targets.value; }, function (targets2) {
        cleanup();
        if (isSupported.value && targets2.size) {
            observer = new MutationObserver(callback);
            targets2.forEach(function (el) { return observer.observe(el, mutationOptions); });
        }
    }, { immediate: true, flush: "post" });
    var takeRecords = function () {
        return observer == null ? void 0 : observer.takeRecords();
    };
    var stop = function () {
        cleanup();
        stopWatch();
    };
    tryOnScopeDispose(stop);
    return {
        isSupported: isSupported,
        stop: stop,
        takeRecords: takeRecords
    };
}
function useActiveElement(options) {
    if (options === void 0) { options = {}; }
    var _a;
    var _j = options.window, window = _j === void 0 ? defaultWindow : _j, _k = options.deep, deep = _k === void 0 ? true : _k, _l = options.triggerOnRemoval, triggerOnRemoval = _l === void 0 ? false : _l;
    var document = (_a = options.document) != null ? _a : window == null ? void 0 : window.document;
    var getDeepActiveElement = function () {
        var _a2;
        var element = document == null ? void 0 : document.activeElement;
        if (deep) {
            while (element == null ? void 0 : element.shadowRoot)
                element = (_a2 = element == null ? void 0 : element.shadowRoot) == null ? void 0 : _a2.activeElement;
        }
        return element;
    };
    var activeElement = ref();
    var trigger = function () {
        activeElement.value = getDeepActiveElement();
    };
    if (window) {
        useEventListener(window, "blur", function (event) {
            if (event.relatedTarget !== null)
                return;
            trigger();
        }, true);
        useEventListener(window, "focus", trigger, true);
    }
    if (triggerOnRemoval) {
        useMutationObserver(document, function (mutations) {
            mutations.filter(function (m) { return m.removedNodes.length; }).map(function (n) { return Array.from(n.removedNodes); }).flat().forEach(function (node) {
                if (node === activeElement.value)
                    trigger();
            });
        }, {
            childList: true,
            subtree: true
        });
    }
    trigger();
    return activeElement;
}
function useRafFn(fn, options) {
    if (options === void 0) { options = {}; }
    var _j = options.immediate, immediate = _j === void 0 ? true : _j, _k = options.fpsLimit, fpsLimit = _k === void 0 ? void 0 : _k, _l = options.window, window = _l === void 0 ? defaultWindow : _l;
    var isActive = ref(false);
    var intervalLimit = fpsLimit ? 1e3 / fpsLimit : null;
    var previousFrameTimestamp = 0;
    var rafId = null;
    function loop(timestamp) {
        if (!isActive.value || !window)
            return;
        if (!previousFrameTimestamp)
            previousFrameTimestamp = timestamp;
        var delta = timestamp - previousFrameTimestamp;
        if (intervalLimit && delta < intervalLimit) {
            rafId = window.requestAnimationFrame(loop);
            return;
        }
        previousFrameTimestamp = timestamp;
        fn({ delta: delta, timestamp: timestamp });
        rafId = window.requestAnimationFrame(loop);
    }
    function resume() {
        if (!isActive.value && window) {
            isActive.value = true;
            previousFrameTimestamp = 0;
            rafId = window.requestAnimationFrame(loop);
        }
    }
    function pause() {
        isActive.value = false;
        if (rafId != null && window) {
            window.cancelAnimationFrame(rafId);
            rafId = null;
        }
    }
    if (immediate)
        resume();
    tryOnScopeDispose(pause);
    return {
        isActive: readonly(isActive),
        pause: pause,
        resume: resume
    };
}
function useAnimate(target, keyframes, options) {
    var config;
    var animateOptions;
    if (isObject(options)) {
        config = options;
        animateOptions = objectOmit(options, ["window", "immediate", "commitStyles", "persist", "onReady", "onError"]);
    }
    else {
        config = { duration: options };
        animateOptions = options;
    }
    var _j = config.window, window = _j === void 0 ? defaultWindow : _j, _k = config.immediate, immediate = _k === void 0 ? true : _k, commitStyles = config.commitStyles, persist = config.persist, _l = config.playbackRate, _playbackRate = _l === void 0 ? 1 : _l, onReady = config.onReady, _m = config.onError, onError = _m === void 0 ? function (e) {
        console.error(e);
    } : _m;
    var isSupported = useSupported(function () { return window && HTMLElement && "animate" in HTMLElement.prototype; });
    var animate = shallowRef(void 0);
    var store = shallowReactive({
        startTime: null,
        currentTime: null,
        timeline: null,
        playbackRate: _playbackRate,
        pending: false,
        playState: immediate ? "idle" : "paused",
        replaceState: "active"
    });
    var pending = computed(function () { return store.pending; });
    var playState = computed(function () { return store.playState; });
    var replaceState = computed(function () { return store.replaceState; });
    var startTime = computed({
        get: function () {
            return store.startTime;
        },
        set: function (value) {
            store.startTime = value;
            if (animate.value)
                animate.value.startTime = value;
        }
    });
    var currentTime = computed({
        get: function () {
            return store.currentTime;
        },
        set: function (value) {
            store.currentTime = value;
            if (animate.value) {
                animate.value.currentTime = value;
                syncResume();
            }
        }
    });
    var timeline = computed({
        get: function () {
            return store.timeline;
        },
        set: function (value) {
            store.timeline = value;
            if (animate.value)
                animate.value.timeline = value;
        }
    });
    var playbackRate = computed({
        get: function () {
            return store.playbackRate;
        },
        set: function (value) {
            store.playbackRate = value;
            if (animate.value)
                animate.value.playbackRate = value;
        }
    });
    var play = function () {
        if (animate.value) {
            try {
                animate.value.play();
                syncResume();
            }
            catch (e) {
                syncPause();
                onError(e);
            }
        }
        else {
            update();
        }
    };
    var pause = function () {
        var _a;
        try {
            (_a = animate.value) == null ? void 0 : _a.pause();
            syncPause();
        }
        catch (e) {
            onError(e);
        }
    };
    var reverse = function () {
        var _a;
        !animate.value && update();
        try {
            (_a = animate.value) == null ? void 0 : _a.reverse();
            syncResume();
        }
        catch (e) {
            syncPause();
            onError(e);
        }
    };
    var finish = function () {
        var _a;
        try {
            (_a = animate.value) == null ? void 0 : _a.finish();
            syncPause();
        }
        catch (e) {
            onError(e);
        }
    };
    var cancel = function () {
        var _a;
        try {
            (_a = animate.value) == null ? void 0 : _a.cancel();
            syncPause();
        }
        catch (e) {
            onError(e);
        }
    };
    watch(function () { return unrefElement(target); }, function (el) {
        el && update();
    });
    watch(function () { return keyframes; }, function (value) {
        !animate.value && update();
        if (!unrefElement(target) && animate.value) {
            animate.value.effect = new KeyframeEffect(unrefElement(target), toValue(value), animateOptions);
        }
    }, { deep: true });
    tryOnMounted(function () {
        nextTick(function () { return update(true); });
    });
    tryOnScopeDispose(cancel);
    function update(init) {
        var el = unrefElement(target);
        if (!isSupported.value || !el)
            return;
        if (!animate.value)
            animate.value = el.animate(toValue(keyframes), animateOptions);
        if (persist)
            animate.value.persist();
        if (_playbackRate !== 1)
            animate.value.playbackRate = _playbackRate;
        if (init && !immediate)
            animate.value.pause();
        else
            syncResume();
        onReady == null ? void 0 : onReady(animate.value);
    }
    useEventListener(animate, ["cancel", "finish", "remove"], syncPause);
    useEventListener(animate, "finish", function () {
        var _a;
        if (commitStyles)
            (_a = animate.value) == null ? void 0 : _a.commitStyles();
    });
    var _o = useRafFn(function () {
        if (!animate.value)
            return;
        store.pending = animate.value.pending;
        store.playState = animate.value.playState;
        store.replaceState = animate.value.replaceState;
        store.startTime = animate.value.startTime;
        store.currentTime = animate.value.currentTime;
        store.timeline = animate.value.timeline;
        store.playbackRate = animate.value.playbackRate;
    }, { immediate: false }), resumeRef = _o.resume, pauseRef = _o.pause;
    function syncResume() {
        if (isSupported.value)
            resumeRef();
    }
    function syncPause() {
        if (isSupported.value && window)
            window.requestAnimationFrame(pauseRef);
    }
    return {
        isSupported: isSupported,
        animate: animate,
        // actions
        play: play,
        pause: pause,
        reverse: reverse,
        finish: finish,
        cancel: cancel,
        // state
        pending: pending,
        playState: playState,
        replaceState: replaceState,
        startTime: startTime,
        currentTime: currentTime,
        timeline: timeline,
        playbackRate: playbackRate
    };
}
function useAsyncQueue(tasks, options) {
    var _j = options || {}, _k = _j.interrupt, interrupt = _k === void 0 ? true : _k, _l = _j.onError, onError = _l === void 0 ? noop : _l, _m = _j.onFinished, onFinished = _m === void 0 ? noop : _m, signal = _j.signal;
    var promiseState = {
        aborted: "aborted",
        fulfilled: "fulfilled",
        pending: "pending",
        rejected: "rejected"
    };
    var initialResult = Array.from(Array.from({ length: tasks.length }), function () { return ({ state: promiseState.pending, data: null }); });
    var result = reactive(initialResult);
    var activeIndex = ref(-1);
    if (!tasks || tasks.length === 0) {
        onFinished();
        return {
            activeIndex: activeIndex,
            result: result
        };
    }
    function updateResult(state, res) {
        activeIndex.value++;
        result[activeIndex.value].data = res;
        result[activeIndex.value].state = state;
    }
    tasks.reduce(function (prev, curr) {
        return prev.then(function (prevRes) {
            var _a;
            if (signal == null ? void 0 : signal.aborted) {
                updateResult(promiseState.aborted, new Error("aborted"));
                return;
            }
            if (((_a = result[activeIndex.value]) == null ? void 0 : _a.state) === promiseState.rejected && interrupt) {
                onFinished();
                return;
            }
            var done = curr(prevRes).then(function (currentRes) {
                updateResult(promiseState.fulfilled, currentRes);
                activeIndex.value === tasks.length - 1 && onFinished();
                return currentRes;
            });
            if (!signal)
                return done;
            return Promise.race([done, whenAborted(signal)]);
        }).catch(function (e) {
            if (signal == null ? void 0 : signal.aborted) {
                updateResult(promiseState.aborted, e);
                return e;
            }
            updateResult(promiseState.rejected, e);
            onError();
            return e;
        });
    }, Promise.resolve());
    return {
        activeIndex: activeIndex,
        result: result
    };
}
function whenAborted(signal) {
    return new Promise(function (resolve, reject) {
        var error = new Error("aborted");
        if (signal.aborted)
            reject(error);
        else
            signal.addEventListener("abort", function () { return reject(error); }, { once: true });
    });
}
function useAsyncState(promise, initialState, options) {
    var _j = options != null ? options : {}, _k = _j.immediate, immediate = _k === void 0 ? true : _k, _l = _j.delay, delay = _l === void 0 ? 0 : _l, _m = _j.onError, onError = _m === void 0 ? noop : _m, _o = _j.onSuccess, onSuccess = _o === void 0 ? noop : _o, _p = _j.resetOnExecute, resetOnExecute = _p === void 0 ? true : _p, _q = _j.shallow, shallow = _q === void 0 ? true : _q, throwError = _j.throwError;
    var state = shallow ? shallowRef(initialState) : ref(initialState);
    var isReady = ref(false);
    var isLoading = ref(false);
    var error = shallowRef(void 0);
    function execute() {
        return __awaiter(this, arguments, void 0, function (delay2) {
            var _i, _promise, data, e_2;
            if (delay2 === void 0) { delay2 = 0; }
            var args = [];
            for (_i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            return __generator(this, function (_j) {
                switch (_j.label) {
                    case 0:
                        if (resetOnExecute)
                            state.value = initialState;
                        error.value = void 0;
                        isReady.value = false;
                        isLoading.value = true;
                        if (!(delay2 > 0)) return [3 /*break*/, 2];
                        return [4 /*yield*/, promiseTimeout(delay2)];
                    case 1:
                        _j.sent();
                        _j.label = 2;
                    case 2:
                        _promise = typeof promise === "function" ? promise.apply(void 0, __spreadArray([], __read(args), false)) : promise;
                        _j.label = 3;
                    case 3:
                        _j.trys.push([3, 5, 6, 7]);
                        return [4 /*yield*/, _promise];
                    case 4:
                        data = _j.sent();
                        state.value = data;
                        isReady.value = true;
                        onSuccess(data);
                        return [3 /*break*/, 7];
                    case 5:
                        e_2 = _j.sent();
                        error.value = e_2;
                        onError(e_2);
                        if (throwError)
                            throw e_2;
                        return [3 /*break*/, 7];
                    case 6:
                        isLoading.value = false;
                        return [7 /*endfinally*/];
                    case 7: return [2 /*return*/, state.value];
                }
            });
        });
    }
    if (immediate)
        execute(delay);
    var shell = {
        state: state,
        isReady: isReady,
        isLoading: isLoading,
        error: error,
        execute: execute
    };
    function waitUntilIsLoaded() {
        return new Promise(function (resolve, reject) {
            until(isLoading).toBe(false).then(function () { return resolve(shell); }).catch(reject);
        });
    }
    return __assign(__assign({}, shell), { then: function (onFulfilled, onRejected) {
            return waitUntilIsLoaded().then(onFulfilled, onRejected);
        } });
}
var defaults = {
    array: function (v) { return JSON.stringify(v); },
    object: function (v) { return JSON.stringify(v); },
    set: function (v) { return JSON.stringify(Array.from(v)); },
    map: function (v) { return JSON.stringify(Object.fromEntries(v)); },
    null: function () { return ""; }
};
function getDefaultSerialization(target) {
    if (!target)
        return defaults.null;
    if (target instanceof Map)
        return defaults.map;
    else if (target instanceof Set)
        return defaults.set;
    else if (Array.isArray(target))
        return defaults.array;
    else
        return defaults.object;
}
function useBase64(target, options) {
    var base64 = ref("");
    var promise = ref();
    function execute() {
        if (!isClient)
            return;
        promise.value = new Promise(function (resolve, reject) {
            try {
                var _target = toValue(target);
                if (_target == null) {
                    resolve("");
                }
                else if (typeof _target === "string") {
                    resolve(blobToBase64(new Blob([_target], { type: "text/plain" })));
                }
                else if (_target instanceof Blob) {
                    resolve(blobToBase64(_target));
                }
                else if (_target instanceof ArrayBuffer) {
                    resolve(window.btoa(String.fromCharCode.apply(String, __spreadArray([], __read(new Uint8Array(_target)), false))));
                }
                else if (_target instanceof HTMLCanvasElement) {
                    resolve(_target.toDataURL(options == null ? void 0 : options.type, options == null ? void 0 : options.quality));
                }
                else if (_target instanceof HTMLImageElement) {
                    var img_1 = _target.cloneNode(false);
                    img_1.crossOrigin = "Anonymous";
                    imgLoaded(img_1).then(function () {
                        var canvas = document.createElement("canvas");
                        var ctx = canvas.getContext("2d");
                        canvas.width = img_1.width;
                        canvas.height = img_1.height;
                        ctx.drawImage(img_1, 0, 0, canvas.width, canvas.height);
                        resolve(canvas.toDataURL(options == null ? void 0 : options.type, options == null ? void 0 : options.quality));
                    }).catch(reject);
                }
                else if (typeof _target === "object") {
                    var _serializeFn = (options == null ? void 0 : options.serializer) || getDefaultSerialization(_target);
                    var serialized = _serializeFn(_target);
                    return resolve(blobToBase64(new Blob([serialized], { type: "application/json" })));
                }
                else {
                    reject(new Error("target is unsupported types"));
                }
            }
            catch (error) {
                reject(error);
            }
        });
        promise.value.then(function (res) { return base64.value = res; });
        return promise.value;
    }
    if (isRef(target) || typeof target === "function")
        watch(target, execute, { immediate: true });
    else
        execute();
    return {
        base64: base64,
        promise: promise,
        execute: execute
    };
}
function imgLoaded(img) {
    return new Promise(function (resolve, reject) {
        if (!img.complete) {
            img.onload = function () {
                resolve();
            };
            img.onerror = reject;
        }
        else {
            resolve();
        }
    });
}
function blobToBase64(blob) {
    return new Promise(function (resolve, reject) {
        var fr = new FileReader();
        fr.onload = function (e) {
            resolve(e.target.result);
        };
        fr.onerror = reject;
        fr.readAsDataURL(blob);
    });
}
function useBattery(options) {
    if (options === void 0) { options = {}; }
    var _j = options.navigator, navigator = _j === void 0 ? defaultNavigator : _j;
    var events = ["chargingchange", "chargingtimechange", "dischargingtimechange", "levelchange"];
    var isSupported = useSupported(function () { return navigator && "getBattery" in navigator && typeof navigator.getBattery === "function"; });
    var charging = ref(false);
    var chargingTime = ref(0);
    var dischargingTime = ref(0);
    var level = ref(1);
    var battery;
    function updateBatteryInfo() {
        charging.value = this.charging;
        chargingTime.value = this.chargingTime || 0;
        dischargingTime.value = this.dischargingTime || 0;
        level.value = this.level;
    }
    if (isSupported.value) {
        navigator.getBattery().then(function (_battery) {
            battery = _battery;
            updateBatteryInfo.call(battery);
            useEventListener(battery, events, updateBatteryInfo, { passive: true });
        });
    }
    return {
        isSupported: isSupported,
        charging: charging,
        chargingTime: chargingTime,
        dischargingTime: dischargingTime,
        level: level
    };
}
function useBluetooth(options) {
    var _j = (options || {}).acceptAllDevices, acceptAllDevices = _j === void 0 ? false : _j;
    var _k = options || {}, _l = _k.filters, filters = _l === void 0 ? void 0 : _l, _m = _k.optionalServices, optionalServices = _m === void 0 ? void 0 : _m, _o = _k.navigator, navigator = _o === void 0 ? defaultNavigator : _o;
    var isSupported = useSupported(function () { return navigator && "bluetooth" in navigator; });
    var device = shallowRef(void 0);
    var error = shallowRef(null);
    watch(device, function () {
        connectToBluetoothGATTServer();
    });
    function requestDevice() {
        return __awaiter(this, void 0, void 0, function () {
            var _j, err_1;
            return __generator(this, function (_k) {
                switch (_k.label) {
                    case 0:
                        if (!isSupported.value)
                            return [2 /*return*/];
                        error.value = null;
                        if (filters && filters.length > 0)
                            acceptAllDevices = false;
                        _k.label = 1;
                    case 1:
                        _k.trys.push([1, 3, , 4]);
                        _j = device;
                        return [4 /*yield*/, (navigator == null ? void 0 : navigator.bluetooth.requestDevice({
                                acceptAllDevices: acceptAllDevices,
                                filters: filters,
                                optionalServices: optionalServices
                            }))];
                    case 2:
                        _j.value = _k.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _k.sent();
                        error.value = err_1;
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    var server = ref();
    var isConnected = computed(function () {
        var _a;
        return ((_a = server.value) == null ? void 0 : _a.connected) || false;
    });
    function connectToBluetoothGATTServer() {
        return __awaiter(this, void 0, void 0, function () {
            var _j, err_2;
            return __generator(this, function (_k) {
                switch (_k.label) {
                    case 0:
                        error.value = null;
                        if (!(device.value && device.value.gatt)) return [3 /*break*/, 4];
                        device.value.addEventListener("gattserverdisconnected", function () {
                        });
                        _k.label = 1;
                    case 1:
                        _k.trys.push([1, 3, , 4]);
                        _j = server;
                        return [4 /*yield*/, device.value.gatt.connect()];
                    case 2:
                        _j.value = _k.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_2 = _k.sent();
                        error.value = err_2;
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    tryOnMounted(function () {
        var _a;
        if (device.value)
            (_a = device.value.gatt) == null ? void 0 : _a.connect();
    });
    tryOnScopeDispose(function () {
        var _a;
        if (device.value)
            (_a = device.value.gatt) == null ? void 0 : _a.disconnect();
    });
    return {
        isSupported: isSupported,
        isConnected: isConnected,
        // Device:
        device: device,
        requestDevice: requestDevice,
        // Server:
        server: server,
        // Errors:
        error: error
    };
}
function useMediaQuery(query, options) {
    if (options === void 0) { options = {}; }
    var _j = options.window, window = _j === void 0 ? defaultWindow : _j;
    var isSupported = useSupported(function () { return window && "matchMedia" in window && typeof window.matchMedia === "function"; });
    var mediaQuery;
    var matches = ref(false);
    var handler = function (event) {
        matches.value = event.matches;
    };
    var cleanup = function () {
        if (!mediaQuery)
            return;
        if ("removeEventListener" in mediaQuery)
            mediaQuery.removeEventListener("change", handler);
        else
            mediaQuery.removeListener(handler);
    };
    var stopWatch = watchEffect(function () {
        if (!isSupported.value)
            return;
        cleanup();
        mediaQuery = window.matchMedia(toValue(query));
        if ("addEventListener" in mediaQuery)
            mediaQuery.addEventListener("change", handler);
        else
            mediaQuery.addListener(handler);
        matches.value = mediaQuery.matches;
    });
    tryOnScopeDispose(function () {
        stopWatch();
        cleanup();
        mediaQuery = void 0;
    });
    return matches;
}
var breakpointsTailwind = {
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "2xl": 1536
};
var breakpointsBootstrapV5 = {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1400
};
var breakpointsVuetifyV2 = {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1264,
    xl: 1904
};
var breakpointsVuetifyV3 = {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920,
    xxl: 2560
};
var breakpointsVuetify = breakpointsVuetifyV2;
var breakpointsAntDesign = {
    xs: 480,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1600
};
var breakpointsQuasar = {
    xs: 0,
    sm: 600,
    md: 1024,
    lg: 1440,
    xl: 1920
};
var breakpointsSematic = {
    mobileS: 320,
    mobileM: 375,
    mobileL: 425,
    tablet: 768,
    laptop: 1024,
    laptopL: 1440,
    desktop4K: 2560
};
var breakpointsMasterCss = {
    "3xs": 360,
    "2xs": 480,
    "xs": 600,
    "sm": 768,
    "md": 1024,
    "lg": 1280,
    "xl": 1440,
    "2xl": 1600,
    "3xl": 1920,
    "4xl": 2560
};
var breakpointsPrimeFlex = {
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200
};
function useBreakpoints(breakpoints, options) {
    if (options === void 0) { options = {}; }
    function getValue(k, delta) {
        var v = toValue(breakpoints[toValue(k)]);
        if (delta != null)
            v = increaseWithUnit(v, delta);
        if (typeof v === "number")
            v = "".concat(v, "px");
        return v;
    }
    var _j = options.window, window = _j === void 0 ? defaultWindow : _j, _k = options.strategy, strategy = _k === void 0 ? "min-width" : _k;
    function match(query) {
        if (!window)
            return false;
        return window.matchMedia(query).matches;
    }
    var greaterOrEqual = function (k) {
        return useMediaQuery(function () { return "(min-width: ".concat(getValue(k), ")"); }, options);
    };
    var smallerOrEqual = function (k) {
        return useMediaQuery(function () { return "(max-width: ".concat(getValue(k), ")"); }, options);
    };
    var shortcutMethods = Object.keys(breakpoints).reduce(function (shortcuts, k) {
        Object.defineProperty(shortcuts, k, {
            get: function () { return strategy === "min-width" ? greaterOrEqual(k) : smallerOrEqual(k); },
            enumerable: true,
            configurable: true
        });
        return shortcuts;
    }, {});
    function current() {
        var points = Object.keys(breakpoints).map(function (i) { return [i, greaterOrEqual(i)]; });
        return computed(function () { return points.filter(function (_j) {
            var _k = __read(_j, 2), v = _k[1];
            return v.value;
        }).map(function (_j) {
            var _k = __read(_j, 1), k = _k[0];
            return k;
        }); });
    }
    return Object.assign(shortcutMethods, {
        greaterOrEqual: greaterOrEqual,
        smallerOrEqual: smallerOrEqual,
        greater: function (k) {
            return useMediaQuery(function () { return "(min-width: ".concat(getValue(k, 0.1), ")"); }, options);
        },
        smaller: function (k) {
            return useMediaQuery(function () { return "(max-width: ".concat(getValue(k, -0.1), ")"); }, options);
        },
        between: function (a, b) {
            return useMediaQuery(function () { return "(min-width: ".concat(getValue(a), ") and (max-width: ").concat(getValue(b, -0.1), ")"); }, options);
        },
        isGreater: function (k) {
            return match("(min-width: ".concat(getValue(k, 0.1), ")"));
        },
        isGreaterOrEqual: function (k) {
            return match("(min-width: ".concat(getValue(k), ")"));
        },
        isSmaller: function (k) {
            return match("(max-width: ".concat(getValue(k, -0.1), ")"));
        },
        isSmallerOrEqual: function (k) {
            return match("(max-width: ".concat(getValue(k), ")"));
        },
        isInBetween: function (a, b) {
            return match("(min-width: ".concat(getValue(a), ") and (max-width: ").concat(getValue(b, -0.1), ")"));
        },
        current: current,
        active: function () {
            var bps = current();
            return computed(function () { return bps.value.length === 0 ? "" : bps.value.at(-1); });
        }
    });
}
function useBroadcastChannel(options) {
    var name = options.name, _j = options.window, window = _j === void 0 ? defaultWindow : _j;
    var isSupported = useSupported(function () { return window && "BroadcastChannel" in window; });
    var isClosed = ref(false);
    var channel = ref();
    var data = ref();
    var error = shallowRef(null);
    var post = function (data2) {
        if (channel.value)
            channel.value.postMessage(data2);
    };
    var close = function () {
        if (channel.value)
            channel.value.close();
        isClosed.value = true;
    };
    if (isSupported.value) {
        tryOnMounted(function () {
            error.value = null;
            channel.value = new BroadcastChannel(name);
            channel.value.addEventListener("message", function (e) {
                data.value = e.data;
            }, { passive: true });
            channel.value.addEventListener("messageerror", function (e) {
                error.value = e;
            }, { passive: true });
            channel.value.addEventListener("close", function () {
                isClosed.value = true;
            });
        });
    }
    tryOnScopeDispose(function () {
        close();
    });
    return {
        isSupported: isSupported,
        channel: channel,
        data: data,
        post: post,
        close: close,
        error: error,
        isClosed: isClosed
    };
}
var WRITABLE_PROPERTIES = [
    "hash",
    "host",
    "hostname",
    "href",
    "pathname",
    "port",
    "protocol",
    "search"
];
function useBrowserLocation(options) {
    var e_3, _j;
    if (options === void 0) { options = {}; }
    var _k = options.window, window = _k === void 0 ? defaultWindow : _k;
    var refs = Object.fromEntries(WRITABLE_PROPERTIES.map(function (key) { return [key, ref()]; }));
    var _loop_1 = function (key, ref2) {
        watch(ref2, function (value) {
            if (!(window == null ? void 0 : window.location) || window.location[key] === value)
                return;
            window.location[key] = value;
        });
    };
    try {
        for (var _l = __values(objectEntries(refs)), _m = _l.next(); !_m.done; _m = _l.next()) {
            var _o = __read(_m.value, 2), key = _o[0], ref2 = _o[1];
            _loop_1(key, ref2);
        }
    }
    catch (e_3_1) { e_3 = { error: e_3_1 }; }
    finally {
        try {
            if (_m && !_m.done && (_j = _l.return)) _j.call(_l);
        }
        finally { if (e_3) throw e_3.error; }
    }
    var buildState = function (trigger) {
        var e_4, _j;
        var _a;
        var _k = (window == null ? void 0 : window.history) || {}, state2 = _k.state, length = _k.length;
        var origin = ((window == null ? void 0 : window.location) || {}).origin;
        try {
            for (var WRITABLE_PROPERTIES_1 = __values(WRITABLE_PROPERTIES), WRITABLE_PROPERTIES_1_1 = WRITABLE_PROPERTIES_1.next(); !WRITABLE_PROPERTIES_1_1.done; WRITABLE_PROPERTIES_1_1 = WRITABLE_PROPERTIES_1.next()) {
                var key = WRITABLE_PROPERTIES_1_1.value;
                refs[key].value = (_a = window == null ? void 0 : window.location) == null ? void 0 : _a[key];
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (WRITABLE_PROPERTIES_1_1 && !WRITABLE_PROPERTIES_1_1.done && (_j = WRITABLE_PROPERTIES_1.return)) _j.call(WRITABLE_PROPERTIES_1);
            }
            finally { if (e_4) throw e_4.error; }
        }
        return reactive(__assign({ trigger: trigger, state: state2, length: length, origin: origin }, refs));
    };
    var state = ref(buildState("load"));
    if (window) {
        useEventListener(window, "popstate", function () { return state.value = buildState("popstate"); }, { passive: true });
        useEventListener(window, "hashchange", function () { return state.value = buildState("hashchange"); }, { passive: true });
    }
    return state;
}
function useCached(refValue, comparator, watchOptions) {
    if (comparator === void 0) { comparator = function (a, b) { return a === b; }; }
    var cachedValue = ref(refValue.value);
    watch(function () { return refValue.value; }, function (value) {
        if (!comparator(value, cachedValue.value))
            cachedValue.value = value;
    }, watchOptions);
    return cachedValue;
}
function usePermission(permissionDesc, options) {
    var _this = this;
    if (options === void 0) { options = {}; }
    var _j = options.controls, controls = _j === void 0 ? false : _j, _k = options.navigator, navigator = _k === void 0 ? defaultNavigator : _k;
    var isSupported = useSupported(function () { return navigator && "permissions" in navigator; });
    var permissionStatus;
    var desc = typeof permissionDesc === "string" ? { name: permissionDesc } : permissionDesc;
    var state = ref();
    var onChange = function () {
        if (permissionStatus)
            state.value = permissionStatus.state;
    };
    var query = createSingletonPromise(function () { return __awaiter(_this, void 0, void 0, function () {
        var e_5;
        return __generator(this, function (_j) {
            switch (_j.label) {
                case 0:
                    if (!isSupported.value)
                        return [2 /*return*/];
                    if (!!permissionStatus) return [3 /*break*/, 4];
                    _j.label = 1;
                case 1:
                    _j.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, navigator.permissions.query(desc)];
                case 2:
                    permissionStatus = _j.sent();
                    useEventListener(permissionStatus, "change", onChange);
                    onChange();
                    return [3 /*break*/, 4];
                case 3:
                    e_5 = _j.sent();
                    state.value = "prompt";
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/, permissionStatus];
            }
        });
    }); });
    query();
    if (controls) {
        return {
            state: state,
            isSupported: isSupported,
            query: query
        };
    }
    else {
        return state;
    }
}
function useClipboard(options) {
    if (options === void 0) { options = {}; }
    var _j = options.navigator, navigator = _j === void 0 ? defaultNavigator : _j, _k = options.read, read = _k === void 0 ? false : _k, source = options.source, _l = options.copiedDuring, copiedDuring = _l === void 0 ? 1500 : _l, _m = options.legacy, legacy = _m === void 0 ? false : _m;
    var isClipboardApiSupported = useSupported(function () { return navigator && "clipboard" in navigator; });
    var permissionRead = usePermission("clipboard-read");
    var permissionWrite = usePermission("clipboard-write");
    var isSupported = computed(function () { return isClipboardApiSupported.value || legacy; });
    var text = ref("");
    var copied = ref(false);
    var timeout = useTimeoutFn(function () { return copied.value = false; }, copiedDuring);
    function updateText() {
        if (isClipboardApiSupported.value && isAllowed(permissionRead.value)) {
            navigator.clipboard.readText().then(function (value) {
                text.value = value;
            });
        }
        else {
            text.value = legacyRead();
        }
    }
    if (isSupported.value && read)
        useEventListener(["copy", "cut"], updateText);
    function copy() {
        return __awaiter(this, arguments, void 0, function (value) {
            if (value === void 0) { value = toValue(source); }
            return __generator(this, function (_j) {
                switch (_j.label) {
                    case 0:
                        if (!(isSupported.value && value != null)) return [3 /*break*/, 4];
                        if (!(isClipboardApiSupported.value && isAllowed(permissionWrite.value))) return [3 /*break*/, 2];
                        return [4 /*yield*/, navigator.clipboard.writeText(value)];
                    case 1:
                        _j.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        legacyCopy(value);
                        _j.label = 3;
                    case 3:
                        text.value = value;
                        copied.value = true;
                        timeout.start();
                        _j.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    function legacyCopy(value) {
        var ta = document.createElement("textarea");
        ta.value = value != null ? value : "";
        ta.style.position = "absolute";
        ta.style.opacity = "0";
        document.body.appendChild(ta);
        ta.select();
        document.execCommand("copy");
        ta.remove();
    }
    function legacyRead() {
        var _a, _b, _c;
        return (_c = (_b = (_a = document == null ? void 0 : document.getSelection) == null ? void 0 : _a.call(document)) == null ? void 0 : _b.toString()) != null ? _c : "";
    }
    function isAllowed(status) {
        return status === "granted" || status === "prompt";
    }
    return {
        isSupported: isSupported,
        text: text,
        copied: copied,
        copy: copy
    };
}
function useClipboardItems(options) {
    if (options === void 0) { options = {}; }
    var _j = options.navigator, navigator = _j === void 0 ? defaultNavigator : _j, _k = options.read, read = _k === void 0 ? false : _k, source = options.source, _l = options.copiedDuring, copiedDuring = _l === void 0 ? 1500 : _l;
    var isSupported = useSupported(function () { return navigator && "clipboard" in navigator; });
    var content = ref([]);
    var copied = ref(false);
    var timeout = useTimeoutFn(function () { return copied.value = false; }, copiedDuring);
    function updateContent() {
        if (isSupported.value) {
            navigator.clipboard.read().then(function (items) {
                content.value = items;
            });
        }
    }
    if (isSupported.value && read)
        useEventListener(["copy", "cut"], updateContent);
    function copy() {
        return __awaiter(this, arguments, void 0, function (value) {
            if (value === void 0) { value = toValue(source); }
            return __generator(this, function (_j) {
                switch (_j.label) {
                    case 0:
                        if (!(isSupported.value && value != null)) return [3 /*break*/, 2];
                        return [4 /*yield*/, navigator.clipboard.write(value)];
                    case 1:
                        _j.sent();
                        content.value = value;
                        copied.value = true;
                        timeout.start();
                        _j.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    }
    return {
        isSupported: isSupported,
        content: content,
        copied: copied,
        copy: copy
    };
}
function cloneFnJSON(source) {
    return JSON.parse(JSON.stringify(source));
}
function useCloned(source, options) {
    if (options === void 0) { options = {}; }
    var cloned = ref({});
    var manual = options.manual, _j = options.clone, clone = _j === void 0 ? cloneFnJSON : _j, 
    // watch options
    _k = options.deep, 
    // watch options
    deep = _k === void 0 ? true : _k, _l = options.immediate, immediate = _l === void 0 ? true : _l;
    function sync() {
        cloned.value = clone(toValue(source));
    }
    if (!manual && (isRef(source) || typeof source === "function")) {
        watch(source, sync, __assign(__assign({}, options), { deep: deep, immediate: immediate }));
    }
    else {
        sync();
    }
    return { cloned: cloned, sync: sync };
}
var _global = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
var globalKey = "__vueuse_ssr_handlers__";
var handlers = /* @__PURE__ */ getHandlers();
function getHandlers() {
    if (!(globalKey in _global))
        _global[globalKey] = _global[globalKey] || {};
    return _global[globalKey];
}
function getSSRHandler(key, fallback) {
    return handlers[key] || fallback;
}
function setSSRHandler(key, fn) {
    handlers[key] = fn;
}
function guessSerializerType(rawInit) {
    return rawInit == null ? "any" : rawInit instanceof Set ? "set" : rawInit instanceof Map ? "map" : rawInit instanceof Date ? "date" : typeof rawInit === "boolean" ? "boolean" : typeof rawInit === "string" ? "string" : typeof rawInit === "object" ? "object" : !Number.isNaN(rawInit) ? "number" : "any";
}
var StorageSerializers = {
    boolean: {
        read: function (v) { return v === "true"; },
        write: function (v) { return String(v); }
    },
    object: {
        read: function (v) { return JSON.parse(v); },
        write: function (v) { return JSON.stringify(v); }
    },
    number: {
        read: function (v) { return Number.parseFloat(v); },
        write: function (v) { return String(v); }
    },
    any: {
        read: function (v) { return v; },
        write: function (v) { return String(v); }
    },
    string: {
        read: function (v) { return v; },
        write: function (v) { return String(v); }
    },
    map: {
        read: function (v) { return new Map(JSON.parse(v)); },
        write: function (v) { return JSON.stringify(Array.from(v.entries())); }
    },
    set: {
        read: function (v) { return new Set(JSON.parse(v)); },
        write: function (v) { return JSON.stringify(Array.from(v)); }
    },
    date: {
        read: function (v) { return new Date(v); },
        write: function (v) { return v.toISOString(); }
    }
};
var customStorageEventName = "vueuse-storage";
function useStorage(key, defaults, storage, options) {
    if (options === void 0) { options = {}; }
    var _a;
    var _j = options.flush, flush = _j === void 0 ? "pre" : _j, _k = options.deep, deep = _k === void 0 ? true : _k, _l = options.listenToStorageChanges, listenToStorageChanges = _l === void 0 ? true : _l, _m = options.writeDefaults, writeDefaults = _m === void 0 ? true : _m, _o = options.mergeDefaults, mergeDefaults = _o === void 0 ? false : _o, shallow = options.shallow, _p = options.window, window = _p === void 0 ? defaultWindow : _p, eventFilter = options.eventFilter, _q = options.onError, onError = _q === void 0 ? function (e) {
        console.error(e);
    } : _q, initOnMounted = options.initOnMounted;
    var data = (shallow ? shallowRef : ref)(typeof defaults === "function" ? defaults() : defaults);
    if (!storage) {
        try {
            storage = getSSRHandler("getDefaultStorage", function () {
                var _a2;
                return (_a2 = defaultWindow) == null ? void 0 : _a2.localStorage;
            })();
        }
        catch (e) {
            onError(e);
        }
    }
    if (!storage)
        return data;
    var rawInit = toValue(defaults);
    var type = guessSerializerType(rawInit);
    var serializer = (_a = options.serializer) != null ? _a : StorageSerializers[type];
    var _r = pausableWatch(data, function () { return write(data.value); }, { flush: flush, deep: deep, eventFilter: eventFilter }), pauseWatch = _r.pause, resumeWatch = _r.resume;
    if (window && listenToStorageChanges) {
        tryOnMounted(function () {
            useEventListener(window, "storage", update);
            useEventListener(window, customStorageEventName, updateFromCustomEvent);
            if (initOnMounted)
                update();
        });
    }
    if (!initOnMounted)
        update();
    function dispatchWriteEvent(oldValue, newValue) {
        if (window) {
            window.dispatchEvent(new CustomEvent(customStorageEventName, {
                detail: {
                    key: key,
                    oldValue: oldValue,
                    newValue: newValue,
                    storageArea: storage
                }
            }));
        }
    }
    function write(v) {
        try {
            var oldValue = storage.getItem(key);
            if (v == null) {
                dispatchWriteEvent(oldValue, null);
                storage.removeItem(key);
            }
            else {
                var serialized = serializer.write(v);
                if (oldValue !== serialized) {
                    storage.setItem(key, serialized);
                    dispatchWriteEvent(oldValue, serialized);
                }
            }
        }
        catch (e) {
            onError(e);
        }
    }
    function read(event) {
        var rawValue = event ? event.newValue : storage.getItem(key);
        if (rawValue == null) {
            if (writeDefaults && rawInit != null)
                storage.setItem(key, serializer.write(rawInit));
            return rawInit;
        }
        else if (!event && mergeDefaults) {
            var value = serializer.read(rawValue);
            if (typeof mergeDefaults === "function")
                return mergeDefaults(value, rawInit);
            else if (type === "object" && !Array.isArray(value))
                return __assign(__assign({}, rawInit), value);
            return value;
        }
        else if (typeof rawValue !== "string") {
            return rawValue;
        }
        else {
            return serializer.read(rawValue);
        }
    }
    function update(event) {
        if (event && event.storageArea !== storage)
            return;
        if (event && event.key == null) {
            data.value = rawInit;
            return;
        }
        if (event && event.key !== key)
            return;
        pauseWatch();
        try {
            if ((event == null ? void 0 : event.newValue) !== serializer.write(data.value))
                data.value = read(event);
        }
        catch (e) {
            onError(e);
        }
        finally {
            if (event)
                nextTick(resumeWatch);
            else
                resumeWatch();
        }
    }
    function updateFromCustomEvent(event) {
        update(event.detail);
    }
    return data;
}
function usePreferredDark(options) {
    return useMediaQuery("(prefers-color-scheme: dark)", options);
}
function useColorMode(options) {
    if (options === void 0) { options = {}; }
    var _j = options.selector, selector = _j === void 0 ? "html" : _j, _k = options.attribute, attribute = _k === void 0 ? "class" : _k, _l = options.initialValue, initialValue = _l === void 0 ? "auto" : _l, _m = options.window, window = _m === void 0 ? defaultWindow : _m, storage = options.storage, _o = options.storageKey, storageKey = _o === void 0 ? "vueuse-color-scheme" : _o, _p = options.listenToStorageChanges, listenToStorageChanges = _p === void 0 ? true : _p, storageRef = options.storageRef, emitAuto = options.emitAuto, _q = options.disableTransition, disableTransition = _q === void 0 ? true : _q;
    var modes = __assign({ auto: "", light: "light", dark: "dark" }, options.modes || {});
    var preferredDark = usePreferredDark({ window: window });
    var system = computed(function () { return preferredDark.value ? "dark" : "light"; });
    var store = storageRef || (storageKey == null ? toRef(initialValue) : useStorage(storageKey, initialValue, storage, { window: window, listenToStorageChanges: listenToStorageChanges }));
    var state = computed(function () { return store.value === "auto" ? system.value : store.value; });
    var updateHTMLAttrs = getSSRHandler("updateHTMLAttrs", function (selector2, attribute2, value) {
        var el = typeof selector2 === "string" ? window == null ? void 0 : window.document.querySelector(selector2) : unrefElement(selector2);
        if (!el)
            return;
        var style;
        if (disableTransition) {
            style = window.document.createElement("style");
            var styleString = "*,*::before,*::after{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}";
            style.appendChild(document.createTextNode(styleString));
            window.document.head.appendChild(style);
        }
        if (attribute2 === "class") {
            var current_1 = value.split(/\s/g);
            Object.values(modes).flatMap(function (i) { return (i || "").split(/\s/g); }).filter(Boolean).forEach(function (v) {
                if (current_1.includes(v))
                    el.classList.add(v);
                else
                    el.classList.remove(v);
            });
        }
        else {
            el.setAttribute(attribute2, value);
        }
        if (disableTransition) {
            window.getComputedStyle(style).opacity;
            document.head.removeChild(style);
        }
    });
    function defaultOnChanged(mode) {
        var _a;
        updateHTMLAttrs(selector, attribute, (_a = modes[mode]) != null ? _a : mode);
    }
    function onChanged(mode) {
        if (options.onChanged)
            options.onChanged(mode, defaultOnChanged);
        else
            defaultOnChanged(mode);
    }
    watch(state, onChanged, { flush: "post", immediate: true });
    tryOnMounted(function () { return onChanged(state.value); });
    var auto = computed({
        get: function () {
            return emitAuto ? store.value : state.value;
        },
        set: function (v) {
            store.value = v;
        }
    });
    try {
        return Object.assign(auto, { store: store, system: system, state: state });
    }
    catch (e) {
        return auto;
    }
}
function useConfirmDialog(revealed) {
    if (revealed === void 0) { revealed = ref(false); }
    var confirmHook = createEventHook();
    var cancelHook = createEventHook();
    var revealHook = createEventHook();
    var _resolve = noop;
    var reveal = function (data) {
        revealHook.trigger(data);
        revealed.value = true;
        return new Promise(function (resolve) {
            _resolve = resolve;
        });
    };
    var confirm = function (data) {
        revealed.value = false;
        confirmHook.trigger(data);
        _resolve({ data: data, isCanceled: false });
    };
    var cancel = function (data) {
        revealed.value = false;
        cancelHook.trigger(data);
        _resolve({ data: data, isCanceled: true });
    };
    return {
        isRevealed: computed(function () { return revealed.value; }),
        reveal: reveal,
        confirm: confirm,
        cancel: cancel,
        onReveal: revealHook.on,
        onConfirm: confirmHook.on,
        onCancel: cancelHook.on
    };
}
function useCssVar(prop, target, options) {
    if (options === void 0) { options = {}; }
    var _j = options.window, window = _j === void 0 ? defaultWindow : _j, _k = options.initialValue, initialValue = _k === void 0 ? "" : _k, _l = options.observe, observe = _l === void 0 ? false : _l;
    var variable = ref(initialValue);
    var elRef = computed(function () {
        var _a;
        return unrefElement(target) || ((_a = window == null ? void 0 : window.document) == null ? void 0 : _a.documentElement);
    });
    function updateCssVar() {
        var _a;
        var key = toValue(prop);
        var el = toValue(elRef);
        if (el && window) {
            var value = (_a = window.getComputedStyle(el).getPropertyValue(key)) == null ? void 0 : _a.trim();
            variable.value = value || initialValue;
        }
    }
    if (observe) {
        useMutationObserver(elRef, updateCssVar, {
            attributeFilter: ["style", "class"],
            window: window
        });
    }
    watch([elRef, function () { return toValue(prop); }], updateCssVar, { immediate: true });
    watch(variable, function (val) {
        var _a;
        if ((_a = elRef.value) == null ? void 0 : _a.style)
            elRef.value.style.setProperty(toValue(prop), val);
    });
    return variable;
}
function useCurrentElement(rootComponent) {
    var vm = getCurrentInstance();
    var currentElement = computedWithControl(function () { return null; }, function () { return rootComponent ? unrefElement(rootComponent) : vm.proxy.$el; });
    onUpdated(currentElement.trigger);
    onMounted(currentElement.trigger);
    return currentElement;
}
function useCycleList(list, options) {
    var state = shallowRef(getInitialValue());
    var listRef = toRef(list);
    var index = computed({
        get: function () {
            var _a;
            var targetList = listRef.value;
            var index2 = (options == null ? void 0 : options.getIndexOf) ? options.getIndexOf(state.value, targetList) : targetList.indexOf(state.value);
            if (index2 < 0)
                index2 = (_a = options == null ? void 0 : options.fallbackIndex) != null ? _a : 0;
            return index2;
        },
        set: function (v) {
            set(v);
        }
    });
    function set(i) {
        var targetList = listRef.value;
        var length = targetList.length;
        var index2 = (i % length + length) % length;
        var value = targetList[index2];
        state.value = value;
        return value;
    }
    function shift(delta) {
        if (delta === void 0) { delta = 1; }
        return set(index.value + delta);
    }
    function next(n) {
        if (n === void 0) { n = 1; }
        return shift(n);
    }
    function prev(n) {
        if (n === void 0) { n = 1; }
        return shift(-n);
    }
    function getInitialValue() {
        var _a, _b;
        return (_b = toValue((_a = options == null ? void 0 : options.initialValue) != null ? _a : toValue(list)[0])) != null ? _b : void 0;
    }
    watch(listRef, function () { return set(index.value); });
    return {
        state: state,
        index: index,
        next: next,
        prev: prev,
        go: set
    };
}
function useDark(options) {
    if (options === void 0) { options = {}; }
    var _j = options.valueDark, valueDark = _j === void 0 ? "dark" : _j, _k = options.valueLight, valueLight = _k === void 0 ? "" : _k, _l = options.window, window = _l === void 0 ? defaultWindow : _l;
    var mode = useColorMode(__assign(__assign({}, options), { onChanged: function (mode2, defaultHandler) {
            var _a;
            if (options.onChanged)
                (_a = options.onChanged) == null ? void 0 : _a.call(options, mode2 === "dark", defaultHandler, mode2);
            else
                defaultHandler(mode2);
        }, modes: {
            dark: valueDark,
            light: valueLight
        } }));
    var system = computed(function () {
        if (mode.system) {
            return mode.system.value;
        }
        else {
            var preferredDark = usePreferredDark({ window: window });
            return preferredDark.value ? "dark" : "light";
        }
    });
    var isDark = computed({
        get: function () {
            return mode.value === "dark";
        },
        set: function (v) {
            var modeVal = v ? "dark" : "light";
            if (system.value === modeVal)
                mode.value = "auto";
            else
                mode.value = modeVal;
        }
    });
    return isDark;
}
function fnBypass(v) {
    return v;
}
function fnSetSource(source, value) {
    return source.value = value;
}
function defaultDump(clone) {
    return clone ? typeof clone === "function" ? clone : cloneFnJSON : fnBypass;
}
function defaultParse(clone) {
    return clone ? typeof clone === "function" ? clone : cloneFnJSON : fnBypass;
}
function useManualRefHistory(source, options) {
    if (options === void 0) { options = {}; }
    var _j = options.clone, clone = _j === void 0 ? false : _j, _k = options.dump, dump = _k === void 0 ? defaultDump(clone) : _k, _l = options.parse, parse = _l === void 0 ? defaultParse(clone) : _l, _m = options.setSource, setSource = _m === void 0 ? fnSetSource : _m;
    function _createHistoryRecord() {
        return markRaw({
            snapshot: dump(source.value),
            timestamp: timestamp()
        });
    }
    var last = ref(_createHistoryRecord());
    var undoStack = ref([]);
    var redoStack = ref([]);
    var _setSource = function (record) {
        setSource(source, parse(record.snapshot));
        last.value = record;
    };
    var commit = function () {
        undoStack.value.unshift(last.value);
        last.value = _createHistoryRecord();
        if (options.capacity && undoStack.value.length > options.capacity)
            undoStack.value.splice(options.capacity, Number.POSITIVE_INFINITY);
        if (redoStack.value.length)
            redoStack.value.splice(0, redoStack.value.length);
    };
    var clear = function () {
        undoStack.value.splice(0, undoStack.value.length);
        redoStack.value.splice(0, redoStack.value.length);
    };
    var undo = function () {
        var state = undoStack.value.shift();
        if (state) {
            redoStack.value.unshift(last.value);
            _setSource(state);
        }
    };
    var redo = function () {
        var state = redoStack.value.shift();
        if (state) {
            undoStack.value.unshift(last.value);
            _setSource(state);
        }
    };
    var reset = function () {
        _setSource(last.value);
    };
    var history = computed(function () { return __spreadArray([last.value], __read(undoStack.value), false); });
    var canUndo = computed(function () { return undoStack.value.length > 0; });
    var canRedo = computed(function () { return redoStack.value.length > 0; });
    return {
        source: source,
        undoStack: undoStack,
        redoStack: redoStack,
        last: last,
        history: history,
        canUndo: canUndo,
        canRedo: canRedo,
        clear: clear,
        commit: commit,
        reset: reset,
        undo: undo,
        redo: redo
    };
}
function useRefHistory(source, options) {
    if (options === void 0) { options = {}; }
    var _j = options.deep, deep = _j === void 0 ? false : _j, _k = options.flush, flush = _k === void 0 ? "pre" : _k, eventFilter = options.eventFilter;
    var _l = pausableFilter(eventFilter), composedFilter = _l.eventFilter, pause = _l.pause, resumeTracking = _l.resume, isTracking = _l.isActive;
    var _m = watchIgnorable(source, commit, { deep: deep, flush: flush, eventFilter: composedFilter }), ignoreUpdates = _m.ignoreUpdates, ignorePrevAsyncUpdates = _m.ignorePrevAsyncUpdates, stop = _m.stop;
    function setSource(source2, value) {
        ignorePrevAsyncUpdates();
        ignoreUpdates(function () {
            source2.value = value;
        });
    }
    var manualHistory = useManualRefHistory(source, __assign(__assign({}, options), { clone: options.clone || deep, setSource: setSource }));
    var clear = manualHistory.clear, manualCommit = manualHistory.commit;
    function commit() {
        ignorePrevAsyncUpdates();
        manualCommit();
    }
    function resume(commitNow) {
        resumeTracking();
        if (commitNow)
            commit();
    }
    function batch(fn) {
        var canceled = false;
        var cancel = function () { return canceled = true; };
        ignoreUpdates(function () {
            fn(cancel);
        });
        if (!canceled)
            commit();
    }
    function dispose() {
        stop();
        clear();
    }
    return __assign(__assign({}, manualHistory), { isTracking: isTracking, pause: pause, resume: resume, commit: commit, batch: batch, dispose: dispose });
}
function useDebouncedRefHistory(source, options) {
    if (options === void 0) { options = {}; }
    var filter = options.debounce ? debounceFilter(options.debounce) : void 0;
    var history = useRefHistory(source, __assign(__assign({}, options), { eventFilter: filter }));
    return __assign({}, history);
}
function useDeviceMotion(options) {
    if (options === void 0) { options = {}; }
    var _j = options.window, window = _j === void 0 ? defaultWindow : _j, _k = options.eventFilter, eventFilter = _k === void 0 ? bypassFilter : _k;
    var acceleration = ref({ x: null, y: null, z: null });
    var rotationRate = ref({ alpha: null, beta: null, gamma: null });
    var interval = ref(0);
    var accelerationIncludingGravity = ref({
        x: null,
        y: null,
        z: null
    });
    if (window) {
        var onDeviceMotion = createFilterWrapper(eventFilter, function (event) {
            acceleration.value = event.acceleration;
            accelerationIncludingGravity.value = event.accelerationIncludingGravity;
            rotationRate.value = event.rotationRate;
            interval.value = event.interval;
        });
        useEventListener(window, "devicemotion", onDeviceMotion);
    }
    return {
        acceleration: acceleration,
        accelerationIncludingGravity: accelerationIncludingGravity,
        rotationRate: rotationRate,
        interval: interval
    };
}
function useDeviceOrientation(options) {
    if (options === void 0) { options = {}; }
    var _j = options.window, window = _j === void 0 ? defaultWindow : _j;
    var isSupported = useSupported(function () { return window && "DeviceOrientationEvent" in window; });
    var isAbsolute = ref(false);
    var alpha = ref(null);
    var beta = ref(null);
    var gamma = ref(null);
    if (window && isSupported.value) {
        useEventListener(window, "deviceorientation", function (event) {
            isAbsolute.value = event.absolute;
            alpha.value = event.alpha;
            beta.value = event.beta;
            gamma.value = event.gamma;
        });
    }
    return {
        isSupported: isSupported,
        isAbsolute: isAbsolute,
        alpha: alpha,
        beta: beta,
        gamma: gamma
    };
}
function useDevicePixelRatio(options) {
    if (options === void 0) { options = {}; }
    var _j = options.window, window = _j === void 0 ? defaultWindow : _j;
    var pixelRatio = ref(1);
    if (window) {
        var observe2_1 = function () {
            pixelRatio.value = window.devicePixelRatio;
            cleanup2_1();
            media_1 = window.matchMedia("(resolution: ".concat(pixelRatio.value, "dppx)"));
            media_1.addEventListener("change", observe2_1, { once: true });
        }, cleanup2_1 = function () {
            media_1 == null ? void 0 : media_1.removeEventListener("change", observe2_1);
        };
        var media_1;
        observe2_1();
        tryOnScopeDispose(cleanup2_1);
    }
    return { pixelRatio: pixelRatio };
}
function useDevicesList(options) {
    if (options === void 0) { options = {}; }
    var _j = options.navigator, navigator = _j === void 0 ? defaultNavigator : _j, _k = options.requestPermissions, requestPermissions = _k === void 0 ? false : _k, _l = options.constraints, constraints = _l === void 0 ? { audio: true, video: true } : _l, onUpdated = options.onUpdated;
    var devices = ref([]);
    var videoInputs = computed(function () { return devices.value.filter(function (i) { return i.kind === "videoinput"; }); });
    var audioInputs = computed(function () { return devices.value.filter(function (i) { return i.kind === "audioinput"; }); });
    var audioOutputs = computed(function () { return devices.value.filter(function (i) { return i.kind === "audiooutput"; }); });
    var isSupported = useSupported(function () { return navigator && navigator.mediaDevices && navigator.mediaDevices.enumerateDevices; });
    var permissionGranted = ref(false);
    var stream;
    function update() {
        return __awaiter(this, void 0, void 0, function () {
            var _j;
            return __generator(this, function (_k) {
                switch (_k.label) {
                    case 0:
                        if (!isSupported.value)
                            return [2 /*return*/];
                        _j = devices;
                        return [4 /*yield*/, navigator.mediaDevices.enumerateDevices()];
                    case 1:
                        _j.value = _k.sent();
                        onUpdated == null ? void 0 : onUpdated(devices.value);
                        if (stream) {
                            stream.getTracks().forEach(function (t) { return t.stop(); });
                            stream = null;
                        }
                        return [2 /*return*/];
                }
            });
        });
    }
    function ensurePermissions() {
        return __awaiter(this, void 0, void 0, function () {
            var _j, state, query;
            return __generator(this, function (_k) {
                switch (_k.label) {
                    case 0:
                        if (!isSupported.value)
                            return [2 /*return*/, false];
                        if (permissionGranted.value)
                            return [2 /*return*/, true];
                        _j = usePermission("camera", { controls: true }), state = _j.state, query = _j.query;
                        return [4 /*yield*/, query()];
                    case 1:
                        _k.sent();
                        if (!(state.value !== "granted")) return [3 /*break*/, 3];
                        return [4 /*yield*/, navigator.mediaDevices.getUserMedia(constraints)];
                    case 2:
                        stream = _k.sent();
                        update();
                        permissionGranted.value = true;
                        return [3 /*break*/, 4];
                    case 3:
                        permissionGranted.value = true;
                        _k.label = 4;
                    case 4: return [2 /*return*/, permissionGranted.value];
                }
            });
        });
    }
    if (isSupported.value) {
        if (requestPermissions)
            ensurePermissions();
        useEventListener(navigator.mediaDevices, "devicechange", update);
        update();
    }
    return {
        devices: devices,
        ensurePermissions: ensurePermissions,
        permissionGranted: permissionGranted,
        videoInputs: videoInputs,
        audioInputs: audioInputs,
        audioOutputs: audioOutputs,
        isSupported: isSupported
    };
}
function useDisplayMedia(options) {
    if (options === void 0) { options = {}; }
    var _a;
    var enabled = ref((_a = options.enabled) != null ? _a : false);
    var video = options.video;
    var audio = options.audio;
    var _j = options.navigator, navigator = _j === void 0 ? defaultNavigator : _j;
    var isSupported = useSupported(function () {
        var _a2;
        return (_a2 = navigator == null ? void 0 : navigator.mediaDevices) == null ? void 0 : _a2.getDisplayMedia;
    });
    var constraint = { audio: audio, video: video };
    var stream = shallowRef();
    function _start() {
        return __awaiter(this, void 0, void 0, function () {
            var _a2, _j;
            return __generator(this, function (_k) {
                switch (_k.label) {
                    case 0:
                        if (!isSupported.value || stream.value)
                            return [2 /*return*/];
                        _j = stream;
                        return [4 /*yield*/, navigator.mediaDevices.getDisplayMedia(constraint)];
                    case 1:
                        _j.value = _k.sent();
                        (_a2 = stream.value) == null ? void 0 : _a2.getTracks().forEach(function (t) { return t.addEventListener("ended", stop); });
                        return [2 /*return*/, stream.value];
                }
            });
        });
    }
    function _stop() {
        return __awaiter(this, void 0, void 0, function () {
            var _a2;
            return __generator(this, function (_j) {
                (_a2 = stream.value) == null ? void 0 : _a2.getTracks().forEach(function (t) { return t.stop(); });
                stream.value = void 0;
                return [2 /*return*/];
            });
        });
    }
    function stop() {
        _stop();
        enabled.value = false;
    }
    function start() {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_j) {
                switch (_j.label) {
                    case 0: return [4 /*yield*/, _start()];
                    case 1:
                        _j.sent();
                        if (stream.value)
                            enabled.value = true;
                        return [2 /*return*/, stream.value];
                }
            });
        });
    }
    watch(enabled, function (v) {
        if (v)
            _start();
        else
            _stop();
    }, { immediate: true });
    return {
        isSupported: isSupported,
        stream: stream,
        start: start,
        stop: stop,
        enabled: enabled
    };
}
function useDocumentVisibility(options) {
    if (options === void 0) { options = {}; }
    var _j = options.document, document = _j === void 0 ? defaultDocument : _j;
    if (!document)
        return ref("visible");
    var visibility = ref(document.visibilityState);
    useEventListener(document, "visibilitychange", function () {
        visibility.value = document.visibilityState;
    });
    return visibility;
}
function useDraggable(target, options) {
    if (options === void 0) { options = {}; }
    var _a, _b;
    var pointerTypes = options.pointerTypes, preventDefault = options.preventDefault, stopPropagation = options.stopPropagation, exact = options.exact, onMove = options.onMove, onEnd = options.onEnd, onStart = options.onStart, initialValue = options.initialValue, _j = options.axis, axis = _j === void 0 ? "both" : _j, _k = options.draggingElement, draggingElement = _k === void 0 ? defaultWindow : _k, containerElement = options.containerElement, _l = options.handle, draggingHandle = _l === void 0 ? target : _l;
    var position = ref((_a = toValue(initialValue)) != null ? _a : { x: 0, y: 0 });
    var pressedDelta = ref();
    var filterEvent = function (e) {
        if (pointerTypes)
            return pointerTypes.includes(e.pointerType);
        return true;
    };
    var handleEvent = function (e) {
        if (toValue(preventDefault))
            e.preventDefault();
        if (toValue(stopPropagation))
            e.stopPropagation();
    };
    var start = function (e) {
        var _a2;
        if (e.button !== 0)
            return;
        if (toValue(options.disabled) || !filterEvent(e))
            return;
        if (toValue(exact) && e.target !== toValue(target))
            return;
        var container = toValue(containerElement);
        var containerRect = (_a2 = container == null ? void 0 : container.getBoundingClientRect) == null ? void 0 : _a2.call(container);
        var targetRect = toValue(target).getBoundingClientRect();
        var pos = {
            x: e.clientX - (container ? targetRect.left - containerRect.left + container.scrollLeft : targetRect.left),
            y: e.clientY - (container ? targetRect.top - containerRect.top + container.scrollTop : targetRect.top)
        };
        if ((onStart == null ? void 0 : onStart(pos, e)) === false)
            return;
        pressedDelta.value = pos;
        handleEvent(e);
    };
    var move = function (e) {
        if (toValue(options.disabled) || !filterEvent(e))
            return;
        if (!pressedDelta.value)
            return;
        var container = toValue(containerElement);
        var targetRect = toValue(target).getBoundingClientRect();
        var _j = position.value, x = _j.x, y = _j.y;
        if (axis === "x" || axis === "both") {
            x = e.clientX - pressedDelta.value.x;
            if (container)
                x = Math.min(Math.max(0, x), container.scrollWidth - targetRect.width);
        }
        if (axis === "y" || axis === "both") {
            y = e.clientY - pressedDelta.value.y;
            if (container)
                y = Math.min(Math.max(0, y), container.scrollHeight - targetRect.height);
        }
        position.value = {
            x: x,
            y: y
        };
        onMove == null ? void 0 : onMove(position.value, e);
        handleEvent(e);
    };
    var end = function (e) {
        if (toValue(options.disabled) || !filterEvent(e))
            return;
        if (!pressedDelta.value)
            return;
        pressedDelta.value = void 0;
        onEnd == null ? void 0 : onEnd(position.value, e);
        handleEvent(e);
    };
    if (isClient) {
        var config = { capture: (_b = options.capture) != null ? _b : true };
        useEventListener(draggingHandle, "pointerdown", start, config);
        useEventListener(draggingElement, "pointermove", move, config);
        useEventListener(draggingElement, "pointerup", end, config);
    }
    return __assign(__assign({}, toRefs(position)), { position: position, isDragging: computed(function () { return !!pressedDelta.value; }), style: computed(function () { return "left:".concat(position.value.x, "px;top:").concat(position.value.y, "px;"); }) });
}
function useDropZone(target, options) {
    if (options === void 0) { options = {}; }
    var isOverDropZone = ref(false);
    var files = shallowRef(null);
    var counter = 0;
    var isDataTypeIncluded = true;
    if (isClient) {
        var _options_1 = typeof options === "function" ? { onDrop: options } : options;
        var getFiles_1 = function (event) {
            var _a, _b;
            var list = Array.from((_b = (_a = event.dataTransfer) == null ? void 0 : _a.files) != null ? _b : []);
            return files.value = list.length === 0 ? null : list;
        };
        useEventListener(target, "dragenter", function (event) {
            var _a, _b;
            var types = Array.from(((_a = event == null ? void 0 : event.dataTransfer) == null ? void 0 : _a.items) || []).map(function (i) { return i.kind === "file" ? i.type : null; }).filter(notNullish);
            if (_options_1.dataTypes && event.dataTransfer) {
                var dataTypes = unref(_options_1.dataTypes);
                isDataTypeIncluded = typeof dataTypes === "function" ? dataTypes(types) : dataTypes ? dataTypes.some(function (item) { return types.includes(item); }) : true;
                if (!isDataTypeIncluded)
                    return;
            }
            event.preventDefault();
            counter += 1;
            isOverDropZone.value = true;
            (_b = _options_1.onEnter) == null ? void 0 : _b.call(_options_1, getFiles_1(event), event);
        });
        useEventListener(target, "dragover", function (event) {
            var _a;
            if (!isDataTypeIncluded)
                return;
            event.preventDefault();
            (_a = _options_1.onOver) == null ? void 0 : _a.call(_options_1, getFiles_1(event), event);
        });
        useEventListener(target, "dragleave", function (event) {
            var _a;
            if (!isDataTypeIncluded)
                return;
            event.preventDefault();
            counter -= 1;
            if (counter === 0)
                isOverDropZone.value = false;
            (_a = _options_1.onLeave) == null ? void 0 : _a.call(_options_1, getFiles_1(event), event);
        });
        useEventListener(target, "drop", function (event) {
            var _a;
            event.preventDefault();
            counter = 0;
            isOverDropZone.value = false;
            (_a = _options_1.onDrop) == null ? void 0 : _a.call(_options_1, getFiles_1(event), event);
        });
    }
    return {
        files: files,
        isOverDropZone: isOverDropZone
    };
}
function useResizeObserver(target, callback, options) {
    if (options === void 0) { options = {}; }
    var _j = options.window, window = _j === void 0 ? defaultWindow : _j, observerOptions = __rest(options, ["window"]);
    var observer;
    var isSupported = useSupported(function () { return window && "ResizeObserver" in window; });
    var cleanup = function () {
        if (observer) {
            observer.disconnect();
            observer = void 0;
        }
    };
    var targets = computed(function () { return Array.isArray(target) ? target.map(function (el) { return unrefElement(el); }) : [unrefElement(target)]; });
    var stopWatch = watch(targets, function (els) {
        var e_6, _j;
        cleanup();
        if (isSupported.value && window) {
            observer = new ResizeObserver(callback);
            try {
                for (var els_1 = __values(els), els_1_1 = els_1.next(); !els_1_1.done; els_1_1 = els_1.next()) {
                    var _el = els_1_1.value;
                    _el && observer.observe(_el, observerOptions);
                }
            }
            catch (e_6_1) { e_6 = { error: e_6_1 }; }
            finally {
                try {
                    if (els_1_1 && !els_1_1.done && (_j = els_1.return)) _j.call(els_1);
                }
                finally { if (e_6) throw e_6.error; }
            }
        }
    }, { immediate: true, flush: "post" });
    var stop = function () {
        cleanup();
        stopWatch();
    };
    tryOnScopeDispose(stop);
    return {
        isSupported: isSupported,
        stop: stop
    };
}
function useElementBounding(target, options) {
    if (options === void 0) { options = {}; }
    var _j = options.reset, reset = _j === void 0 ? true : _j, _k = options.windowResize, windowResize = _k === void 0 ? true : _k, _l = options.windowScroll, windowScroll = _l === void 0 ? true : _l, _m = options.immediate, immediate = _m === void 0 ? true : _m;
    var height = ref(0);
    var bottom = ref(0);
    var left = ref(0);
    var right = ref(0);
    var top = ref(0);
    var width = ref(0);
    var x = ref(0);
    var y = ref(0);
    function update() {
        var el = unrefElement(target);
        if (!el) {
            if (reset) {
                height.value = 0;
                bottom.value = 0;
                left.value = 0;
                right.value = 0;
                top.value = 0;
                width.value = 0;
                x.value = 0;
                y.value = 0;
            }
            return;
        }
        var rect = el.getBoundingClientRect();
        height.value = rect.height;
        bottom.value = rect.bottom;
        left.value = rect.left;
        right.value = rect.right;
        top.value = rect.top;
        width.value = rect.width;
        x.value = rect.x;
        y.value = rect.y;
    }
    useResizeObserver(target, update);
    watch(function () { return unrefElement(target); }, function (ele) { return !ele && update(); });
    useMutationObserver(target, update, {
        attributeFilter: ["style", "class"]
    });
    if (windowScroll)
        useEventListener("scroll", update, { capture: true, passive: true });
    if (windowResize)
        useEventListener("resize", update, { passive: true });
    tryOnMounted(function () {
        if (immediate)
            update();
    });
    return {
        height: height,
        bottom: bottom,
        left: left,
        right: right,
        top: top,
        width: width,
        x: x,
        y: y,
        update: update
    };
}
function useElementByPoint(options) {
    var x = options.x, y = options.y, _j = options.document, document = _j === void 0 ? defaultDocument : _j, multiple = options.multiple, _k = options.interval, interval = _k === void 0 ? "requestAnimationFrame" : _k, _l = options.immediate, immediate = _l === void 0 ? true : _l;
    var isSupported = useSupported(function () {
        if (toValue(multiple))
            return document && "elementsFromPoint" in document;
        return document && "elementFromPoint" in document;
    });
    var element = ref(null);
    var cb = function () {
        var _a, _b;
        element.value = toValue(multiple) ? (_a = document == null ? void 0 : document.elementsFromPoint(toValue(x), toValue(y))) != null ? _a : [] : (_b = document == null ? void 0 : document.elementFromPoint(toValue(x), toValue(y))) != null ? _b : null;
    };
    var controls = interval === "requestAnimationFrame" ? useRafFn(cb, { immediate: immediate }) : useIntervalFn(cb, interval, { immediate: immediate });
    return __assign({ isSupported: isSupported, element: element }, controls);
}
function useElementHover(el, options) {
    if (options === void 0) { options = {}; }
    var _j = options.delayEnter, delayEnter = _j === void 0 ? 0 : _j, _k = options.delayLeave, delayLeave = _k === void 0 ? 0 : _k, _l = options.window, window = _l === void 0 ? defaultWindow : _l;
    var isHovered = ref(false);
    var timer;
    var toggle = function (entering) {
        var delay = entering ? delayEnter : delayLeave;
        if (timer) {
            clearTimeout(timer);
            timer = void 0;
        }
        if (delay)
            timer = setTimeout(function () { return isHovered.value = entering; }, delay);
        else
            isHovered.value = entering;
    };
    if (!window)
        return isHovered;
    useEventListener(el, "mouseenter", function () { return toggle(true); }, { passive: true });
    useEventListener(el, "mouseleave", function () { return toggle(false); }, { passive: true });
    return isHovered;
}
function useElementSize(target, initialSize, options) {
    if (initialSize === void 0) { initialSize = { width: 0, height: 0 }; }
    if (options === void 0) { options = {}; }
    var _j = options.window, window = _j === void 0 ? defaultWindow : _j, _k = options.box, box = _k === void 0 ? "content-box" : _k;
    var isSVG = computed(function () {
        var _a, _b;
        return (_b = (_a = unrefElement(target)) == null ? void 0 : _a.namespaceURI) == null ? void 0 : _b.includes("svg");
    });
    var width = ref(initialSize.width);
    var height = ref(initialSize.height);
    var stop1 = useResizeObserver(target, function (_j) {
        var _k = __read(_j, 1), entry = _k[0];
        var boxSize = box === "border-box" ? entry.borderBoxSize : box === "content-box" ? entry.contentBoxSize : entry.devicePixelContentBoxSize;
        if (window && isSVG.value) {
            var $elem = unrefElement(target);
            if ($elem) {
                var rect = $elem.getBoundingClientRect();
                width.value = rect.width;
                height.value = rect.height;
            }
        }
        else {
            if (boxSize) {
                var formatBoxSize = Array.isArray(boxSize) ? boxSize : [boxSize];
                width.value = formatBoxSize.reduce(function (acc, _j) {
                    var inlineSize = _j.inlineSize;
                    return acc + inlineSize;
                }, 0);
                height.value = formatBoxSize.reduce(function (acc, _j) {
                    var blockSize = _j.blockSize;
                    return acc + blockSize;
                }, 0);
            }
            else {
                width.value = entry.contentRect.width;
                height.value = entry.contentRect.height;
            }
        }
    }, options).stop;
    tryOnMounted(function () {
        var ele = unrefElement(target);
        if (ele) {
            width.value = "offsetWidth" in ele ? ele.offsetWidth : initialSize.width;
            height.value = "offsetHeight" in ele ? ele.offsetHeight : initialSize.height;
        }
    });
    var stop2 = watch(function () { return unrefElement(target); }, function (ele) {
        width.value = ele ? initialSize.width : 0;
        height.value = ele ? initialSize.height : 0;
    });
    function stop() {
        stop1();
        stop2();
    }
    return {
        width: width,
        height: height,
        stop: stop
    };
}
function useIntersectionObserver(target, callback, options) {
    if (options === void 0) { options = {}; }
    var root = options.root, _j = options.rootMargin, rootMargin = _j === void 0 ? "0px" : _j, _k = options.threshold, threshold = _k === void 0 ? 0.1 : _k, _l = options.window, window = _l === void 0 ? defaultWindow : _l, _m = options.immediate, immediate = _m === void 0 ? true : _m;
    var isSupported = useSupported(function () { return window && "IntersectionObserver" in window; });
    var targets = computed(function () {
        var _target = toValue(target);
        return (Array.isArray(_target) ? _target : [_target]).map(unrefElement).filter(notNullish);
    });
    var cleanup = noop;
    var isActive = ref(immediate);
    var stopWatch = isSupported.value ? watch(function () { return [targets.value, unrefElement(root), isActive.value]; }, function (_j) {
        var _k = __read(_j, 2), targets2 = _k[0], root2 = _k[1];
        cleanup();
        if (!isActive.value)
            return;
        if (!targets2.length)
            return;
        var observer = new IntersectionObserver(callback, {
            root: unrefElement(root2),
            rootMargin: rootMargin,
            threshold: threshold
        });
        targets2.forEach(function (el) { return el && observer.observe(el); });
        cleanup = function () {
            observer.disconnect();
            cleanup = noop;
        };
    }, { immediate: immediate, flush: "post" }) : noop;
    var stop = function () {
        cleanup();
        stopWatch();
        isActive.value = false;
    };
    tryOnScopeDispose(stop);
    return {
        isSupported: isSupported,
        isActive: isActive,
        pause: function () {
            cleanup();
            isActive.value = false;
        },
        resume: function () {
            isActive.value = true;
        },
        stop: stop
    };
}
function useElementVisibility(element, options) {
    if (options === void 0) { options = {}; }
    var _j = options.window, window = _j === void 0 ? defaultWindow : _j, scrollTarget = options.scrollTarget, _k = options.threshold, threshold = _k === void 0 ? 0 : _k;
    var elementIsVisible = ref(false);
    useIntersectionObserver(element, function (intersectionObserverEntries) {
        var e_7, _j;
        var isIntersecting = elementIsVisible.value;
        var latestTime = 0;
        try {
            for (var intersectionObserverEntries_1 = __values(intersectionObserverEntries), intersectionObserverEntries_1_1 = intersectionObserverEntries_1.next(); !intersectionObserverEntries_1_1.done; intersectionObserverEntries_1_1 = intersectionObserverEntries_1.next()) {
                var entry = intersectionObserverEntries_1_1.value;
                if (entry.time >= latestTime) {
                    latestTime = entry.time;
                    isIntersecting = entry.isIntersecting;
                }
            }
        }
        catch (e_7_1) { e_7 = { error: e_7_1 }; }
        finally {
            try {
                if (intersectionObserverEntries_1_1 && !intersectionObserverEntries_1_1.done && (_j = intersectionObserverEntries_1.return)) _j.call(intersectionObserverEntries_1);
            }
            finally { if (e_7) throw e_7.error; }
        }
        elementIsVisible.value = isIntersecting;
    }, {
        root: scrollTarget,
        window: window,
        threshold: threshold
    });
    return elementIsVisible;
}
var events = /* @__PURE__ */ new Map();
function useEventBus(key) {
    var scope = getCurrentScope();
    function on(listener) {
        var _a;
        var listeners = events.get(key) || /* @__PURE__ */ new Set();
        listeners.add(listener);
        events.set(key, listeners);
        var _off = function () { return off(listener); };
        (_a = scope == null ? void 0 : scope.cleanups) == null ? void 0 : _a.push(_off);
        return _off;
    }
    function once(listener) {
        function _listener() {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            off(_listener);
            listener.apply(void 0, __spreadArray([], __read(args), false));
        }
        return on(_listener);
    }
    function off(listener) {
        var listeners = events.get(key);
        if (!listeners)
            return;
        listeners.delete(listener);
        if (!listeners.size)
            reset();
    }
    function reset() {
        events.delete(key);
    }
    function emit(event, payload) {
        var _a;
        (_a = events.get(key)) == null ? void 0 : _a.forEach(function (v) { return v(event, payload); });
    }
    return { on: on, once: once, off: off, emit: emit, reset: reset };
}
function resolveNestedOptions$1(options) {
    if (options === true)
        return {};
    return options;
}
function useEventSource(url, events, options) {
    if (events === void 0) { events = []; }
    if (options === void 0) { options = {}; }
    var event = ref(null);
    var data = ref(null);
    var status = ref("CONNECTING");
    var eventSource = ref(null);
    var error = shallowRef(null);
    var urlRef = toRef(url);
    var lastEventId = shallowRef(null);
    var explicitlyClosed = false;
    var retried = 0;
    var _j = options.withCredentials, withCredentials = _j === void 0 ? false : _j, _k = options.immediate, immediate = _k === void 0 ? true : _k;
    var close = function () {
        if (isClient && eventSource.value) {
            eventSource.value.close();
            eventSource.value = null;
            status.value = "CLOSED";
            explicitlyClosed = true;
        }
    };
    var _init = function () {
        var e_8, _j;
        if (explicitlyClosed || typeof urlRef.value === "undefined")
            return;
        var es = new EventSource(urlRef.value, { withCredentials: withCredentials });
        status.value = "CONNECTING";
        eventSource.value = es;
        es.onopen = function () {
            status.value = "OPEN";
            error.value = null;
        };
        es.onerror = function (e) {
            status.value = "CLOSED";
            error.value = e;
            if (es.readyState === 2 && !explicitlyClosed && options.autoReconnect) {
                es.close();
                var _j = resolveNestedOptions$1(options.autoReconnect), _k = _j.retries, retries = _k === void 0 ? -1 : _k, _l = _j.delay, delay = _l === void 0 ? 1e3 : _l, onFailed = _j.onFailed;
                retried += 1;
                if (typeof retries === "number" && (retries < 0 || retried < retries))
                    setTimeout(_init, delay);
                else if (typeof retries === "function" && retries())
                    setTimeout(_init, delay);
                else
                    onFailed == null ? void 0 : onFailed();
            }
        };
        es.onmessage = function (e) {
            event.value = null;
            data.value = e.data;
            lastEventId.value = e.lastEventId;
        };
        var _loop_2 = function (event_name) {
            useEventListener(es, event_name, function (e) {
                event.value = event_name;
                data.value = e.data || null;
            });
        };
        try {
            for (var events_1 = __values(events), events_1_1 = events_1.next(); !events_1_1.done; events_1_1 = events_1.next()) {
                var event_name = events_1_1.value;
                _loop_2(event_name);
            }
        }
        catch (e_8_1) { e_8 = { error: e_8_1 }; }
        finally {
            try {
                if (events_1_1 && !events_1_1.done && (_j = events_1.return)) _j.call(events_1);
            }
            finally { if (e_8) throw e_8.error; }
        }
    };
    var open = function () {
        if (!isClient)
            return;
        close();
        explicitlyClosed = false;
        retried = 0;
        _init();
    };
    if (immediate)
        watch(urlRef, open, { immediate: true });
    tryOnScopeDispose(close);
    return {
        eventSource: eventSource,
        event: event,
        data: data,
        status: status,
        error: error,
        open: open,
        close: close,
        lastEventId: lastEventId
    };
}
function useEyeDropper(options) {
    if (options === void 0) { options = {}; }
    var _j = options.initialValue, initialValue = _j === void 0 ? "" : _j;
    var isSupported = useSupported(function () { return typeof window !== "undefined" && "EyeDropper" in window; });
    var sRGBHex = ref(initialValue);
    function open(openOptions) {
        return __awaiter(this, void 0, void 0, function () {
            var eyeDropper, result;
            return __generator(this, function (_j) {
                switch (_j.label) {
                    case 0:
                        if (!isSupported.value)
                            return [2 /*return*/];
                        eyeDropper = new window.EyeDropper();
                        return [4 /*yield*/, eyeDropper.open(openOptions)];
                    case 1:
                        result = _j.sent();
                        sRGBHex.value = result.sRGBHex;
                        return [2 /*return*/, result];
                }
            });
        });
    }
    return { isSupported: isSupported, sRGBHex: sRGBHex, open: open };
}
function useFavicon(newIcon, options) {
    if (newIcon === void 0) { newIcon = null; }
    if (options === void 0) { options = {}; }
    var _j = options.baseUrl, baseUrl = _j === void 0 ? "" : _j, _k = options.rel, rel = _k === void 0 ? "icon" : _k, _l = options.document, document = _l === void 0 ? defaultDocument : _l;
    var favicon = toRef(newIcon);
    var applyIcon = function (icon) {
        var elements = document == null ? void 0 : document.head.querySelectorAll("link[rel*=\"".concat(rel, "\"]"));
        if (!elements || elements.length === 0) {
            var link = document == null ? void 0 : document.createElement("link");
            if (link) {
                link.rel = rel;
                link.href = "".concat(baseUrl).concat(icon);
                link.type = "image/".concat(icon.split(".").pop());
                document == null ? void 0 : document.head.append(link);
            }
            return;
        }
        elements == null ? void 0 : elements.forEach(function (el) { return el.href = "".concat(baseUrl).concat(icon); });
    };
    watch(favicon, function (i, o) {
        if (typeof i === "string" && i !== o)
            applyIcon(i);
    }, { immediate: true });
    return favicon;
}
var payloadMapping = {
    json: "application/json",
    text: "text/plain"
};
function isFetchOptions(obj) {
    return obj && containsProp(obj, "immediate", "refetch", "initialData", "timeout", "beforeFetch", "afterFetch", "onFetchError", "fetch", "updateDataOnError");
}
var reAbsolute = /^(?:[a-z][a-z\d+\-.]*:)?\/\//i;
function isAbsoluteURL(url) {
    return reAbsolute.test(url);
}
function headersToObject(headers) {
    if (typeof Headers !== "undefined" && headers instanceof Headers)
        return Object.fromEntries(headers.entries());
    return headers;
}
function combineCallbacks(combination) {
    var _this = this;
    var callbacks = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        callbacks[_i - 1] = arguments[_i];
    }
    if (combination === "overwrite") {
        return function (ctx) { return __awaiter(_this, void 0, void 0, function () {
            var callback, _j;
            return __generator(this, function (_k) {
                switch (_k.label) {
                    case 0:
                        callback = callbacks[callbacks.length - 1];
                        if (!callback) return [3 /*break*/, 2];
                        _j = [__assign({}, ctx)];
                        return [4 /*yield*/, callback(ctx)];
                    case 1: return [2 /*return*/, __assign.apply(void 0, _j.concat([_k.sent()]))];
                    case 2: return [2 /*return*/, ctx];
                }
            });
        }); };
    }
    else {
        return function (ctx) { return __awaiter(_this, void 0, void 0, function () {
            var callbacks_1, callbacks_1_1, callback, _j, e_9_1;
            var e_9, _k;
            return __generator(this, function (_l) {
                switch (_l.label) {
                    case 0:
                        _l.trys.push([0, 5, 6, 7]);
                        callbacks_1 = __values(callbacks), callbacks_1_1 = callbacks_1.next();
                        _l.label = 1;
                    case 1:
                        if (!!callbacks_1_1.done) return [3 /*break*/, 4];
                        callback = callbacks_1_1.value;
                        if (!callback) return [3 /*break*/, 3];
                        _j = [__assign({}, ctx)];
                        return [4 /*yield*/, callback(ctx)];
                    case 2:
                        ctx = __assign.apply(void 0, _j.concat([_l.sent()]));
                        _l.label = 3;
                    case 3:
                        callbacks_1_1 = callbacks_1.next();
                        return [3 /*break*/, 1];
                    case 4: return [3 /*break*/, 7];
                    case 5:
                        e_9_1 = _l.sent();
                        e_9 = { error: e_9_1 };
                        return [3 /*break*/, 7];
                    case 6:
                        try {
                            if (callbacks_1_1 && !callbacks_1_1.done && (_k = callbacks_1.return)) _k.call(callbacks_1);
                        }
                        finally { if (e_9) throw e_9.error; }
                        return [7 /*endfinally*/];
                    case 7: return [2 /*return*/, ctx];
                }
            });
        }); };
    }
}
function createFetch(config) {
    if (config === void 0) { config = {}; }
    var _combination = config.combination || "chain";
    var _options = config.options || {};
    var _fetchOptions = config.fetchOptions || {};
    function useFactoryFetch(url) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var computedUrl = computed(function () {
            var baseUrl = toValue(config.baseUrl);
            var targetUrl = toValue(url);
            return baseUrl && !isAbsoluteURL(targetUrl) ? joinPaths(baseUrl, targetUrl) : targetUrl;
        });
        var options = _options;
        var fetchOptions = _fetchOptions;
        if (args.length > 0) {
            if (isFetchOptions(args[0])) {
                options = __assign(__assign(__assign({}, options), args[0]), { beforeFetch: combineCallbacks(_combination, _options.beforeFetch, args[0].beforeFetch), afterFetch: combineCallbacks(_combination, _options.afterFetch, args[0].afterFetch), onFetchError: combineCallbacks(_combination, _options.onFetchError, args[0].onFetchError) });
            }
            else {
                fetchOptions = __assign(__assign(__assign({}, fetchOptions), args[0]), { headers: __assign(__assign({}, headersToObject(fetchOptions.headers) || {}), headersToObject(args[0].headers) || {}) });
            }
        }
        if (args.length > 1 && isFetchOptions(args[1])) {
            options = __assign(__assign(__assign({}, options), args[1]), { beforeFetch: combineCallbacks(_combination, _options.beforeFetch, args[1].beforeFetch), afterFetch: combineCallbacks(_combination, _options.afterFetch, args[1].afterFetch), onFetchError: combineCallbacks(_combination, _options.onFetchError, args[1].onFetchError) });
        }
        return useFetch(computedUrl, fetchOptions, options);
    }
    return useFactoryFetch;
}
function useFetch(url) {
    var _this = this;
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    var _a;
    var supportsAbort = typeof AbortController === "function";
    var fetchOptions = {};
    var options = {
        immediate: true,
        refetch: false,
        timeout: 0,
        updateDataOnError: false
    };
    var config = {
        method: "GET",
        type: "text",
        payload: void 0
    };
    if (args.length > 0) {
        if (isFetchOptions(args[0]))
            options = __assign(__assign({}, options), args[0]);
        else
            fetchOptions = args[0];
    }
    if (args.length > 1) {
        if (isFetchOptions(args[1]))
            options = __assign(__assign({}, options), args[1]);
    }
    var _j = options.fetch, fetch = _j === void 0 ? (_a = defaultWindow) == null ? void 0 : _a.fetch : _j, initialData = options.initialData, timeout = options.timeout;
    var responseEvent = createEventHook();
    var errorEvent = createEventHook();
    var finallyEvent = createEventHook();
    var isFinished = ref(false);
    var isFetching = ref(false);
    var aborted = ref(false);
    var statusCode = ref(null);
    var response = shallowRef(null);
    var error = shallowRef(null);
    var data = shallowRef(initialData || null);
    var canAbort = computed(function () { return supportsAbort && isFetching.value; });
    var controller;
    var timer;
    var abort = function () {
        if (supportsAbort) {
            controller == null ? void 0 : controller.abort();
            controller = new AbortController();
            controller.signal.onabort = function () { return aborted.value = true; };
            fetchOptions = __assign(__assign({}, fetchOptions), { signal: controller.signal });
        }
    };
    var loading = function (isLoading) {
        isFetching.value = isLoading;
        isFinished.value = !isLoading;
    };
    if (timeout)
        timer = useTimeoutFn(abort, timeout, { immediate: false });
    var executeCounter = 0;
    var execute = function () {
        var args_1 = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args_1[_i] = arguments[_i];
        }
        return __awaiter(_this, __spreadArray([], __read(args_1), false), void 0, function (throwOnFailed) {
            var _a2, _b, currentExecuteCounter, defaultFetchOptions, headers, payload, isCanceled, context, _j, _k, _l, responseData;
            var _this = this;
            if (throwOnFailed === void 0) { throwOnFailed = false; }
            return __generator(this, function (_m) {
                switch (_m.label) {
                    case 0:
                        abort();
                        loading(true);
                        error.value = null;
                        statusCode.value = null;
                        aborted.value = false;
                        executeCounter += 1;
                        currentExecuteCounter = executeCounter;
                        defaultFetchOptions = {
                            method: config.method,
                            headers: {}
                        };
                        if (config.payload) {
                            headers = headersToObject(defaultFetchOptions.headers);
                            payload = toValue(config.payload);
                            if (!config.payloadType && payload && Object.getPrototypeOf(payload) === Object.prototype && !(payload instanceof FormData))
                                config.payloadType = "json";
                            if (config.payloadType)
                                headers["Content-Type"] = (_a2 = payloadMapping[config.payloadType]) != null ? _a2 : config.payloadType;
                            defaultFetchOptions.body = config.payloadType === "json" ? JSON.stringify(payload) : payload;
                        }
                        isCanceled = false;
                        context = {
                            url: toValue(url),
                            options: __assign(__assign({}, defaultFetchOptions), fetchOptions),
                            cancel: function () {
                                isCanceled = true;
                            }
                        };
                        if (!options.beforeFetch) return [3 /*break*/, 2];
                        _k = (_j = Object).assign;
                        _l = [context];
                        return [4 /*yield*/, options.beforeFetch(context)];
                    case 1:
                        _k.apply(_j, _l.concat([_m.sent()]));
                        _m.label = 2;
                    case 2:
                        if (isCanceled || !fetch) {
                            loading(false);
                            return [2 /*return*/, Promise.resolve(null)];
                        }
                        responseData = null;
                        if (timer)
                            timer.start();
                        return [2 /*return*/, fetch(context.url, __assign(__assign(__assign({}, defaultFetchOptions), context.options), { headers: __assign(__assign({}, headersToObject(defaultFetchOptions.headers)), headersToObject((_b = context.options) == null ? void 0 : _b.headers)) })).then(function (fetchResponse) { return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_j) {
                                    switch (_j.label) {
                                        case 0:
                                            response.value = fetchResponse;
                                            statusCode.value = fetchResponse.status;
                                            return [4 /*yield*/, fetchResponse.clone()[config.type]()];
                                        case 1:
                                            responseData = _j.sent();
                                            if (!fetchResponse.ok) {
                                                data.value = initialData || null;
                                                throw new Error(fetchResponse.statusText);
                                            }
                                            if (!options.afterFetch) return [3 /*break*/, 3];
                                            return [4 /*yield*/, options.afterFetch({
                                                    data: responseData,
                                                    response: fetchResponse
                                                })];
                                        case 2:
                                            (responseData = (_j.sent()).data);
                                            _j.label = 3;
                                        case 3:
                                            data.value = responseData;
                                            responseEvent.trigger(fetchResponse);
                                            return [2 /*return*/, fetchResponse];
                                    }
                                });
                            }); }).catch(function (fetchError) { return __awaiter(_this, void 0, void 0, function () {
                                var errorData;
                                var _j;
                                return __generator(this, function (_k) {
                                    switch (_k.label) {
                                        case 0:
                                            errorData = fetchError.message || fetchError.name;
                                            if (!options.onFetchError) return [3 /*break*/, 2];
                                            return [4 /*yield*/, options.onFetchError({
                                                    data: responseData,
                                                    error: fetchError,
                                                    response: response.value
                                                })];
                                        case 1:
                                            (_j = _k.sent(), errorData = _j.error, responseData = _j.data);
                                            _k.label = 2;
                                        case 2:
                                            error.value = errorData;
                                            if (options.updateDataOnError)
                                                data.value = responseData;
                                            errorEvent.trigger(fetchError);
                                            if (throwOnFailed)
                                                throw fetchError;
                                            return [2 /*return*/, null];
                                    }
                                });
                            }); }).finally(function () {
                                if (currentExecuteCounter === executeCounter)
                                    loading(false);
                                if (timer)
                                    timer.stop();
                                finallyEvent.trigger(null);
                            })];
                }
            });
        });
    };
    var refetch = toRef(options.refetch);
    watch([
        refetch,
        toRef(url)
    ], function (_j) {
        var _k = __read(_j, 1), refetch2 = _k[0];
        return refetch2 && execute();
    }, { deep: true });
    var shell = {
        isFinished: readonly(isFinished),
        isFetching: readonly(isFetching),
        statusCode: statusCode,
        response: response,
        error: error,
        data: data,
        canAbort: canAbort,
        aborted: aborted,
        abort: abort,
        execute: execute,
        onFetchResponse: responseEvent.on,
        onFetchError: errorEvent.on,
        onFetchFinally: finallyEvent.on,
        // method
        get: setMethod("GET"),
        put: setMethod("PUT"),
        post: setMethod("POST"),
        delete: setMethod("DELETE"),
        patch: setMethod("PATCH"),
        head: setMethod("HEAD"),
        options: setMethod("OPTIONS"),
        // type
        json: setType("json"),
        text: setType("text"),
        blob: setType("blob"),
        arrayBuffer: setType("arrayBuffer"),
        formData: setType("formData")
    };
    function setMethod(method) {
        return function (payload, payloadType) {
            if (!isFetching.value) {
                config.method = method;
                config.payload = payload;
                config.payloadType = payloadType;
                if (isRef(config.payload)) {
                    watch([
                        refetch,
                        toRef(config.payload)
                    ], function (_j) {
                        var _k = __read(_j, 1), refetch2 = _k[0];
                        return refetch2 && execute();
                    }, { deep: true });
                }
                return __assign(__assign({}, shell), { then: function (onFulfilled, onRejected) {
                        return waitUntilFinished().then(onFulfilled, onRejected);
                    } });
            }
            return void 0;
        };
    }
    function waitUntilFinished() {
        return new Promise(function (resolve, reject) {
            until(isFinished).toBe(true).then(function () { return resolve(shell); }).catch(function (error2) { return reject(error2); });
        });
    }
    function setType(type) {
        return function () {
            if (!isFetching.value) {
                config.type = type;
                return __assign(__assign({}, shell), { then: function (onFulfilled, onRejected) {
                        return waitUntilFinished().then(onFulfilled, onRejected);
                    } });
            }
            return void 0;
        };
    }
    if (options.immediate)
        Promise.resolve().then(function () { return execute(); });
    return __assign(__assign({}, shell), { then: function (onFulfilled, onRejected) {
            return waitUntilFinished().then(onFulfilled, onRejected);
        } });
}
function joinPaths(start, end) {
    if (!start.endsWith("/") && !end.startsWith("/"))
        return "".concat(start, "/").concat(end);
    return "".concat(start).concat(end);
}
var DEFAULT_OPTIONS = {
    multiple: true,
    accept: "*",
    reset: false,
    directory: false
};
function useFileDialog(options) {
    if (options === void 0) { options = {}; }
    var _j = options.document, document = _j === void 0 ? defaultDocument : _j;
    var files = ref(null);
    var _k = createEventHook(), onChange = _k.on, trigger = _k.trigger;
    var input;
    if (document) {
        input = document.createElement("input");
        input.type = "file";
        input.onchange = function (event) {
            var result = event.target;
            files.value = result.files;
            trigger(files.value);
        };
    }
    var reset = function () {
        files.value = null;
        if (input && input.value) {
            input.value = "";
            trigger(null);
        }
    };
    var open = function (localOptions) {
        if (!input)
            return;
        var _options = __assign(__assign(__assign({}, DEFAULT_OPTIONS), options), localOptions);
        input.multiple = _options.multiple;
        input.accept = _options.accept;
        input.webkitdirectory = _options.directory;
        if (hasOwn(_options, "capture"))
            input.capture = _options.capture;
        if (_options.reset)
            reset();
        input.click();
    };
    return {
        files: readonly(files),
        open: open,
        reset: reset,
        onChange: onChange
    };
}
function useFileSystemAccess(options) {
    if (options === void 0) { options = {}; }
    var _j = options.window, _window = _j === void 0 ? defaultWindow : _j, _k = options.dataType, dataType = _k === void 0 ? "Text" : _k;
    var window = _window;
    var isSupported = useSupported(function () { return window && "showSaveFilePicker" in window && "showOpenFilePicker" in window; });
    var fileHandle = ref();
    var data = ref();
    var file = ref();
    var fileName = computed(function () {
        var _a, _b;
        return (_b = (_a = file.value) == null ? void 0 : _a.name) != null ? _b : "";
    });
    var fileMIME = computed(function () {
        var _a, _b;
        return (_b = (_a = file.value) == null ? void 0 : _a.type) != null ? _b : "";
    });
    var fileSize = computed(function () {
        var _a, _b;
        return (_b = (_a = file.value) == null ? void 0 : _a.size) != null ? _b : 0;
    });
    var fileLastModified = computed(function () {
        var _a, _b;
        return (_b = (_a = file.value) == null ? void 0 : _a.lastModified) != null ? _b : 0;
    });
    function open() {
        return __awaiter(this, arguments, void 0, function (_options) {
            var _j, handle;
            if (_options === void 0) { _options = {}; }
            return __generator(this, function (_k) {
                switch (_k.label) {
                    case 0:
                        if (!isSupported.value)
                            return [2 /*return*/];
                        return [4 /*yield*/, window.showOpenFilePicker(__assign(__assign({}, toValue(options)), _options))];
                    case 1:
                        _j = __read.apply(void 0, [_k.sent(), 1]), handle = _j[0];
                        fileHandle.value = handle;
                        return [4 /*yield*/, updateData()];
                    case 2:
                        _k.sent();
                        return [2 /*return*/];
                }
            });
        });
    }
    function create() {
        return __awaiter(this, arguments, void 0, function (_options) {
            var _j;
            if (_options === void 0) { _options = {}; }
            return __generator(this, function (_k) {
                switch (_k.label) {
                    case 0:
                        if (!isSupported.value)
                            return [2 /*return*/];
                        _j = fileHandle;
                        return [4 /*yield*/, window.showSaveFilePicker(__assign(__assign({}, options), _options))];
                    case 1:
                        _j.value = _k.sent();
                        data.value = void 0;
                        return [4 /*yield*/, updateData()];
                    case 2:
                        _k.sent();
                        return [2 /*return*/];
                }
            });
        });
    }
    function save() {
        return __awaiter(this, arguments, void 0, function (_options) {
            var writableStream;
            if (_options === void 0) { _options = {}; }
            return __generator(this, function (_j) {
                switch (_j.label) {
                    case 0:
                        if (!isSupported.value)
                            return [2 /*return*/];
                        if (!fileHandle.value)
                            return [2 /*return*/, saveAs(_options)];
                        if (!data.value) return [3 /*break*/, 4];
                        return [4 /*yield*/, fileHandle.value.createWritable()];
                    case 1:
                        writableStream = _j.sent();
                        return [4 /*yield*/, writableStream.write(data.value)];
                    case 2:
                        _j.sent();
                        return [4 /*yield*/, writableStream.close()];
                    case 3:
                        _j.sent();
                        _j.label = 4;
                    case 4: return [4 /*yield*/, updateFile()];
                    case 5:
                        _j.sent();
                        return [2 /*return*/];
                }
            });
        });
    }
    function saveAs() {
        return __awaiter(this, arguments, void 0, function (_options) {
            var _j, writableStream;
            if (_options === void 0) { _options = {}; }
            return __generator(this, function (_k) {
                switch (_k.label) {
                    case 0:
                        if (!isSupported.value)
                            return [2 /*return*/];
                        _j = fileHandle;
                        return [4 /*yield*/, window.showSaveFilePicker(__assign(__assign({}, options), _options))];
                    case 1:
                        _j.value = _k.sent();
                        if (!data.value) return [3 /*break*/, 5];
                        return [4 /*yield*/, fileHandle.value.createWritable()];
                    case 2:
                        writableStream = _k.sent();
                        return [4 /*yield*/, writableStream.write(data.value)];
                    case 3:
                        _k.sent();
                        return [4 /*yield*/, writableStream.close()];
                    case 4:
                        _k.sent();
                        _k.label = 5;
                    case 5: return [4 /*yield*/, updateFile()];
                    case 6:
                        _k.sent();
                        return [2 /*return*/];
                }
            });
        });
    }
    function updateFile() {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _j;
            return __generator(this, function (_k) {
                switch (_k.label) {
                    case 0:
                        _j = file;
                        return [4 /*yield*/, ((_a = fileHandle.value) == null ? void 0 : _a.getFile())];
                    case 1:
                        _j.value = _k.sent();
                        return [2 /*return*/];
                }
            });
        });
    }
    function updateData() {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, type, _j, _k;
            return __generator(this, function (_l) {
                switch (_l.label) {
                    case 0: return [4 /*yield*/, updateFile()];
                    case 1:
                        _l.sent();
                        type = toValue(dataType);
                        if (!(type === "Text")) return [3 /*break*/, 3];
                        _j = data;
                        return [4 /*yield*/, ((_a = file.value) == null ? void 0 : _a.text())];
                    case 2:
                        _j.value = _l.sent();
                        return [3 /*break*/, 6];
                    case 3:
                        if (!(type === "ArrayBuffer")) return [3 /*break*/, 5];
                        _k = data;
                        return [4 /*yield*/, ((_b = file.value) == null ? void 0 : _b.arrayBuffer())];
                    case 4:
                        _k.value = _l.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        if (type === "Blob")
                            data.value = file.value;
                        _l.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        });
    }
    watch(function () { return toValue(dataType); }, updateData);
    return {
        isSupported: isSupported,
        data: data,
        file: file,
        fileName: fileName,
        fileMIME: fileMIME,
        fileSize: fileSize,
        fileLastModified: fileLastModified,
        open: open,
        create: create,
        save: save,
        saveAs: saveAs,
        updateData: updateData
    };
}
function useFocus(target, options) {
    if (options === void 0) { options = {}; }
    var _j = options.initialValue, initialValue = _j === void 0 ? false : _j, _k = options.focusVisible, focusVisible = _k === void 0 ? false : _k, _l = options.preventScroll, preventScroll = _l === void 0 ? false : _l;
    var innerFocused = ref(false);
    var targetElement = computed(function () { return unrefElement(target); });
    useEventListener(targetElement, "focus", function (event) {
        var _a, _b;
        if (!focusVisible || ((_b = (_a = event.target).matches) == null ? void 0 : _b.call(_a, ":focus-visible")))
            innerFocused.value = true;
    });
    useEventListener(targetElement, "blur", function () { return innerFocused.value = false; });
    var focused = computed({
        get: function () { return innerFocused.value; },
        set: function (value) {
            var _a, _b;
            if (!value && innerFocused.value)
                (_a = targetElement.value) == null ? void 0 : _a.blur();
            else if (value && !innerFocused.value)
                (_b = targetElement.value) == null ? void 0 : _b.focus({ preventScroll: preventScroll });
        }
    });
    watch(targetElement, function () {
        focused.value = initialValue;
    }, { immediate: true, flush: "post" });
    return { focused: focused };
}
function useFocusWithin(target, options) {
    if (options === void 0) { options = {}; }
    var activeElement = useActiveElement(options);
    var targetElement = computed(function () { return unrefElement(target); });
    var focused = computed(function () { return targetElement.value && activeElement.value ? targetElement.value.contains(activeElement.value) : false; });
    return { focused: focused };
}
function useFps(options) {
    var _a;
    var fps = ref(0);
    if (typeof performance === "undefined")
        return fps;
    var every = (_a = options == null ? void 0 : options.every) != null ? _a : 10;
    var last = performance.now();
    var ticks = 0;
    useRafFn(function () {
        ticks += 1;
        if (ticks >= every) {
            var now = performance.now();
            var diff = now - last;
            fps.value = Math.round(1e3 / (diff / ticks));
            last = now;
            ticks = 0;
        }
    });
    return fps;
}
var eventHandlers = [
    "fullscreenchange",
    "webkitfullscreenchange",
    "webkitendfullscreen",
    "mozfullscreenchange",
    "MSFullscreenChange"
];
function useFullscreen(target, options) {
    if (options === void 0) { options = {}; }
    var _j = options.document, document = _j === void 0 ? defaultDocument : _j, _k = options.autoExit, autoExit = _k === void 0 ? false : _k;
    var targetRef = computed(function () {
        var _a;
        return (_a = unrefElement(target)) != null ? _a : document == null ? void 0 : document.querySelector("html");
    });
    var isFullscreen = ref(false);
    var requestMethod = computed(function () {
        return [
            "requestFullscreen",
            "webkitRequestFullscreen",
            "webkitEnterFullscreen",
            "webkitEnterFullScreen",
            "webkitRequestFullScreen",
            "mozRequestFullScreen",
            "msRequestFullscreen"
        ].find(function (m) { return document && m in document || targetRef.value && m in targetRef.value; });
    });
    var exitMethod = computed(function () {
        return [
            "exitFullscreen",
            "webkitExitFullscreen",
            "webkitExitFullScreen",
            "webkitCancelFullScreen",
            "mozCancelFullScreen",
            "msExitFullscreen"
        ].find(function (m) { return document && m in document || targetRef.value && m in targetRef.value; });
    });
    var fullscreenEnabled = computed(function () {
        return [
            "fullScreen",
            "webkitIsFullScreen",
            "webkitDisplayingFullscreen",
            "mozFullScreen",
            "msFullscreenElement"
        ].find(function (m) { return document && m in document || targetRef.value && m in targetRef.value; });
    });
    var fullscreenElementMethod = [
        "fullscreenElement",
        "webkitFullscreenElement",
        "mozFullScreenElement",
        "msFullscreenElement"
    ].find(function (m) { return document && m in document; });
    var isSupported = useSupported(function () { return targetRef.value && document && requestMethod.value !== void 0 && exitMethod.value !== void 0 && fullscreenEnabled.value !== void 0; });
    var isCurrentElementFullScreen = function () {
        if (fullscreenElementMethod)
            return (document == null ? void 0 : document[fullscreenElementMethod]) === targetRef.value;
        return false;
    };
    var isElementFullScreen = function () {
        if (fullscreenEnabled.value) {
            if (document && document[fullscreenEnabled.value] != null) {
                return document[fullscreenEnabled.value];
            }
            else {
                var target2 = targetRef.value;
                if ((target2 == null ? void 0 : target2[fullscreenEnabled.value]) != null) {
                    return Boolean(target2[fullscreenEnabled.value]);
                }
            }
        }
        return false;
    };
    function exit() {
        return __awaiter(this, void 0, void 0, function () {
            var target2;
            return __generator(this, function (_j) {
                switch (_j.label) {
                    case 0:
                        if (!isSupported.value || !isFullscreen.value)
                            return [2 /*return*/];
                        if (!exitMethod.value) return [3 /*break*/, 4];
                        if (!((document == null ? void 0 : document[exitMethod.value]) != null)) return [3 /*break*/, 2];
                        return [4 /*yield*/, document[exitMethod.value]()];
                    case 1:
                        _j.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        target2 = targetRef.value;
                        if (!((target2 == null ? void 0 : target2[exitMethod.value]) != null)) return [3 /*break*/, 4];
                        return [4 /*yield*/, target2[exitMethod.value]()];
                    case 3:
                        _j.sent();
                        _j.label = 4;
                    case 4:
                        isFullscreen.value = false;
                        return [2 /*return*/];
                }
            });
        });
    }
    function enter() {
        return __awaiter(this, void 0, void 0, function () {
            var target2;
            return __generator(this, function (_j) {
                switch (_j.label) {
                    case 0:
                        if (!isSupported.value || isFullscreen.value)
                            return [2 /*return*/];
                        if (!isElementFullScreen()) return [3 /*break*/, 2];
                        return [4 /*yield*/, exit()];
                    case 1:
                        _j.sent();
                        _j.label = 2;
                    case 2:
                        target2 = targetRef.value;
                        if (!(requestMethod.value && (target2 == null ? void 0 : target2[requestMethod.value]) != null)) return [3 /*break*/, 4];
                        return [4 /*yield*/, target2[requestMethod.value]()];
                    case 3:
                        _j.sent();
                        isFullscreen.value = true;
                        _j.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    function toggle() {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_j) {
                switch (_j.label) {
                    case 0: return [4 /*yield*/, (isFullscreen.value ? exit() : enter())];
                    case 1:
                        _j.sent();
                        return [2 /*return*/];
                }
            });
        });
    }
    var handlerCallback = function () {
        var isElementFullScreenValue = isElementFullScreen();
        if (!isElementFullScreenValue || isElementFullScreenValue && isCurrentElementFullScreen())
            isFullscreen.value = isElementFullScreenValue;
    };
    useEventListener(document, eventHandlers, handlerCallback, false);
    useEventListener(function () { return unrefElement(targetRef); }, eventHandlers, handlerCallback, false);
    if (autoExit)
        tryOnScopeDispose(exit);
    return {
        isSupported: isSupported,
        isFullscreen: isFullscreen,
        enter: enter,
        exit: exit,
        toggle: toggle
    };
}
function mapGamepadToXbox360Controller(gamepad) {
    return computed(function () {
        if (gamepad.value) {
            return {
                buttons: {
                    a: gamepad.value.buttons[0],
                    b: gamepad.value.buttons[1],
                    x: gamepad.value.buttons[2],
                    y: gamepad.value.buttons[3]
                },
                bumper: {
                    left: gamepad.value.buttons[4],
                    right: gamepad.value.buttons[5]
                },
                triggers: {
                    left: gamepad.value.buttons[6],
                    right: gamepad.value.buttons[7]
                },
                stick: {
                    left: {
                        horizontal: gamepad.value.axes[0],
                        vertical: gamepad.value.axes[1],
                        button: gamepad.value.buttons[10]
                    },
                    right: {
                        horizontal: gamepad.value.axes[2],
                        vertical: gamepad.value.axes[3],
                        button: gamepad.value.buttons[11]
                    }
                },
                dpad: {
                    up: gamepad.value.buttons[12],
                    down: gamepad.value.buttons[13],
                    left: gamepad.value.buttons[14],
                    right: gamepad.value.buttons[15]
                },
                back: gamepad.value.buttons[8],
                start: gamepad.value.buttons[9]
            };
        }
        return null;
    });
}
function useGamepad(options) {
    if (options === void 0) { options = {}; }
    var _j = options.navigator, navigator = _j === void 0 ? defaultNavigator : _j;
    var isSupported = useSupported(function () { return navigator && "getGamepads" in navigator; });
    var gamepads = ref([]);
    var onConnectedHook = createEventHook();
    var onDisconnectedHook = createEventHook();
    var stateFromGamepad = function (gamepad) {
        var hapticActuators = [];
        var vibrationActuator = "vibrationActuator" in gamepad ? gamepad.vibrationActuator : null;
        if (vibrationActuator)
            hapticActuators.push(vibrationActuator);
        if (gamepad.hapticActuators)
            hapticActuators.push.apply(hapticActuators, __spreadArray([], __read(gamepad.hapticActuators), false));
        return {
            id: gamepad.id,
            index: gamepad.index,
            connected: gamepad.connected,
            mapping: gamepad.mapping,
            timestamp: gamepad.timestamp,
            vibrationActuator: gamepad.vibrationActuator,
            hapticActuators: hapticActuators,
            axes: gamepad.axes.map(function (axes) { return axes; }),
            buttons: gamepad.buttons.map(function (button) { return ({ pressed: button.pressed, touched: button.touched, value: button.value }); })
        };
    };
    var updateGamepadState = function () {
        var e_10, _j;
        var _gamepads = (navigator == null ? void 0 : navigator.getGamepads()) || [];
        try {
            for (var _gamepads_1 = __values(_gamepads), _gamepads_1_1 = _gamepads_1.next(); !_gamepads_1_1.done; _gamepads_1_1 = _gamepads_1.next()) {
                var gamepad = _gamepads_1_1.value;
                if (gamepad && gamepads.value[gamepad.index])
                    gamepads.value[gamepad.index] = stateFromGamepad(gamepad);
            }
        }
        catch (e_10_1) { e_10 = { error: e_10_1 }; }
        finally {
            try {
                if (_gamepads_1_1 && !_gamepads_1_1.done && (_j = _gamepads_1.return)) _j.call(_gamepads_1);
            }
            finally { if (e_10) throw e_10.error; }
        }
    };
    var _k = useRafFn(updateGamepadState), isActive = _k.isActive, pause = _k.pause, resume = _k.resume;
    var onGamepadConnected = function (gamepad) {
        if (!gamepads.value.some(function (_j) {
            var index = _j.index;
            return index === gamepad.index;
        })) {
            gamepads.value.push(stateFromGamepad(gamepad));
            onConnectedHook.trigger(gamepad.index);
        }
        resume();
    };
    var onGamepadDisconnected = function (gamepad) {
        gamepads.value = gamepads.value.filter(function (x) { return x.index !== gamepad.index; });
        onDisconnectedHook.trigger(gamepad.index);
    };
    useEventListener("gamepadconnected", function (e) { return onGamepadConnected(e.gamepad); });
    useEventListener("gamepaddisconnected", function (e) { return onGamepadDisconnected(e.gamepad); });
    tryOnMounted(function () {
        var e_11, _j;
        var _gamepads = (navigator == null ? void 0 : navigator.getGamepads()) || [];
        try {
            for (var _gamepads_2 = __values(_gamepads), _gamepads_2_1 = _gamepads_2.next(); !_gamepads_2_1.done; _gamepads_2_1 = _gamepads_2.next()) {
                var gamepad = _gamepads_2_1.value;
                if (gamepad && gamepads.value[gamepad.index])
                    onGamepadConnected(gamepad);
            }
        }
        catch (e_11_1) { e_11 = { error: e_11_1 }; }
        finally {
            try {
                if (_gamepads_2_1 && !_gamepads_2_1.done && (_j = _gamepads_2.return)) _j.call(_gamepads_2);
            }
            finally { if (e_11) throw e_11.error; }
        }
    });
    pause();
    return {
        isSupported: isSupported,
        onConnected: onConnectedHook.on,
        onDisconnected: onDisconnectedHook.on,
        gamepads: gamepads,
        pause: pause,
        resume: resume,
        isActive: isActive
    };
}
function useGeolocation(options) {
    if (options === void 0) { options = {}; }
    var _j = options.enableHighAccuracy, enableHighAccuracy = _j === void 0 ? true : _j, _k = options.maximumAge, maximumAge = _k === void 0 ? 3e4 : _k, _l = options.timeout, timeout = _l === void 0 ? 27e3 : _l, _m = options.navigator, navigator = _m === void 0 ? defaultNavigator : _m, _o = options.immediate, immediate = _o === void 0 ? true : _o;
    var isSupported = useSupported(function () { return navigator && "geolocation" in navigator; });
    var locatedAt = ref(null);
    var error = shallowRef(null);
    var coords = ref({
        accuracy: 0,
        latitude: Number.POSITIVE_INFINITY,
        longitude: Number.POSITIVE_INFINITY,
        altitude: null,
        altitudeAccuracy: null,
        heading: null,
        speed: null
    });
    function updatePosition(position) {
        locatedAt.value = position.timestamp;
        coords.value = position.coords;
        error.value = null;
    }
    var watcher;
    function resume() {
        if (isSupported.value) {
            watcher = navigator.geolocation.watchPosition(updatePosition, function (err) { return error.value = err; }, {
                enableHighAccuracy: enableHighAccuracy,
                maximumAge: maximumAge,
                timeout: timeout
            });
        }
    }
    if (immediate)
        resume();
    function pause() {
        if (watcher && navigator)
            navigator.geolocation.clearWatch(watcher);
    }
    tryOnScopeDispose(function () {
        pause();
    });
    return {
        isSupported: isSupported,
        coords: coords,
        locatedAt: locatedAt,
        error: error,
        resume: resume,
        pause: pause
    };
}
var defaultEvents$1 = ["mousemove", "mousedown", "resize", "keydown", "touchstart", "wheel"];
var oneMinute = 6e4;
function useIdle(timeout, options) {
    var e_12, _j;
    if (timeout === void 0) { timeout = oneMinute; }
    if (options === void 0) { options = {}; }
    var _k = options.initialState, initialState = _k === void 0 ? false : _k, _l = options.listenForVisibilityChange, listenForVisibilityChange = _l === void 0 ? true : _l, _m = options.events, events = _m === void 0 ? defaultEvents$1 : _m, _o = options.window, window = _o === void 0 ? defaultWindow : _o, _p = options.eventFilter, eventFilter = _p === void 0 ? throttleFilter(50) : _p;
    var idle = ref(initialState);
    var lastActive = ref(timestamp());
    var timer;
    var reset = function () {
        idle.value = false;
        clearTimeout(timer);
        timer = setTimeout(function () { return idle.value = true; }, timeout);
    };
    var onEvent = createFilterWrapper(eventFilter, function () {
        lastActive.value = timestamp();
        reset();
    });
    if (window) {
        var document_1 = window.document;
        try {
            for (var events_2 = __values(events), events_2_1 = events_2.next(); !events_2_1.done; events_2_1 = events_2.next()) {
                var event = events_2_1.value;
                useEventListener(window, event, onEvent, { passive: true });
            }
        }
        catch (e_12_1) { e_12 = { error: e_12_1 }; }
        finally {
            try {
                if (events_2_1 && !events_2_1.done && (_j = events_2.return)) _j.call(events_2);
            }
            finally { if (e_12) throw e_12.error; }
        }
        if (listenForVisibilityChange) {
            useEventListener(document_1, "visibilitychange", function () {
                if (!document_1.hidden)
                    onEvent();
            });
        }
        reset();
    }
    return {
        idle: idle,
        lastActive: lastActive,
        reset: reset
    };
}
function loadImage(options) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_j) {
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    var img = new Image();
                    var src = options.src, srcset = options.srcset, sizes = options.sizes, clazz = options.class, loading = options.loading, crossorigin = options.crossorigin, referrerPolicy = options.referrerPolicy;
                    img.src = src;
                    if (srcset)
                        img.srcset = srcset;
                    if (sizes)
                        img.sizes = sizes;
                    if (clazz)
                        img.className = clazz;
                    if (loading)
                        img.loading = loading;
                    if (crossorigin)
                        img.crossOrigin = crossorigin;
                    if (referrerPolicy)
                        img.referrerPolicy = referrerPolicy;
                    img.onload = function () { return resolve(img); };
                    img.onerror = reject;
                })];
        });
    });
}
function useImage(options, asyncStateOptions) {
    if (asyncStateOptions === void 0) { asyncStateOptions = {}; }
    var state = useAsyncState(function () { return loadImage(toValue(options)); }, void 0, __assign({ resetOnExecute: true }, asyncStateOptions));
    watch(function () { return toValue(options); }, function () { return state.execute(asyncStateOptions.delay); }, { deep: true });
    return state;
}
var ARRIVED_STATE_THRESHOLD_PIXELS = 1;
function useScroll(element, options) {
    if (options === void 0) { options = {}; }
    var _j = options.throttle, throttle = _j === void 0 ? 0 : _j, _k = options.idle, idle = _k === void 0 ? 200 : _k, _l = options.onStop, onStop = _l === void 0 ? noop : _l, _m = options.onScroll, onScroll = _m === void 0 ? noop : _m, _o = options.offset, offset = _o === void 0 ? {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0
    } : _o, _p = options.eventListenerOptions, eventListenerOptions = _p === void 0 ? {
        capture: false,
        passive: true
    } : _p, _q = options.behavior, behavior = _q === void 0 ? "auto" : _q, _r = options.window, window = _r === void 0 ? defaultWindow : _r, _s = options.onError, onError = _s === void 0 ? function (e) {
        console.error(e);
    } : _s;
    var internalX = ref(0);
    var internalY = ref(0);
    var x = computed({
        get: function () {
            return internalX.value;
        },
        set: function (x2) {
            scrollTo(x2, void 0);
        }
    });
    var y = computed({
        get: function () {
            return internalY.value;
        },
        set: function (y2) {
            scrollTo(void 0, y2);
        }
    });
    function scrollTo(_x, _y) {
        var _a, _b, _c, _d;
        if (!window)
            return;
        var _element = toValue(element);
        if (!_element)
            return;
        (_c = _element instanceof Document ? window.document.body : _element) == null ? void 0 : _c.scrollTo({
            top: (_a = toValue(_y)) != null ? _a : y.value,
            left: (_b = toValue(_x)) != null ? _b : x.value,
            behavior: toValue(behavior)
        });
        var scrollContainer = ((_d = _element == null ? void 0 : _element.document) == null ? void 0 : _d.documentElement) || (_element == null ? void 0 : _element.documentElement) || _element;
        if (x != null)
            internalX.value = scrollContainer.scrollLeft;
        if (y != null)
            internalY.value = scrollContainer.scrollTop;
    }
    var isScrolling = ref(false);
    var arrivedState = reactive({
        left: true,
        right: false,
        top: true,
        bottom: false
    });
    var directions = reactive({
        left: false,
        right: false,
        top: false,
        bottom: false
    });
    var onScrollEnd = function (e) {
        if (!isScrolling.value)
            return;
        isScrolling.value = false;
        directions.left = false;
        directions.right = false;
        directions.top = false;
        directions.bottom = false;
        onStop(e);
    };
    var onScrollEndDebounced = useDebounceFn(onScrollEnd, throttle + idle);
    var setArrivedState = function (target) {
        var _a;
        if (!window)
            return;
        var el = ((_a = target == null ? void 0 : target.document) == null ? void 0 : _a.documentElement) || (target == null ? void 0 : target.documentElement) || unrefElement(target);
        var _j = getComputedStyle(el), display = _j.display, flexDirection = _j.flexDirection;
        var scrollLeft = el.scrollLeft;
        directions.left = scrollLeft < internalX.value;
        directions.right = scrollLeft > internalX.value;
        var left = Math.abs(scrollLeft) <= (offset.left || 0);
        var right = Math.abs(scrollLeft) + el.clientWidth >= el.scrollWidth - (offset.right || 0) - ARRIVED_STATE_THRESHOLD_PIXELS;
        if (display === "flex" && flexDirection === "row-reverse") {
            arrivedState.left = right;
            arrivedState.right = left;
        }
        else {
            arrivedState.left = left;
            arrivedState.right = right;
        }
        internalX.value = scrollLeft;
        var scrollTop = el.scrollTop;
        if (target === window.document && !scrollTop)
            scrollTop = window.document.body.scrollTop;
        directions.top = scrollTop < internalY.value;
        directions.bottom = scrollTop > internalY.value;
        var top = Math.abs(scrollTop) <= (offset.top || 0);
        var bottom = Math.abs(scrollTop) + el.clientHeight >= el.scrollHeight - (offset.bottom || 0) - ARRIVED_STATE_THRESHOLD_PIXELS;
        if (display === "flex" && flexDirection === "column-reverse") {
            arrivedState.top = bottom;
            arrivedState.bottom = top;
        }
        else {
            arrivedState.top = top;
            arrivedState.bottom = bottom;
        }
        internalY.value = scrollTop;
    };
    var onScrollHandler = function (e) {
        var _a;
        if (!window)
            return;
        var eventTarget = (_a = e.target.documentElement) != null ? _a : e.target;
        setArrivedState(eventTarget);
        isScrolling.value = true;
        onScrollEndDebounced(e);
        onScroll(e);
    };
    useEventListener(element, "scroll", throttle ? useThrottleFn(onScrollHandler, throttle, true, false) : onScrollHandler, eventListenerOptions);
    tryOnMounted(function () {
        try {
            var _element = toValue(element);
            if (!_element)
                return;
            setArrivedState(_element);
        }
        catch (e) {
            onError(e);
        }
    });
    useEventListener(element, "scrollend", onScrollEnd, eventListenerOptions);
    return {
        x: x,
        y: y,
        isScrolling: isScrolling,
        arrivedState: arrivedState,
        directions: directions,
        measure: function () {
            var _element = toValue(element);
            if (window && _element)
                setArrivedState(_element);
        }
    };
}
function resolveElement(el) {
    if (typeof Window !== "undefined" && el instanceof Window)
        return el.document.documentElement;
    if (typeof Document !== "undefined" && el instanceof Document)
        return el.documentElement;
    return el;
}
function useInfiniteScroll(element, onLoadMore, options) {
    var _j;
    if (options === void 0) { options = {}; }
    var _a;
    var _k = options.direction, direction = _k === void 0 ? "bottom" : _k, _l = options.interval, interval = _l === void 0 ? 100 : _l, _m = options.canLoadMore, canLoadMore = _m === void 0 ? function () { return true; } : _m;
    var state = reactive(useScroll(element, __assign(__assign({}, options), { offset: __assign((_j = {}, _j[direction] = (_a = options.distance) != null ? _a : 0, _j), options.offset) })));
    var promise = ref();
    var isLoading = computed(function () { return !!promise.value; });
    var observedElement = computed(function () {
        return resolveElement(toValue(element));
    });
    var isElementVisible = useElementVisibility(observedElement);
    function checkAndLoad() {
        state.measure();
        if (!observedElement.value || !isElementVisible.value || !canLoadMore(observedElement.value))
            return;
        var _j = observedElement.value, scrollHeight = _j.scrollHeight, clientHeight = _j.clientHeight, scrollWidth = _j.scrollWidth, clientWidth = _j.clientWidth;
        var isNarrower = direction === "bottom" || direction === "top" ? scrollHeight <= clientHeight : scrollWidth <= clientWidth;
        if (state.arrivedState[direction] || isNarrower) {
            if (!promise.value) {
                promise.value = Promise.all([
                    onLoadMore(state),
                    new Promise(function (resolve) { return setTimeout(resolve, interval); })
                ]).finally(function () {
                    promise.value = null;
                    nextTick(function () { return checkAndLoad(); });
                });
            }
        }
    }
    watch(function () { return [state.arrivedState[direction], isElementVisible.value]; }, checkAndLoad, { immediate: true });
    return {
        isLoading: isLoading
    };
}
var defaultEvents = ["mousedown", "mouseup", "keydown", "keyup"];
function useKeyModifier(modifier, options) {
    if (options === void 0) { options = {}; }
    var _j = options.events, events = _j === void 0 ? defaultEvents : _j, _k = options.document, document = _k === void 0 ? defaultDocument : _k, _l = options.initial, initial = _l === void 0 ? null : _l;
    var state = ref(initial);
    if (document) {
        events.forEach(function (listenerEvent) {
            useEventListener(document, listenerEvent, function (evt) {
                if (typeof evt.getModifierState === "function")
                    state.value = evt.getModifierState(modifier);
            });
        });
    }
    return state;
}
function useLocalStorage(key, initialValue, options) {
    if (options === void 0) { options = {}; }
    var _j = options.window, window = _j === void 0 ? defaultWindow : _j;
    return useStorage(key, initialValue, window == null ? void 0 : window.localStorage, options);
}
var DefaultMagicKeysAliasMap = {
    ctrl: "control",
    command: "meta",
    cmd: "meta",
    option: "alt",
    up: "arrowup",
    down: "arrowdown",
    left: "arrowleft",
    right: "arrowright"
};
function useMagicKeys(options) {
    if (options === void 0) { options = {}; }
    var _j = options.reactive, useReactive = _j === void 0 ? false : _j, _k = options.target, target = _k === void 0 ? defaultWindow : _k, _l = options.aliasMap, aliasMap = _l === void 0 ? DefaultMagicKeysAliasMap : _l, _m = options.passive, passive = _m === void 0 ? true : _m, _o = options.onEventFired, onEventFired = _o === void 0 ? noop : _o;
    var current = reactive(/* @__PURE__ */ new Set());
    var obj = {
        toJSON: function () {
            return {};
        },
        current: current
    };
    var refs = useReactive ? reactive(obj) : obj;
    var metaDeps = /* @__PURE__ */ new Set();
    var usedKeys = /* @__PURE__ */ new Set();
    function setRefs(key, value) {
        if (key in refs) {
            if (useReactive)
                refs[key] = value;
            else
                refs[key].value = value;
        }
    }
    function reset() {
        var e_13, _j;
        current.clear();
        try {
            for (var usedKeys_1 = __values(usedKeys), usedKeys_1_1 = usedKeys_1.next(); !usedKeys_1_1.done; usedKeys_1_1 = usedKeys_1.next()) {
                var key = usedKeys_1_1.value;
                setRefs(key, false);
            }
        }
        catch (e_13_1) { e_13 = { error: e_13_1 }; }
        finally {
            try {
                if (usedKeys_1_1 && !usedKeys_1_1.done && (_j = usedKeys_1.return)) _j.call(usedKeys_1);
            }
            finally { if (e_13) throw e_13.error; }
        }
    }
    function updateRefs(e, value) {
        var e_14, _j;
        var _a, _b;
        var key = (_a = e.key) == null ? void 0 : _a.toLowerCase();
        var code = (_b = e.code) == null ? void 0 : _b.toLowerCase();
        var values = [code, key].filter(Boolean);
        if (key) {
            if (value)
                current.add(key);
            else
                current.delete(key);
        }
        try {
            for (var values_1 = __values(values), values_1_1 = values_1.next(); !values_1_1.done; values_1_1 = values_1.next()) {
                var key2 = values_1_1.value;
                usedKeys.add(key2);
                setRefs(key2, value);
            }
        }
        catch (e_14_1) { e_14 = { error: e_14_1 }; }
        finally {
            try {
                if (values_1_1 && !values_1_1.done && (_j = values_1.return)) _j.call(values_1);
            }
            finally { if (e_14) throw e_14.error; }
        }
        if (key === "meta" && !value) {
            metaDeps.forEach(function (key2) {
                current.delete(key2);
                setRefs(key2, false);
            });
            metaDeps.clear();
        }
        else if (typeof e.getModifierState === "function" && e.getModifierState("Meta") && value) {
            __spreadArray(__spreadArray([], __read(current), false), __read(values), false).forEach(function (key2) { return metaDeps.add(key2); });
        }
    }
    useEventListener(target, "keydown", function (e) {
        updateRefs(e, true);
        return onEventFired(e);
    }, { passive: passive });
    useEventListener(target, "keyup", function (e) {
        updateRefs(e, false);
        return onEventFired(e);
    }, { passive: passive });
    useEventListener("blur", reset, { passive: true });
    useEventListener("focus", reset, { passive: true });
    var proxy = new Proxy(refs, {
        get: function (target2, prop, rec) {
            if (typeof prop !== "string")
                return Reflect.get(target2, prop, rec);
            prop = prop.toLowerCase();
            if (prop in aliasMap)
                prop = aliasMap[prop];
            if (!(prop in refs)) {
                if (/[+_-]/.test(prop)) {
                    var keys_1 = prop.split(/[+_-]/g).map(function (i) { return i.trim(); });
                    refs[prop] = computed(function () { return keys_1.every(function (key) { return toValue(proxy[key]); }); });
                }
                else {
                    refs[prop] = ref(false);
                }
            }
            var r = Reflect.get(target2, prop, rec);
            return useReactive ? toValue(r) : r;
        }
    });
    return proxy;
}
function usingElRef(source, cb) {
    if (toValue(source))
        cb(toValue(source));
}
function timeRangeToArray(timeRanges) {
    var ranges = [];
    for (var i = 0; i < timeRanges.length; ++i)
        ranges = __spreadArray(__spreadArray([], __read(ranges), false), [[timeRanges.start(i), timeRanges.end(i)]], false);
    return ranges;
}
function tracksToArray(tracks) {
    return Array.from(tracks).map(function (_j, id) {
        var label = _j.label, kind = _j.kind, language = _j.language, mode = _j.mode, activeCues = _j.activeCues, cues = _j.cues, inBandMetadataTrackDispatchType = _j.inBandMetadataTrackDispatchType;
        return ({ id: id, label: label, kind: kind, language: language, mode: mode, activeCues: activeCues, cues: cues, inBandMetadataTrackDispatchType: inBandMetadataTrackDispatchType });
    });
}
var defaultOptions = {
    src: "",
    tracks: []
};
function useMediaControls(target, options) {
    var _this = this;
    if (options === void 0) { options = {}; }
    target = toRef(target);
    options = __assign(__assign({}, defaultOptions), options);
    var _j = options.document, document = _j === void 0 ? defaultDocument : _j;
    var currentTime = ref(0);
    var duration = ref(0);
    var seeking = ref(false);
    var volume = ref(1);
    var waiting = ref(false);
    var ended = ref(false);
    var playing = ref(false);
    var rate = ref(1);
    var stalled = ref(false);
    var buffered = ref([]);
    var tracks = ref([]);
    var selectedTrack = ref(-1);
    var isPictureInPicture = ref(false);
    var muted = ref(false);
    var supportsPictureInPicture = document && "pictureInPictureEnabled" in document;
    var sourceErrorEvent = createEventHook();
    var disableTrack = function (track) {
        usingElRef(target, function (el) {
            if (track) {
                var id = typeof track === "number" ? track : track.id;
                el.textTracks[id].mode = "disabled";
            }
            else {
                for (var i = 0; i < el.textTracks.length; ++i)
                    el.textTracks[i].mode = "disabled";
            }
            selectedTrack.value = -1;
        });
    };
    var enableTrack = function (track, disableTracks) {
        if (disableTracks === void 0) { disableTracks = true; }
        usingElRef(target, function (el) {
            var id = typeof track === "number" ? track : track.id;
            if (disableTracks)
                disableTrack();
            el.textTracks[id].mode = "showing";
            selectedTrack.value = id;
        });
    };
    var togglePictureInPicture = function () {
        return new Promise(function (resolve, reject) {
            usingElRef(target, function (el) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_j) {
                    if (supportsPictureInPicture) {
                        if (!isPictureInPicture.value) {
                            el.requestPictureInPicture().then(resolve).catch(reject);
                        }
                        else {
                            document.exitPictureInPicture().then(resolve).catch(reject);
                        }
                    }
                    return [2 /*return*/];
                });
            }); });
        });
    };
    watchEffect(function () {
        if (!document)
            return;
        var el = toValue(target);
        if (!el)
            return;
        var src = toValue(options.src);
        var sources = [];
        if (!src)
            return;
        if (typeof src === "string")
            sources = [{ src: src }];
        else if (Array.isArray(src))
            sources = src;
        else if (isObject(src))
            sources = [src];
        el.querySelectorAll("source").forEach(function (e) {
            e.removeEventListener("error", sourceErrorEvent.trigger);
            e.remove();
        });
        sources.forEach(function (_j) {
            var src2 = _j.src, type = _j.type;
            var source = document.createElement("source");
            source.setAttribute("src", src2);
            source.setAttribute("type", type || "");
            source.addEventListener("error", sourceErrorEvent.trigger);
            el.appendChild(source);
        });
        el.load();
    });
    tryOnScopeDispose(function () {
        var el = toValue(target);
        if (!el)
            return;
        el.querySelectorAll("source").forEach(function (e) { return e.removeEventListener("error", sourceErrorEvent.trigger); });
    });
    watch([target, volume], function () {
        var el = toValue(target);
        if (!el)
            return;
        el.volume = volume.value;
    });
    watch([target, muted], function () {
        var el = toValue(target);
        if (!el)
            return;
        el.muted = muted.value;
    });
    watch([target, rate], function () {
        var el = toValue(target);
        if (!el)
            return;
        el.playbackRate = rate.value;
    });
    watchEffect(function () {
        if (!document)
            return;
        var textTracks = toValue(options.tracks);
        var el = toValue(target);
        if (!textTracks || !textTracks.length || !el)
            return;
        el.querySelectorAll("track").forEach(function (e) { return e.remove(); });
        textTracks.forEach(function (_j, i) {
            var isDefault = _j.default, kind = _j.kind, label = _j.label, src = _j.src, srcLang = _j.srcLang;
            var track = document.createElement("track");
            track.default = isDefault || false;
            track.kind = kind;
            track.label = label;
            track.src = src;
            track.srclang = srcLang;
            if (track.default)
                selectedTrack.value = i;
            el.appendChild(track);
        });
    });
    var ignoreCurrentTimeUpdates = watchIgnorable(currentTime, function (time) {
        var el = toValue(target);
        if (!el)
            return;
        el.currentTime = time;
    }).ignoreUpdates;
    var ignorePlayingUpdates = watchIgnorable(playing, function (isPlaying) {
        var el = toValue(target);
        if (!el)
            return;
        isPlaying ? el.play() : el.pause();
    }).ignoreUpdates;
    useEventListener(target, "timeupdate", function () { return ignoreCurrentTimeUpdates(function () { return currentTime.value = toValue(target).currentTime; }); });
    useEventListener(target, "durationchange", function () { return duration.value = toValue(target).duration; });
    useEventListener(target, "progress", function () { return buffered.value = timeRangeToArray(toValue(target).buffered); });
    useEventListener(target, "seeking", function () { return seeking.value = true; });
    useEventListener(target, "seeked", function () { return seeking.value = false; });
    useEventListener(target, ["waiting", "loadstart"], function () {
        waiting.value = true;
        ignorePlayingUpdates(function () { return playing.value = false; });
    });
    useEventListener(target, "loadeddata", function () { return waiting.value = false; });
    useEventListener(target, "playing", function () {
        waiting.value = false;
        ended.value = false;
        ignorePlayingUpdates(function () { return playing.value = true; });
    });
    useEventListener(target, "ratechange", function () { return rate.value = toValue(target).playbackRate; });
    useEventListener(target, "stalled", function () { return stalled.value = true; });
    useEventListener(target, "ended", function () { return ended.value = true; });
    useEventListener(target, "pause", function () { return ignorePlayingUpdates(function () { return playing.value = false; }); });
    useEventListener(target, "play", function () { return ignorePlayingUpdates(function () { return playing.value = true; }); });
    useEventListener(target, "enterpictureinpicture", function () { return isPictureInPicture.value = true; });
    useEventListener(target, "leavepictureinpicture", function () { return isPictureInPicture.value = false; });
    useEventListener(target, "volumechange", function () {
        var el = toValue(target);
        if (!el)
            return;
        volume.value = el.volume;
        muted.value = el.muted;
    });
    var listeners = [];
    var stop = watch([target], function () {
        var el = toValue(target);
        if (!el)
            return;
        stop();
        listeners[0] = useEventListener(el.textTracks, "addtrack", function () { return tracks.value = tracksToArray(el.textTracks); });
        listeners[1] = useEventListener(el.textTracks, "removetrack", function () { return tracks.value = tracksToArray(el.textTracks); });
        listeners[2] = useEventListener(el.textTracks, "change", function () { return tracks.value = tracksToArray(el.textTracks); });
    });
    tryOnScopeDispose(function () { return listeners.forEach(function (listener) { return listener(); }); });
    return {
        currentTime: currentTime,
        duration: duration,
        waiting: waiting,
        seeking: seeking,
        ended: ended,
        stalled: stalled,
        buffered: buffered,
        playing: playing,
        rate: rate,
        // Volume
        volume: volume,
        muted: muted,
        // Tracks
        tracks: tracks,
        selectedTrack: selectedTrack,
        enableTrack: enableTrack,
        disableTrack: disableTrack,
        // Picture in Picture
        supportsPictureInPicture: supportsPictureInPicture,
        togglePictureInPicture: togglePictureInPicture,
        isPictureInPicture: isPictureInPicture,
        // Events
        onSourceError: sourceErrorEvent.on
    };
}
function getMapVue2Compat() {
    var data = shallowReactive({});
    return {
        get: function (key) { return data[key]; },
        set: function (key, value) { return set(data, key, value); },
        has: function (key) { return hasOwn(data, key); },
        delete: function (key) { return del(data, key); },
        clear: function () {
            Object.keys(data).forEach(function (key) {
                del(data, key);
            });
        }
    };
}
function useMemoize(resolver, options) {
    var initCache = function () {
        if (options == null ? void 0 : options.cache)
            return shallowReactive(options.cache);
        if (isVue2)
            return getMapVue2Compat();
        return shallowReactive(/* @__PURE__ */ new Map());
    };
    var cache = initCache();
    var generateKey = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return (options == null ? void 0 : options.getKey) ? options.getKey.apply(options, __spreadArray([], __read(args), false)) : JSON.stringify(args);
    };
    var _loadData = function (key) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        cache.set(key, resolver.apply(void 0, __spreadArray([], __read(args), false)));
        return cache.get(key);
    };
    var loadData = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return _loadData.apply(void 0, __spreadArray([generateKey.apply(void 0, __spreadArray([], __read(args), false))], __read(args), false));
    };
    var deleteData = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        cache.delete(generateKey.apply(void 0, __spreadArray([], __read(args), false)));
    };
    var clearData = function () {
        cache.clear();
    };
    var memoized = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var key = generateKey.apply(void 0, __spreadArray([], __read(args), false));
        if (cache.has(key))
            return cache.get(key);
        return _loadData.apply(void 0, __spreadArray([key], __read(args), false));
    };
    memoized.load = loadData;
    memoized.delete = deleteData;
    memoized.clear = clearData;
    memoized.generateKey = generateKey;
    memoized.cache = cache;
    return memoized;
}
function useMemory(options) {
    if (options === void 0) { options = {}; }
    var memory = ref();
    var isSupported = useSupported(function () { return typeof performance !== "undefined" && "memory" in performance; });
    if (isSupported.value) {
        var _j = options.interval, interval = _j === void 0 ? 1e3 : _j;
        useIntervalFn(function () {
            memory.value = performance.memory;
        }, interval, { immediate: options.immediate, immediateCallback: options.immediateCallback });
    }
    return { isSupported: isSupported, memory: memory };
}
var UseMouseBuiltinExtractors = {
    page: function (event) { return [event.pageX, event.pageY]; },
    client: function (event) { return [event.clientX, event.clientY]; },
    screen: function (event) { return [event.screenX, event.screenY]; },
    movement: function (event) { return event instanceof Touch ? null : [event.movementX, event.movementY]; }
};
function useMouse(options) {
    if (options === void 0) { options = {}; }
    var _j = options.type, type = _j === void 0 ? "page" : _j, _k = options.touch, touch = _k === void 0 ? true : _k, _l = options.resetOnTouchEnds, resetOnTouchEnds = _l === void 0 ? false : _l, _m = options.initialValue, initialValue = _m === void 0 ? { x: 0, y: 0 } : _m, _o = options.window, window = _o === void 0 ? defaultWindow : _o, _p = options.target, target = _p === void 0 ? window : _p, _q = options.scroll, scroll = _q === void 0 ? true : _q, eventFilter = options.eventFilter;
    var _prevMouseEvent = null;
    var x = ref(initialValue.x);
    var y = ref(initialValue.y);
    var sourceType = ref(null);
    var extractor = typeof type === "function" ? type : UseMouseBuiltinExtractors[type];
    var mouseHandler = function (event) {
        var _j;
        var result = extractor(event);
        _prevMouseEvent = event;
        if (result) {
            _j = __read(result, 2), x.value = _j[0], y.value = _j[1];
            sourceType.value = "mouse";
        }
    };
    var touchHandler = function (event) {
        var _j;
        if (event.touches.length > 0) {
            var result = extractor(event.touches[0]);
            if (result) {
                _j = __read(result, 2), x.value = _j[0], y.value = _j[1];
                sourceType.value = "touch";
            }
        }
    };
    var scrollHandler = function () {
        if (!_prevMouseEvent || !window)
            return;
        var pos = extractor(_prevMouseEvent);
        if (_prevMouseEvent instanceof MouseEvent && pos) {
            x.value = pos[0] + window.scrollX;
            y.value = pos[1] + window.scrollY;
        }
    };
    var reset = function () {
        x.value = initialValue.x;
        y.value = initialValue.y;
    };
    var mouseHandlerWrapper = eventFilter ? function (event) { return eventFilter(function () { return mouseHandler(event); }, {}); } : function (event) { return mouseHandler(event); };
    var touchHandlerWrapper = eventFilter ? function (event) { return eventFilter(function () { return touchHandler(event); }, {}); } : function (event) { return touchHandler(event); };
    var scrollHandlerWrapper = eventFilter ? function () { return eventFilter(function () { return scrollHandler(); }, {}); } : function () { return scrollHandler(); };
    if (target) {
        var listenerOptions = { passive: true };
        useEventListener(target, ["mousemove", "dragover"], mouseHandlerWrapper, listenerOptions);
        if (touch && type !== "movement") {
            useEventListener(target, ["touchstart", "touchmove"], touchHandlerWrapper, listenerOptions);
            if (resetOnTouchEnds)
                useEventListener(target, "touchend", reset, listenerOptions);
        }
        if (scroll && type === "page")
            useEventListener(window, "scroll", scrollHandlerWrapper, { passive: true });
    }
    return {
        x: x,
        y: y,
        sourceType: sourceType
    };
}
function useMouseInElement(target, options) {
    if (options === void 0) { options = {}; }
    var _j = options.handleOutside, handleOutside = _j === void 0 ? true : _j, _k = options.window, window = _k === void 0 ? defaultWindow : _k;
    var type = options.type || "page";
    var _l = useMouse(options), x = _l.x, y = _l.y, sourceType = _l.sourceType;
    var targetRef = ref(target != null ? target : window == null ? void 0 : window.document.body);
    var elementX = ref(0);
    var elementY = ref(0);
    var elementPositionX = ref(0);
    var elementPositionY = ref(0);
    var elementHeight = ref(0);
    var elementWidth = ref(0);
    var isOutside = ref(true);
    var stop = function () {
    };
    if (window) {
        stop = watch([targetRef, x, y], function () {
            var el = unrefElement(targetRef);
            if (!el)
                return;
            var _j = el.getBoundingClientRect(), left = _j.left, top = _j.top, width = _j.width, height = _j.height;
            elementPositionX.value = left + (type === "page" ? window.pageXOffset : 0);
            elementPositionY.value = top + (type === "page" ? window.pageYOffset : 0);
            elementHeight.value = height;
            elementWidth.value = width;
            var elX = x.value - elementPositionX.value;
            var elY = y.value - elementPositionY.value;
            isOutside.value = width === 0 || height === 0 || elX < 0 || elY < 0 || elX > width || elY > height;
            if (handleOutside || !isOutside.value) {
                elementX.value = elX;
                elementY.value = elY;
            }
        }, { immediate: true });
        useEventListener(document, "mouseleave", function () {
            isOutside.value = true;
        });
    }
    return {
        x: x,
        y: y,
        sourceType: sourceType,
        elementX: elementX,
        elementY: elementY,
        elementPositionX: elementPositionX,
        elementPositionY: elementPositionY,
        elementHeight: elementHeight,
        elementWidth: elementWidth,
        isOutside: isOutside,
        stop: stop
    };
}
function useMousePressed(options) {
    if (options === void 0) { options = {}; }
    var _j = options.touch, touch = _j === void 0 ? true : _j, _k = options.drag, drag = _k === void 0 ? true : _k, _l = options.capture, capture = _l === void 0 ? false : _l, _m = options.initialValue, initialValue = _m === void 0 ? false : _m, _o = options.window, window = _o === void 0 ? defaultWindow : _o;
    var pressed = ref(initialValue);
    var sourceType = ref(null);
    if (!window) {
        return {
            pressed: pressed,
            sourceType: sourceType
        };
    }
    var onPressed = function (srcType) { return function () {
        pressed.value = true;
        sourceType.value = srcType;
    }; };
    var onReleased = function () {
        pressed.value = false;
        sourceType.value = null;
    };
    var target = computed(function () { return unrefElement(options.target) || window; });
    useEventListener(target, "mousedown", onPressed("mouse"), { passive: true, capture: capture });
    useEventListener(window, "mouseleave", onReleased, { passive: true, capture: capture });
    useEventListener(window, "mouseup", onReleased, { passive: true, capture: capture });
    if (drag) {
        useEventListener(target, "dragstart", onPressed("mouse"), { passive: true, capture: capture });
        useEventListener(window, "drop", onReleased, { passive: true, capture: capture });
        useEventListener(window, "dragend", onReleased, { passive: true, capture: capture });
    }
    if (touch) {
        useEventListener(target, "touchstart", onPressed("touch"), { passive: true, capture: capture });
        useEventListener(window, "touchend", onReleased, { passive: true, capture: capture });
        useEventListener(window, "touchcancel", onReleased, { passive: true, capture: capture });
    }
    return {
        pressed: pressed,
        sourceType: sourceType
    };
}
function useNavigatorLanguage(options) {
    if (options === void 0) { options = {}; }
    var _j = options.window, window = _j === void 0 ? defaultWindow : _j;
    var navigator = window == null ? void 0 : window.navigator;
    var isSupported = useSupported(function () { return navigator && "language" in navigator; });
    var language = ref(navigator == null ? void 0 : navigator.language);
    useEventListener(window, "languagechange", function () {
        if (navigator)
            language.value = navigator.language;
    });
    return {
        isSupported: isSupported,
        language: language
    };
}
function useNetwork(options) {
    if (options === void 0) { options = {}; }
    var _j = options.window, window = _j === void 0 ? defaultWindow : _j;
    var navigator = window == null ? void 0 : window.navigator;
    var isSupported = useSupported(function () { return navigator && "connection" in navigator; });
    var isOnline = ref(true);
    var saveData = ref(false);
    var offlineAt = ref(void 0);
    var onlineAt = ref(void 0);
    var downlink = ref(void 0);
    var downlinkMax = ref(void 0);
    var rtt = ref(void 0);
    var effectiveType = ref(void 0);
    var type = ref("unknown");
    var connection = isSupported.value && navigator.connection;
    function updateNetworkInformation() {
        if (!navigator)
            return;
        isOnline.value = navigator.onLine;
        offlineAt.value = isOnline.value ? void 0 : Date.now();
        onlineAt.value = isOnline.value ? Date.now() : void 0;
        if (connection) {
            downlink.value = connection.downlink;
            downlinkMax.value = connection.downlinkMax;
            effectiveType.value = connection.effectiveType;
            rtt.value = connection.rtt;
            saveData.value = connection.saveData;
            type.value = connection.type;
        }
    }
    if (window) {
        useEventListener(window, "offline", function () {
            isOnline.value = false;
            offlineAt.value = Date.now();
        });
        useEventListener(window, "online", function () {
            isOnline.value = true;
            onlineAt.value = Date.now();
        });
    }
    if (connection)
        useEventListener(connection, "change", updateNetworkInformation, false);
    updateNetworkInformation();
    return {
        isSupported: isSupported,
        isOnline: isOnline,
        saveData: saveData,
        offlineAt: offlineAt,
        onlineAt: onlineAt,
        downlink: downlink,
        downlinkMax: downlinkMax,
        effectiveType: effectiveType,
        rtt: rtt,
        type: type
    };
}
function useNow(options) {
    if (options === void 0) { options = {}; }
    var _j = options.controls, exposeControls = _j === void 0 ? false : _j, _k = options.interval, interval = _k === void 0 ? "requestAnimationFrame" : _k;
    var now = ref(/* @__PURE__ */ new Date());
    var update = function () { return now.value = /* @__PURE__ */ new Date(); };
    var controls = interval === "requestAnimationFrame" ? useRafFn(update, { immediate: true }) : useIntervalFn(update, interval, { immediate: true });
    if (exposeControls) {
        return __assign({ now: now }, controls);
    }
    else {
        return now;
    }
}
function useObjectUrl(object) {
    var url = ref();
    var release = function () {
        if (url.value)
            URL.revokeObjectURL(url.value);
        url.value = void 0;
    };
    watch(function () { return toValue(object); }, function (newObject) {
        release();
        if (newObject)
            url.value = URL.createObjectURL(newObject);
    }, { immediate: true });
    tryOnScopeDispose(release);
    return readonly(url);
}
function useClamp(value, min, max) {
    if (typeof value === "function" || isReadonly(value))
        return computed(function () { return clamp(toValue(value), toValue(min), toValue(max)); });
    var _value = ref(value);
    return computed({
        get: function () {
            return _value.value = clamp(_value.value, toValue(min), toValue(max));
        },
        set: function (value2) {
            _value.value = clamp(value2, toValue(min), toValue(max));
        }
    });
}
function useOffsetPagination(options) {
    var _j = options.total, total = _j === void 0 ? Number.POSITIVE_INFINITY : _j, _k = options.pageSize, pageSize = _k === void 0 ? 10 : _k, _l = options.page, page = _l === void 0 ? 1 : _l, _m = options.onPageChange, onPageChange = _m === void 0 ? noop : _m, _o = options.onPageSizeChange, onPageSizeChange = _o === void 0 ? noop : _o, _p = options.onPageCountChange, onPageCountChange = _p === void 0 ? noop : _p;
    var currentPageSize = useClamp(pageSize, 1, Number.POSITIVE_INFINITY);
    var pageCount = computed(function () { return Math.max(1, Math.ceil(toValue(total) / toValue(currentPageSize))); });
    var currentPage = useClamp(page, 1, pageCount);
    var isFirstPage = computed(function () { return currentPage.value === 1; });
    var isLastPage = computed(function () { return currentPage.value === pageCount.value; });
    if (isRef(page)) {
        syncRef(page, currentPage, {
            direction: isReadonly(page) ? "ltr" : "both"
        });
    }
    if (isRef(pageSize)) {
        syncRef(pageSize, currentPageSize, {
            direction: isReadonly(pageSize) ? "ltr" : "both"
        });
    }
    function prev() {
        currentPage.value--;
    }
    function next() {
        currentPage.value++;
    }
    var returnValue = {
        currentPage: currentPage,
        currentPageSize: currentPageSize,
        pageCount: pageCount,
        isFirstPage: isFirstPage,
        isLastPage: isLastPage,
        prev: prev,
        next: next
    };
    watch(currentPage, function () {
        onPageChange(reactive(returnValue));
    });
    watch(currentPageSize, function () {
        onPageSizeChange(reactive(returnValue));
    });
    watch(pageCount, function () {
        onPageCountChange(reactive(returnValue));
    });
    return returnValue;
}
function useOnline(options) {
    if (options === void 0) { options = {}; }
    var isOnline = useNetwork(options).isOnline;
    return isOnline;
}
function usePageLeave(options) {
    if (options === void 0) { options = {}; }
    var _j = options.window, window = _j === void 0 ? defaultWindow : _j;
    var isLeft = ref(false);
    var handler = function (event) {
        if (!window)
            return;
        event = event || window.event;
        var from = event.relatedTarget || event.toElement;
        isLeft.value = !from;
    };
    if (window) {
        useEventListener(window, "mouseout", handler, { passive: true });
        useEventListener(window.document, "mouseleave", handler, { passive: true });
        useEventListener(window.document, "mouseenter", handler, { passive: true });
    }
    return isLeft;
}
function useScreenOrientation(options) {
    if (options === void 0) { options = {}; }
    var _j = options.window, window = _j === void 0 ? defaultWindow : _j;
    var isSupported = useSupported(function () { return window && "screen" in window && "orientation" in window.screen; });
    var screenOrientation = isSupported.value ? window.screen.orientation : {};
    var orientation = ref(screenOrientation.type);
    var angle = ref(screenOrientation.angle || 0);
    if (isSupported.value) {
        useEventListener(window, "orientationchange", function () {
            orientation.value = screenOrientation.type;
            angle.value = screenOrientation.angle;
        });
    }
    var lockOrientation = function (type) {
        if (isSupported.value && typeof screenOrientation.lock === "function")
            return screenOrientation.lock(type);
        return Promise.reject(new Error("Not supported"));
    };
    var unlockOrientation = function () {
        if (isSupported.value && typeof screenOrientation.unlock === "function")
            screenOrientation.unlock();
    };
    return {
        isSupported: isSupported,
        orientation: orientation,
        angle: angle,
        lockOrientation: lockOrientation,
        unlockOrientation: unlockOrientation
    };
}
function useParallax(target, options) {
    if (options === void 0) { options = {}; }
    var _j = options.deviceOrientationTiltAdjust, deviceOrientationTiltAdjust = _j === void 0 ? function (i) { return i; } : _j, _k = options.deviceOrientationRollAdjust, deviceOrientationRollAdjust = _k === void 0 ? function (i) { return i; } : _k, _l = options.mouseTiltAdjust, mouseTiltAdjust = _l === void 0 ? function (i) { return i; } : _l, _m = options.mouseRollAdjust, mouseRollAdjust = _m === void 0 ? function (i) { return i; } : _m, _o = options.window, window = _o === void 0 ? defaultWindow : _o;
    var orientation = reactive(useDeviceOrientation({ window: window }));
    var screenOrientation = reactive(useScreenOrientation({ window: window }));
    var _p = useMouseInElement(target, { handleOutside: false, window: window }), x = _p.elementX, y = _p.elementY, width = _p.elementWidth, height = _p.elementHeight;
    var source = computed(function () {
        if (orientation.isSupported && (orientation.alpha != null && orientation.alpha !== 0 || orientation.gamma != null && orientation.gamma !== 0)) {
            return "deviceOrientation";
        }
        return "mouse";
    });
    var roll = computed(function () {
        if (source.value === "deviceOrientation") {
            var value = void 0;
            switch (screenOrientation.orientation) {
                case "landscape-primary":
                    value = orientation.gamma / 90;
                    break;
                case "landscape-secondary":
                    value = -orientation.gamma / 90;
                    break;
                case "portrait-primary":
                    value = -orientation.beta / 90;
                    break;
                case "portrait-secondary":
                    value = orientation.beta / 90;
                    break;
                default:
                    value = -orientation.beta / 90;
            }
            return deviceOrientationRollAdjust(value);
        }
        else {
            var value = -(y.value - height.value / 2) / height.value;
            return mouseRollAdjust(value);
        }
    });
    var tilt = computed(function () {
        if (source.value === "deviceOrientation") {
            var value = void 0;
            switch (screenOrientation.orientation) {
                case "landscape-primary":
                    value = orientation.beta / 90;
                    break;
                case "landscape-secondary":
                    value = -orientation.beta / 90;
                    break;
                case "portrait-primary":
                    value = orientation.gamma / 90;
                    break;
                case "portrait-secondary":
                    value = -orientation.gamma / 90;
                    break;
                default:
                    value = orientation.gamma / 90;
            }
            return deviceOrientationTiltAdjust(value);
        }
        else {
            var value = (x.value - width.value / 2) / width.value;
            return mouseTiltAdjust(value);
        }
    });
    return { roll: roll, tilt: tilt, source: source };
}
function useParentElement(element) {
    if (element === void 0) { element = useCurrentElement(); }
    var parentElement = shallowRef();
    var update = function () {
        var el = unrefElement(element);
        if (el)
            parentElement.value = el.parentElement;
    };
    tryOnMounted(update);
    watch(function () { return toValue(element); }, update);
    return parentElement;
}
function usePerformanceObserver(options, callback) {
    var _j = options.window, window = _j === void 0 ? defaultWindow : _j, _k = options.immediate, immediate = _k === void 0 ? true : _k, performanceOptions = __rest(options, ["window", "immediate"]);
    var isSupported = useSupported(function () { return window && "PerformanceObserver" in window; });
    var observer;
    var stop = function () {
        observer == null ? void 0 : observer.disconnect();
    };
    var start = function () {
        if (isSupported.value) {
            stop();
            observer = new PerformanceObserver(callback);
            observer.observe(performanceOptions);
        }
    };
    tryOnScopeDispose(stop);
    if (immediate)
        start();
    return {
        isSupported: isSupported,
        start: start,
        stop: stop
    };
}
var defaultState = {
    x: 0,
    y: 0,
    pointerId: 0,
    pressure: 0,
    tiltX: 0,
    tiltY: 0,
    width: 0,
    height: 0,
    twist: 0,
    pointerType: null
};
var keys = /* @__PURE__ */ Object.keys(defaultState);
function usePointer(options) {
    if (options === void 0) { options = {}; }
    var _j = options.target, target = _j === void 0 ? defaultWindow : _j;
    var isInside = ref(false);
    var state = ref(options.initialValue || {});
    Object.assign(state.value, defaultState, state.value);
    var handler = function (event) {
        isInside.value = true;
        if (options.pointerTypes && !options.pointerTypes.includes(event.pointerType))
            return;
        state.value = objectPick(event, keys, false);
    };
    if (target) {
        var listenerOptions = { passive: true };
        useEventListener(target, ["pointerdown", "pointermove", "pointerup"], handler, listenerOptions);
        useEventListener(target, "pointerleave", function () { return isInside.value = false; }, listenerOptions);
    }
    return __assign(__assign({}, toRefs(state)), { isInside: isInside });
}
function usePointerLock(target, options) {
    if (options === void 0) { options = {}; }
    var _j = options.document, document = _j === void 0 ? defaultDocument : _j;
    var isSupported = useSupported(function () { return document && "pointerLockElement" in document; });
    var element = ref();
    var triggerElement = ref();
    var targetElement;
    if (isSupported.value) {
        useEventListener(document, "pointerlockchange", function () {
            var _a;
            var currentElement = (_a = document.pointerLockElement) != null ? _a : element.value;
            if (targetElement && currentElement === targetElement) {
                element.value = document.pointerLockElement;
                if (!element.value)
                    targetElement = triggerElement.value = null;
            }
        });
        useEventListener(document, "pointerlockerror", function () {
            var _a;
            var currentElement = (_a = document.pointerLockElement) != null ? _a : element.value;
            if (targetElement && currentElement === targetElement) {
                var action = document.pointerLockElement ? "release" : "acquire";
                throw new Error("Failed to ".concat(action, " pointer lock."));
            }
        });
    }
    function lock(e) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_j) {
                switch (_j.label) {
                    case 0:
                        if (!isSupported.value)
                            throw new Error("Pointer Lock API is not supported by your browser.");
                        triggerElement.value = e instanceof Event ? e.currentTarget : null;
                        targetElement = e instanceof Event ? (_a = unrefElement(target)) != null ? _a : triggerElement.value : unrefElement(e);
                        if (!targetElement)
                            throw new Error("Target element undefined.");
                        targetElement.requestPointerLock();
                        return [4 /*yield*/, until(element).toBe(targetElement)];
                    case 1: return [2 /*return*/, _j.sent()];
                }
            });
        });
    }
    function unlock() {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_j) {
                switch (_j.label) {
                    case 0:
                        if (!element.value)
                            return [2 /*return*/, false];
                        document.exitPointerLock();
                        return [4 /*yield*/, until(element).toBeNull()];
                    case 1:
                        _j.sent();
                        return [2 /*return*/, true];
                }
            });
        });
    }
    return {
        isSupported: isSupported,
        element: element,
        triggerElement: triggerElement,
        lock: lock,
        unlock: unlock
    };
}
function usePointerSwipe(target, options) {
    if (options === void 0) { options = {}; }
    var targetRef = toRef(target);
    var _j = options.threshold, threshold = _j === void 0 ? 50 : _j, onSwipe = options.onSwipe, onSwipeEnd = options.onSwipeEnd, onSwipeStart = options.onSwipeStart, _k = options.disableTextSelect, disableTextSelect = _k === void 0 ? false : _k;
    var posStart = reactive({ x: 0, y: 0 });
    var updatePosStart = function (x, y) {
        posStart.x = x;
        posStart.y = y;
    };
    var posEnd = reactive({ x: 0, y: 0 });
    var updatePosEnd = function (x, y) {
        posEnd.x = x;
        posEnd.y = y;
    };
    var distanceX = computed(function () { return posStart.x - posEnd.x; });
    var distanceY = computed(function () { return posStart.y - posEnd.y; });
    var max = Math.max, abs = Math.abs;
    var isThresholdExceeded = computed(function () { return max(abs(distanceX.value), abs(distanceY.value)) >= threshold; });
    var isSwiping = ref(false);
    var isPointerDown = ref(false);
    var direction = computed(function () {
        if (!isThresholdExceeded.value)
            return "none";
        if (abs(distanceX.value) > abs(distanceY.value)) {
            return distanceX.value > 0 ? "left" : "right";
        }
        else {
            return distanceY.value > 0 ? "up" : "down";
        }
    });
    var eventIsAllowed = function (e) {
        var _a, _b, _c;
        var isReleasingButton = e.buttons === 0;
        var isPrimaryButton = e.buttons === 1;
        return (_c = (_b = (_a = options.pointerTypes) == null ? void 0 : _a.includes(e.pointerType)) != null ? _b : isReleasingButton || isPrimaryButton) != null ? _c : true;
    };
    var stops = [
        useEventListener(target, "pointerdown", function (e) {
            if (!eventIsAllowed(e))
                return;
            isPointerDown.value = true;
            var eventTarget = e.target;
            eventTarget == null ? void 0 : eventTarget.setPointerCapture(e.pointerId);
            var x = e.clientX, y = e.clientY;
            updatePosStart(x, y);
            updatePosEnd(x, y);
            onSwipeStart == null ? void 0 : onSwipeStart(e);
        }),
        useEventListener(target, "pointermove", function (e) {
            if (!eventIsAllowed(e))
                return;
            if (!isPointerDown.value)
                return;
            var x = e.clientX, y = e.clientY;
            updatePosEnd(x, y);
            if (!isSwiping.value && isThresholdExceeded.value)
                isSwiping.value = true;
            if (isSwiping.value)
                onSwipe == null ? void 0 : onSwipe(e);
        }),
        useEventListener(target, "pointerup", function (e) {
            if (!eventIsAllowed(e))
                return;
            if (isSwiping.value)
                onSwipeEnd == null ? void 0 : onSwipeEnd(e, direction.value);
            isPointerDown.value = false;
            isSwiping.value = false;
        })
    ];
    tryOnMounted(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        (_b = (_a = targetRef.value) == null ? void 0 : _a.style) == null ? void 0 : _b.setProperty("touch-action", "none");
        if (disableTextSelect) {
            (_d = (_c = targetRef.value) == null ? void 0 : _c.style) == null ? void 0 : _d.setProperty("-webkit-user-select", "none");
            (_f = (_e = targetRef.value) == null ? void 0 : _e.style) == null ? void 0 : _f.setProperty("-ms-user-select", "none");
            (_h = (_g = targetRef.value) == null ? void 0 : _g.style) == null ? void 0 : _h.setProperty("user-select", "none");
        }
    });
    var stop = function () { return stops.forEach(function (s) { return s(); }); };
    return {
        isSwiping: readonly(isSwiping),
        direction: readonly(direction),
        posStart: readonly(posStart),
        posEnd: readonly(posEnd),
        distanceX: distanceX,
        distanceY: distanceY,
        stop: stop
    };
}
function usePreferredColorScheme(options) {
    var isLight = useMediaQuery("(prefers-color-scheme: light)", options);
    var isDark = useMediaQuery("(prefers-color-scheme: dark)", options);
    return computed(function () {
        if (isDark.value)
            return "dark";
        if (isLight.value)
            return "light";
        return "no-preference";
    });
}
function usePreferredContrast(options) {
    var isMore = useMediaQuery("(prefers-contrast: more)", options);
    var isLess = useMediaQuery("(prefers-contrast: less)", options);
    var isCustom = useMediaQuery("(prefers-contrast: custom)", options);
    return computed(function () {
        if (isMore.value)
            return "more";
        if (isLess.value)
            return "less";
        if (isCustom.value)
            return "custom";
        return "no-preference";
    });
}
function usePreferredLanguages(options) {
    if (options === void 0) { options = {}; }
    var _j = options.window, window = _j === void 0 ? defaultWindow : _j;
    if (!window)
        return ref(["en"]);
    var navigator = window.navigator;
    var value = ref(navigator.languages);
    useEventListener(window, "languagechange", function () {
        value.value = navigator.languages;
    });
    return value;
}
function usePreferredReducedMotion(options) {
    var isReduced = useMediaQuery("(prefers-reduced-motion: reduce)", options);
    return computed(function () {
        if (isReduced.value)
            return "reduce";
        return "no-preference";
    });
}
function usePrevious(value, initialValue) {
    var previous = shallowRef(initialValue);
    watch(toRef(value), function (_, oldValue) {
        previous.value = oldValue;
    }, { flush: "sync" });
    return readonly(previous);
}
var topVarName = "--vueuse-safe-area-top";
var rightVarName = "--vueuse-safe-area-right";
var bottomVarName = "--vueuse-safe-area-bottom";
var leftVarName = "--vueuse-safe-area-left";
function useScreenSafeArea() {
    var top = ref("");
    var right = ref("");
    var bottom = ref("");
    var left = ref("");
    if (isClient) {
        var topCssVar = useCssVar(topVarName);
        var rightCssVar = useCssVar(rightVarName);
        var bottomCssVar = useCssVar(bottomVarName);
        var leftCssVar = useCssVar(leftVarName);
        topCssVar.value = "env(safe-area-inset-top, 0px)";
        rightCssVar.value = "env(safe-area-inset-right, 0px)";
        bottomCssVar.value = "env(safe-area-inset-bottom, 0px)";
        leftCssVar.value = "env(safe-area-inset-left, 0px)";
        update();
        useEventListener("resize", useDebounceFn(update));
    }
    function update() {
        top.value = getValue(topVarName);
        right.value = getValue(rightVarName);
        bottom.value = getValue(bottomVarName);
        left.value = getValue(leftVarName);
    }
    return {
        top: top,
        right: right,
        bottom: bottom,
        left: left,
        update: update
    };
}
function getValue(position) {
    return getComputedStyle(document.documentElement).getPropertyValue(position);
}
function useScriptTag(src, onLoaded, options) {
    if (onLoaded === void 0) { onLoaded = noop; }
    if (options === void 0) { options = {}; }
    var _j = options.immediate, immediate = _j === void 0 ? true : _j, _k = options.manual, manual = _k === void 0 ? false : _k, _l = options.type, type = _l === void 0 ? "text/javascript" : _l, _m = options.async, async = _m === void 0 ? true : _m, crossOrigin = options.crossOrigin, referrerPolicy = options.referrerPolicy, noModule = options.noModule, defer = options.defer, _o = options.document, document = _o === void 0 ? defaultDocument : _o, _p = options.attrs, attrs = _p === void 0 ? {} : _p;
    var scriptTag = ref(null);
    var _promise = null;
    var loadScript = function (waitForScriptLoad) { return new Promise(function (resolve, reject) {
        var resolveWithElement = function (el2) {
            scriptTag.value = el2;
            resolve(el2);
            return el2;
        };
        if (!document) {
            resolve(false);
            return;
        }
        var shouldAppend = false;
        var el = document.querySelector("script[src=\"".concat(toValue(src), "\"]"));
        if (!el) {
            el = document.createElement("script");
            el.type = type;
            el.async = async;
            el.src = toValue(src);
            if (defer)
                el.defer = defer;
            if (crossOrigin)
                el.crossOrigin = crossOrigin;
            if (noModule)
                el.noModule = noModule;
            if (referrerPolicy)
                el.referrerPolicy = referrerPolicy;
            Object.entries(attrs).forEach(function (_j) {
                var _k = __read(_j, 2), name = _k[0], value = _k[1];
                return el == null ? void 0 : el.setAttribute(name, value);
            });
            shouldAppend = true;
        }
        else if (el.hasAttribute("data-loaded")) {
            resolveWithElement(el);
        }
        el.addEventListener("error", function (event) { return reject(event); });
        el.addEventListener("abort", function (event) { return reject(event); });
        el.addEventListener("load", function () {
            el.setAttribute("data-loaded", "true");
            onLoaded(el);
            resolveWithElement(el);
        });
        if (shouldAppend)
            el = document.head.appendChild(el);
        if (!waitForScriptLoad)
            resolveWithElement(el);
    }); };
    var load = function (waitForScriptLoad) {
        if (waitForScriptLoad === void 0) { waitForScriptLoad = true; }
        if (!_promise)
            _promise = loadScript(waitForScriptLoad);
        return _promise;
    };
    var unload = function () {
        if (!document)
            return;
        _promise = null;
        if (scriptTag.value)
            scriptTag.value = null;
        var el = document.querySelector("script[src=\"".concat(toValue(src), "\"]"));
        if (el)
            document.head.removeChild(el);
    };
    if (immediate && !manual)
        tryOnMounted(load);
    if (!manual)
        tryOnUnmounted(unload);
    return { scriptTag: scriptTag, load: load, unload: unload };
}
function checkOverflowScroll(ele) {
    var style = window.getComputedStyle(ele);
    if (style.overflowX === "scroll" || style.overflowY === "scroll" || style.overflowX === "auto" && ele.clientWidth < ele.scrollWidth || style.overflowY === "auto" && ele.clientHeight < ele.scrollHeight) {
        return true;
    }
    else {
        var parent = ele.parentNode;
        if (!parent || parent.tagName === "BODY")
            return false;
        return checkOverflowScroll(parent);
    }
}
function preventDefault(rawEvent) {
    var e = rawEvent || window.event;
    var _target = e.target;
    if (checkOverflowScroll(_target))
        return false;
    if (e.touches.length > 1)
        return true;
    if (e.preventDefault)
        e.preventDefault();
    return false;
}
var elInitialOverflow = /* @__PURE__ */ new WeakMap();
function useScrollLock(element, initialState) {
    if (initialState === void 0) { initialState = false; }
    var isLocked = ref(initialState);
    var stopTouchMoveListener = null;
    var initialOverflow = "";
    watch(toRef(element), function (el) {
        var target = resolveElement(toValue(el));
        if (target) {
            var ele = target;
            if (!elInitialOverflow.get(ele))
                elInitialOverflow.set(ele, ele.style.overflow);
            if (ele.style.overflow !== "hidden")
                initialOverflow = ele.style.overflow;
            if (ele.style.overflow === "hidden")
                return isLocked.value = true;
            if (isLocked.value)
                return ele.style.overflow = "hidden";
        }
    }, {
        immediate: true
    });
    var lock = function () {
        var el = resolveElement(toValue(element));
        if (!el || isLocked.value)
            return;
        if (isIOS) {
            stopTouchMoveListener = useEventListener(el, "touchmove", function (e) {
                preventDefault(e);
            }, { passive: false });
        }
        el.style.overflow = "hidden";
        isLocked.value = true;
    };
    var unlock = function () {
        var el = resolveElement(toValue(element));
        if (!el || !isLocked.value)
            return;
        isIOS && (stopTouchMoveListener == null ? void 0 : stopTouchMoveListener());
        el.style.overflow = initialOverflow;
        elInitialOverflow.delete(el);
        isLocked.value = false;
    };
    tryOnScopeDispose(unlock);
    return computed({
        get: function () {
            return isLocked.value;
        },
        set: function (v) {
            if (v)
                lock();
            else
                unlock();
        }
    });
}
function useSessionStorage(key, initialValue, options) {
    if (options === void 0) { options = {}; }
    var _j = options.window, window = _j === void 0 ? defaultWindow : _j;
    return useStorage(key, initialValue, window == null ? void 0 : window.sessionStorage, options);
}
function useShare(shareOptions, options) {
    var _this = this;
    if (shareOptions === void 0) { shareOptions = {}; }
    if (options === void 0) { options = {}; }
    var _j = options.navigator, navigator = _j === void 0 ? defaultNavigator : _j;
    var _navigator = navigator;
    var isSupported = useSupported(function () { return _navigator && "canShare" in _navigator; });
    var share = function () {
        var args_1 = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args_1[_i] = arguments[_i];
        }
        return __awaiter(_this, __spreadArray([], __read(args_1), false), void 0, function (overrideOptions) {
            var data, granted;
            if (overrideOptions === void 0) { overrideOptions = {}; }
            return __generator(this, function (_j) {
                if (isSupported.value) {
                    data = __assign(__assign({}, toValue(shareOptions)), toValue(overrideOptions));
                    granted = true;
                    if (data.files && _navigator.canShare)
                        granted = _navigator.canShare({ files: data.files });
                    if (granted)
                        return [2 /*return*/, _navigator.share(data)];
                }
                return [2 /*return*/];
            });
        });
    };
    return {
        isSupported: isSupported,
        share: share
    };
}
var defaultSortFn = function (source, compareFn) { return source.sort(compareFn); };
var defaultCompare = function (a, b) { return a - b; };
function useSorted() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var _a, _b, _c, _d;
    var _j = __read(args, 1), source = _j[0];
    var compareFn = defaultCompare;
    var options = {};
    if (args.length === 2) {
        if (typeof args[1] === "object") {
            options = args[1];
            compareFn = (_a = options.compareFn) != null ? _a : defaultCompare;
        }
        else {
            compareFn = (_b = args[1]) != null ? _b : defaultCompare;
        }
    }
    else if (args.length > 2) {
        compareFn = (_c = args[1]) != null ? _c : defaultCompare;
        options = (_d = args[2]) != null ? _d : {};
    }
    var _k = options.dirty, dirty = _k === void 0 ? false : _k, _l = options.sortFn, sortFn = _l === void 0 ? defaultSortFn : _l;
    if (!dirty)
        return computed(function () { return sortFn(__spreadArray([], __read(toValue(source)), false), compareFn); });
    watchEffect(function () {
        var result = sortFn(toValue(source), compareFn);
        if (isRef(source))
            source.value = result;
        else
            source.splice.apply(source, __spreadArray([0, source.length], __read(result), false));
    });
    return source;
}
function useSpeechRecognition(options) {
    if (options === void 0) { options = {}; }
    var _j = options.interimResults, interimResults = _j === void 0 ? true : _j, _k = options.continuous, continuous = _k === void 0 ? true : _k, _l = options.window, window = _l === void 0 ? defaultWindow : _l;
    var lang = toRef(options.lang || "en-US");
    var isListening = ref(false);
    var isFinal = ref(false);
    var result = ref("");
    var error = shallowRef(void 0);
    var toggle = function (value) {
        if (value === void 0) { value = !isListening.value; }
        isListening.value = value;
    };
    var start = function () {
        isListening.value = true;
    };
    var stop = function () {
        isListening.value = false;
    };
    var SpeechRecognition = window && (window.SpeechRecognition || window.webkitSpeechRecognition);
    var isSupported = useSupported(function () { return SpeechRecognition; });
    var recognition;
    if (isSupported.value) {
        recognition = new SpeechRecognition();
        recognition.continuous = continuous;
        recognition.interimResults = interimResults;
        recognition.lang = toValue(lang);
        recognition.onstart = function () {
            isFinal.value = false;
        };
        watch(lang, function (lang2) {
            if (recognition && !isListening.value)
                recognition.lang = lang2;
        });
        recognition.onresult = function (event) {
            var currentResult = event.results[event.resultIndex];
            var transcript = currentResult[0].transcript;
            isFinal.value = currentResult.isFinal;
            result.value = transcript;
            error.value = void 0;
        };
        recognition.onerror = function (event) {
            error.value = event;
        };
        recognition.onend = function () {
            isListening.value = false;
            recognition.lang = toValue(lang);
        };
        watch(isListening, function () {
            if (isListening.value)
                recognition.start();
            else
                recognition.stop();
        });
    }
    tryOnScopeDispose(function () {
        isListening.value = false;
    });
    return {
        isSupported: isSupported,
        isListening: isListening,
        isFinal: isFinal,
        recognition: recognition,
        result: result,
        error: error,
        toggle: toggle,
        start: start,
        stop: stop
    };
}
function useSpeechSynthesis(text, options) {
    if (options === void 0) { options = {}; }
    var _j = options.pitch, pitch = _j === void 0 ? 1 : _j, _k = options.rate, rate = _k === void 0 ? 1 : _k, _l = options.volume, volume = _l === void 0 ? 1 : _l, _m = options.window, window = _m === void 0 ? defaultWindow : _m;
    var synth = window && window.speechSynthesis;
    var isSupported = useSupported(function () { return synth; });
    var isPlaying = ref(false);
    var status = ref("init");
    var spokenText = toRef(text || "");
    var lang = toRef(options.lang || "en-US");
    var error = shallowRef(void 0);
    var toggle = function (value) {
        if (value === void 0) { value = !isPlaying.value; }
        isPlaying.value = value;
    };
    var bindEventsForUtterance = function (utterance2) {
        utterance2.lang = toValue(lang);
        utterance2.voice = toValue(options.voice) || null;
        utterance2.pitch = toValue(pitch);
        utterance2.rate = toValue(rate);
        utterance2.volume = volume;
        utterance2.onstart = function () {
            isPlaying.value = true;
            status.value = "play";
        };
        utterance2.onpause = function () {
            isPlaying.value = false;
            status.value = "pause";
        };
        utterance2.onresume = function () {
            isPlaying.value = true;
            status.value = "play";
        };
        utterance2.onend = function () {
            isPlaying.value = false;
            status.value = "end";
        };
        utterance2.onerror = function (event) {
            error.value = event;
        };
    };
    var utterance = computed(function () {
        isPlaying.value = false;
        status.value = "init";
        var newUtterance = new SpeechSynthesisUtterance(spokenText.value);
        bindEventsForUtterance(newUtterance);
        return newUtterance;
    });
    var speak = function () {
        synth.cancel();
        utterance && synth.speak(utterance.value);
    };
    var stop = function () {
        synth.cancel();
        isPlaying.value = false;
    };
    if (isSupported.value) {
        bindEventsForUtterance(utterance.value);
        watch(lang, function (lang2) {
            if (utterance.value && !isPlaying.value)
                utterance.value.lang = lang2;
        });
        if (options.voice) {
            watch(options.voice, function () {
                synth.cancel();
            });
        }
        watch(isPlaying, function () {
            if (isPlaying.value)
                synth.resume();
            else
                synth.pause();
        });
    }
    tryOnScopeDispose(function () {
        isPlaying.value = false;
    });
    return {
        isSupported: isSupported,
        isPlaying: isPlaying,
        status: status,
        utterance: utterance,
        error: error,
        stop: stop,
        toggle: toggle,
        speak: speak
    };
}
function useStepper(steps, initialStep) {
    var stepsRef = ref(steps);
    var stepNames = computed(function () { return Array.isArray(stepsRef.value) ? stepsRef.value : Object.keys(stepsRef.value); });
    var index = ref(stepNames.value.indexOf(initialStep != null ? initialStep : stepNames.value[0]));
    var current = computed(function () { return at(index.value); });
    var isFirst = computed(function () { return index.value === 0; });
    var isLast = computed(function () { return index.value === stepNames.value.length - 1; });
    var next = computed(function () { return stepNames.value[index.value + 1]; });
    var previous = computed(function () { return stepNames.value[index.value - 1]; });
    function at(index2) {
        if (Array.isArray(stepsRef.value))
            return stepsRef.value[index2];
        return stepsRef.value[stepNames.value[index2]];
    }
    function get(step) {
        if (!stepNames.value.includes(step))
            return;
        return at(stepNames.value.indexOf(step));
    }
    function goTo(step) {
        if (stepNames.value.includes(step))
            index.value = stepNames.value.indexOf(step);
    }
    function goToNext() {
        if (isLast.value)
            return;
        index.value++;
    }
    function goToPrevious() {
        if (isFirst.value)
            return;
        index.value--;
    }
    function goBackTo(step) {
        if (isAfter(step))
            goTo(step);
    }
    function isNext(step) {
        return stepNames.value.indexOf(step) === index.value + 1;
    }
    function isPrevious(step) {
        return stepNames.value.indexOf(step) === index.value - 1;
    }
    function isCurrent(step) {
        return stepNames.value.indexOf(step) === index.value;
    }
    function isBefore(step) {
        return index.value < stepNames.value.indexOf(step);
    }
    function isAfter(step) {
        return index.value > stepNames.value.indexOf(step);
    }
    return {
        steps: stepsRef,
        stepNames: stepNames,
        index: index,
        current: current,
        next: next,
        previous: previous,
        isFirst: isFirst,
        isLast: isLast,
        at: at,
        get: get,
        goTo: goTo,
        goToNext: goToNext,
        goToPrevious: goToPrevious,
        goBackTo: goBackTo,
        isNext: isNext,
        isPrevious: isPrevious,
        isCurrent: isCurrent,
        isBefore: isBefore,
        isAfter: isAfter
    };
}
function useStorageAsync(key, initialValue, storage, options) {
    var _this = this;
    if (options === void 0) { options = {}; }
    var _a;
    var _j = options.flush, flush = _j === void 0 ? "pre" : _j, _k = options.deep, deep = _k === void 0 ? true : _k, _l = options.listenToStorageChanges, listenToStorageChanges = _l === void 0 ? true : _l, _m = options.writeDefaults, writeDefaults = _m === void 0 ? true : _m, _o = options.mergeDefaults, mergeDefaults = _o === void 0 ? false : _o, shallow = options.shallow, _p = options.window, window = _p === void 0 ? defaultWindow : _p, eventFilter = options.eventFilter, _q = options.onError, onError = _q === void 0 ? function (e) {
        console.error(e);
    } : _q;
    var rawInit = toValue(initialValue);
    var type = guessSerializerType(rawInit);
    var data = (shallow ? shallowRef : ref)(initialValue);
    var serializer = (_a = options.serializer) != null ? _a : StorageSerializers[type];
    if (!storage) {
        try {
            storage = getSSRHandler("getDefaultStorageAsync", function () {
                var _a2;
                return (_a2 = defaultWindow) == null ? void 0 : _a2.localStorage;
            })();
        }
        catch (e) {
            onError(e);
        }
    }
    function read(event) {
        return __awaiter(this, void 0, void 0, function () {
            var rawValue, _j, _k, _l, _m, value, _o, e_15;
            return __generator(this, function (_p) {
                switch (_p.label) {
                    case 0:
                        if (!storage || event && event.key !== key)
                            return [2 /*return*/];
                        _p.label = 1;
                    case 1:
                        _p.trys.push([1, 13, , 14]);
                        if (!event) return [3 /*break*/, 2];
                        _j = event.newValue;
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, storage.getItem(key)];
                    case 3:
                        _j = _p.sent();
                        _p.label = 4;
                    case 4:
                        rawValue = _j;
                        if (!(rawValue == null)) return [3 /*break*/, 8];
                        data.value = rawInit;
                        if (!(writeDefaults && rawInit !== null)) return [3 /*break*/, 7];
                        _l = (_k = storage).setItem;
                        _m = [key];
                        return [4 /*yield*/, serializer.write(rawInit)];
                    case 5: return [4 /*yield*/, _l.apply(_k, _m.concat([_p.sent()]))];
                    case 6:
                        _p.sent();
                        _p.label = 7;
                    case 7: return [3 /*break*/, 12];
                    case 8:
                        if (!mergeDefaults) return [3 /*break*/, 10];
                        return [4 /*yield*/, serializer.read(rawValue)];
                    case 9:
                        value = _p.sent();
                        if (typeof mergeDefaults === "function")
                            data.value = mergeDefaults(value, rawInit);
                        else if (type === "object" && !Array.isArray(value))
                            data.value = __assign(__assign({}, rawInit), value);
                        else
                            data.value = value;
                        return [3 /*break*/, 12];
                    case 10:
                        _o = data;
                        return [4 /*yield*/, serializer.read(rawValue)];
                    case 11:
                        _o.value = _p.sent();
                        _p.label = 12;
                    case 12: return [3 /*break*/, 14];
                    case 13:
                        e_15 = _p.sent();
                        onError(e_15);
                        return [3 /*break*/, 14];
                    case 14: return [2 /*return*/];
                }
            });
        });
    }
    read();
    if (window && listenToStorageChanges)
        useEventListener(window, "storage", function (e) { return Promise.resolve().then(function () { return read(e); }); });
    if (storage) {
        watchWithFilter(data, function () { return __awaiter(_this, void 0, void 0, function () {
            var _j, _k, _l, e_16;
            return __generator(this, function (_m) {
                switch (_m.label) {
                    case 0:
                        _m.trys.push([0, 6, , 7]);
                        if (!(data.value == null)) return [3 /*break*/, 2];
                        return [4 /*yield*/, storage.removeItem(key)];
                    case 1:
                        _m.sent();
                        return [3 /*break*/, 5];
                    case 2:
                        _k = (_j = storage).setItem;
                        _l = [key];
                        return [4 /*yield*/, serializer.write(data.value)];
                    case 3: return [4 /*yield*/, _k.apply(_j, _l.concat([_m.sent()]))];
                    case 4:
                        _m.sent();
                        _m.label = 5;
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        e_16 = _m.sent();
                        onError(e_16);
                        return [3 /*break*/, 7];
                    case 7: return [2 /*return*/];
                }
            });
        }); }, {
            flush: flush,
            deep: deep,
            eventFilter: eventFilter
        });
    }
    return data;
}
var _id = 0;
function useStyleTag(css, options) {
    if (options === void 0) { options = {}; }
    var isLoaded = ref(false);
    var _j = options.document, document = _j === void 0 ? defaultDocument : _j, _k = options.immediate, immediate = _k === void 0 ? true : _k, _l = options.manual, manual = _l === void 0 ? false : _l, _m = options.id, id = _m === void 0 ? "vueuse_styletag_".concat(++_id) : _m;
    var cssRef = ref(css);
    var stop = function () {
    };
    var load = function () {
        if (!document)
            return;
        var el = document.getElementById(id) || document.createElement("style");
        if (!el.isConnected) {
            el.id = id;
            if (options.media)
                el.media = options.media;
            document.head.appendChild(el);
        }
        if (isLoaded.value)
            return;
        stop = watch(cssRef, function (value) {
            el.textContent = value;
        }, { immediate: true });
        isLoaded.value = true;
    };
    var unload = function () {
        if (!document || !isLoaded.value)
            return;
        stop();
        document.head.removeChild(document.getElementById(id));
        isLoaded.value = false;
    };
    if (immediate && !manual)
        tryOnMounted(load);
    if (!manual)
        tryOnScopeDispose(unload);
    return {
        id: id,
        css: cssRef,
        unload: unload,
        load: load,
        isLoaded: readonly(isLoaded)
    };
}
function useSwipe(target, options) {
    if (options === void 0) { options = {}; }
    var _j = options.threshold, threshold = _j === void 0 ? 50 : _j, onSwipe = options.onSwipe, onSwipeEnd = options.onSwipeEnd, onSwipeStart = options.onSwipeStart, _k = options.passive, passive = _k === void 0 ? true : _k, _l = options.window, window = _l === void 0 ? defaultWindow : _l;
    var coordsStart = reactive({ x: 0, y: 0 });
    var coordsEnd = reactive({ x: 0, y: 0 });
    var diffX = computed(function () { return coordsStart.x - coordsEnd.x; });
    var diffY = computed(function () { return coordsStart.y - coordsEnd.y; });
    var max = Math.max, abs = Math.abs;
    var isThresholdExceeded = computed(function () { return max(abs(diffX.value), abs(diffY.value)) >= threshold; });
    var isSwiping = ref(false);
    var direction = computed(function () {
        if (!isThresholdExceeded.value)
            return "none";
        if (abs(diffX.value) > abs(diffY.value)) {
            return diffX.value > 0 ? "left" : "right";
        }
        else {
            return diffY.value > 0 ? "up" : "down";
        }
    });
    var getTouchEventCoords = function (e) { return [e.touches[0].clientX, e.touches[0].clientY]; };
    var updateCoordsStart = function (x, y) {
        coordsStart.x = x;
        coordsStart.y = y;
    };
    var updateCoordsEnd = function (x, y) {
        coordsEnd.x = x;
        coordsEnd.y = y;
    };
    var listenerOptions;
    var isPassiveEventSupported = checkPassiveEventSupport(window == null ? void 0 : window.document);
    if (!passive)
        listenerOptions = isPassiveEventSupported ? { passive: false, capture: true } : { capture: true };
    else
        listenerOptions = isPassiveEventSupported ? { passive: true } : { capture: false };
    var onTouchEnd = function (e) {
        if (isSwiping.value)
            onSwipeEnd == null ? void 0 : onSwipeEnd(e, direction.value);
        isSwiping.value = false;
    };
    var stops = [
        useEventListener(target, "touchstart", function (e) {
            if (e.touches.length !== 1)
                return;
            if (listenerOptions.capture && !listenerOptions.passive)
                e.preventDefault();
            var _j = __read(getTouchEventCoords(e), 2), x = _j[0], y = _j[1];
            updateCoordsStart(x, y);
            updateCoordsEnd(x, y);
            onSwipeStart == null ? void 0 : onSwipeStart(e);
        }, listenerOptions),
        useEventListener(target, "touchmove", function (e) {
            if (e.touches.length !== 1)
                return;
            var _j = __read(getTouchEventCoords(e), 2), x = _j[0], y = _j[1];
            updateCoordsEnd(x, y);
            if (!isSwiping.value && isThresholdExceeded.value)
                isSwiping.value = true;
            if (isSwiping.value)
                onSwipe == null ? void 0 : onSwipe(e);
        }, listenerOptions),
        useEventListener(target, ["touchend", "touchcancel"], onTouchEnd, listenerOptions)
    ];
    var stop = function () { return stops.forEach(function (s) { return s(); }); };
    return {
        isPassiveEventSupported: isPassiveEventSupported,
        isSwiping: isSwiping,
        direction: direction,
        coordsStart: coordsStart,
        coordsEnd: coordsEnd,
        lengthX: diffX,
        lengthY: diffY,
        stop: stop
    };
}
function checkPassiveEventSupport(document) {
    if (!document)
        return false;
    var supportsPassive = false;
    var optionsBlock = {
        get passive() {
            supportsPassive = true;
            return false;
        }
    };
    document.addEventListener("x", noop, optionsBlock);
    document.removeEventListener("x", noop);
    return supportsPassive;
}
function useTemplateRefsList() {
    var refs = ref([]);
    refs.value.set = function (el) {
        if (el)
            refs.value.push(el);
    };
    onBeforeUpdate(function () {
        refs.value.length = 0;
    });
    return refs;
}
function useTextDirection(options) {
    if (options === void 0) { options = {}; }
    var _j = options.document, document = _j === void 0 ? defaultDocument : _j, _k = options.selector, selector = _k === void 0 ? "html" : _k, _l = options.observe, observe = _l === void 0 ? false : _l, _m = options.initialValue, initialValue = _m === void 0 ? "ltr" : _m;
    function getValue() {
        var _a, _b;
        return (_b = (_a = document == null ? void 0 : document.querySelector(selector)) == null ? void 0 : _a.getAttribute("dir")) != null ? _b : initialValue;
    }
    var dir = ref(getValue());
    tryOnMounted(function () { return dir.value = getValue(); });
    if (observe && document) {
        useMutationObserver(document.querySelector(selector), function () { return dir.value = getValue(); }, { attributes: true });
    }
    return computed({
        get: function () {
            return dir.value;
        },
        set: function (v) {
            var _a, _b;
            dir.value = v;
            if (!document)
                return;
            if (dir.value)
                (_a = document.querySelector(selector)) == null ? void 0 : _a.setAttribute("dir", dir.value);
            else
                (_b = document.querySelector(selector)) == null ? void 0 : _b.removeAttribute("dir");
        }
    });
}
function getRangesFromSelection(selection) {
    var _a;
    var rangeCount = (_a = selection.rangeCount) != null ? _a : 0;
    return Array.from({ length: rangeCount }, function (_, i) { return selection.getRangeAt(i); });
}
function useTextSelection(options) {
    if (options === void 0) { options = {}; }
    var _j = options.window, window = _j === void 0 ? defaultWindow : _j;
    var selection = ref(null);
    var text = computed(function () {
        var _a, _b;
        return (_b = (_a = selection.value) == null ? void 0 : _a.toString()) != null ? _b : "";
    });
    var ranges = computed(function () { return selection.value ? getRangesFromSelection(selection.value) : []; });
    var rects = computed(function () { return ranges.value.map(function (range) { return range.getBoundingClientRect(); }); });
    function onSelectionChange() {
        selection.value = null;
        if (window)
            selection.value = window.getSelection();
    }
    if (window)
        useEventListener(window.document, "selectionchange", onSelectionChange);
    return {
        text: text,
        rects: rects,
        ranges: ranges,
        selection: selection
    };
}
function useTextareaAutosize(options) {
    var _a;
    var textarea = ref(options == null ? void 0 : options.element);
    var input = ref(options == null ? void 0 : options.input);
    var styleProp = (_a = options == null ? void 0 : options.styleProp) != null ? _a : "height";
    var textareaScrollHeight = ref(1);
    function triggerResize() {
        var _a2;
        if (!textarea.value)
            return;
        var height = "";
        textarea.value.style[styleProp] = "1px";
        textareaScrollHeight.value = (_a2 = textarea.value) == null ? void 0 : _a2.scrollHeight;
        if (options == null ? void 0 : options.styleTarget)
            toValue(options.styleTarget).style[styleProp] = "".concat(textareaScrollHeight.value, "px");
        else
            height = "".concat(textareaScrollHeight.value, "px");
        textarea.value.style[styleProp] = height;
    }
    watch([input, textarea], function () { return nextTick(triggerResize); }, { immediate: true });
    watch(textareaScrollHeight, function () {
        var _a2;
        return (_a2 = options == null ? void 0 : options.onResize) == null ? void 0 : _a2.call(options);
    });
    useResizeObserver(textarea, function () { return triggerResize(); });
    if (options == null ? void 0 : options.watch)
        watch(options.watch, triggerResize, { immediate: true, deep: true });
    return {
        textarea: textarea,
        input: input,
        triggerResize: triggerResize
    };
}
function useThrottledRefHistory(source, options) {
    if (options === void 0) { options = {}; }
    var _j = options.throttle, throttle = _j === void 0 ? 200 : _j, _k = options.trailing, trailing = _k === void 0 ? true : _k;
    var filter = throttleFilter(throttle, trailing);
    var history = useRefHistory(source, __assign(__assign({}, options), { eventFilter: filter }));
    return __assign({}, history);
}
var DEFAULT_UNITS = [
    { max: 6e4, value: 1e3, name: "second" },
    { max: 276e4, value: 6e4, name: "minute" },
    { max: 72e6, value: 36e5, name: "hour" },
    { max: 5184e5, value: 864e5, name: "day" },
    { max: 24192e5, value: 6048e5, name: "week" },
    { max: 28512e6, value: 2592e6, name: "month" },
    { max: Number.POSITIVE_INFINITY, value: 31536e6, name: "year" }
];
var DEFAULT_MESSAGES = {
    justNow: "just now",
    past: function (n) { return n.match(/\d/) ? "".concat(n, " ago") : n; },
    future: function (n) { return n.match(/\d/) ? "in ".concat(n) : n; },
    month: function (n, past) { return n === 1 ? past ? "last month" : "next month" : "".concat(n, " month").concat(n > 1 ? "s" : ""); },
    year: function (n, past) { return n === 1 ? past ? "last year" : "next year" : "".concat(n, " year").concat(n > 1 ? "s" : ""); },
    day: function (n, past) { return n === 1 ? past ? "yesterday" : "tomorrow" : "".concat(n, " day").concat(n > 1 ? "s" : ""); },
    week: function (n, past) { return n === 1 ? past ? "last week" : "next week" : "".concat(n, " week").concat(n > 1 ? "s" : ""); },
    hour: function (n) { return "".concat(n, " hour").concat(n > 1 ? "s" : ""); },
    minute: function (n) { return "".concat(n, " minute").concat(n > 1 ? "s" : ""); },
    second: function (n) { return "".concat(n, " second").concat(n > 1 ? "s" : ""); },
    invalid: ""
};
function DEFAULT_FORMATTER(date) {
    return date.toISOString().slice(0, 10);
}
function useTimeAgo(time, options) {
    if (options === void 0) { options = {}; }
    var _j = options.controls, exposeControls = _j === void 0 ? false : _j, _k = options.updateInterval, updateInterval = _k === void 0 ? 3e4 : _k;
    var _l = useNow({ interval: updateInterval, controls: true }), now = _l.now, controls = __rest(_l, ["now"]);
    var timeAgo = computed(function () { return formatTimeAgo(new Date(toValue(time)), options, toValue(now)); });
    if (exposeControls) {
        return __assign({ timeAgo: timeAgo }, controls);
    }
    else {
        return timeAgo;
    }
}
function formatTimeAgo(from, options, now) {
    var e_17, _j;
    if (options === void 0) { options = {}; }
    if (now === void 0) { now = Date.now(); }
    var _a;
    var max = options.max, _k = options.messages, messages = _k === void 0 ? DEFAULT_MESSAGES : _k, _l = options.fullDateFormatter, fullDateFormatter = _l === void 0 ? DEFAULT_FORMATTER : _l, _m = options.units, units = _m === void 0 ? DEFAULT_UNITS : _m, _o = options.showSecond, showSecond = _o === void 0 ? false : _o, _p = options.rounding, rounding = _p === void 0 ? "round" : _p;
    var roundFn = typeof rounding === "number" ? function (n) { return +n.toFixed(rounding); } : Math[rounding];
    var diff = +now - +from;
    var absDiff = Math.abs(diff);
    function getValue(diff2, unit) {
        return roundFn(Math.abs(diff2) / unit.value);
    }
    function format(diff2, unit) {
        var val = getValue(diff2, unit);
        var past = diff2 > 0;
        var str = applyFormat(unit.name, val, past);
        return applyFormat(past ? "past" : "future", str, past);
    }
    function applyFormat(name, val, isPast) {
        var formatter = messages[name];
        if (typeof formatter === "function")
            return formatter(val, isPast);
        return formatter.replace("{0}", val.toString());
    }
    if (absDiff < 6e4 && !showSecond)
        return messages.justNow;
    if (typeof max === "number" && absDiff > max)
        return fullDateFormatter(new Date(from));
    if (typeof max === "string") {
        var unitMax = (_a = units.find(function (i) { return i.name === max; })) == null ? void 0 : _a.max;
        if (unitMax && absDiff > unitMax)
            return fullDateFormatter(new Date(from));
    }
    try {
        for (var _q = __values(units.entries()), _r = _q.next(); !_r.done; _r = _q.next()) {
            var _s = __read(_r.value, 2), idx = _s[0], unit = _s[1];
            var val = getValue(diff, unit);
            if (val <= 0 && units[idx - 1])
                return format(diff, units[idx - 1]);
            if (absDiff < unit.max)
                return format(diff, unit);
        }
    }
    catch (e_17_1) { e_17 = { error: e_17_1 }; }
    finally {
        try {
            if (_r && !_r.done && (_j = _q.return)) _j.call(_q);
        }
        finally { if (e_17) throw e_17.error; }
    }
    return messages.invalid;
}
function useTimeoutPoll(fn, interval, timeoutPollOptions) {
    var start = useTimeoutFn(loop, interval, { immediate: false }).start;
    var isActive = ref(false);
    function loop() {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_j) {
                switch (_j.label) {
                    case 0:
                        if (!isActive.value)
                            return [2 /*return*/];
                        return [4 /*yield*/, fn()];
                    case 1:
                        _j.sent();
                        start();
                        return [2 /*return*/];
                }
            });
        });
    }
    function resume() {
        if (!isActive.value) {
            isActive.value = true;
            loop();
        }
    }
    function pause() {
        isActive.value = false;
    }
    if (timeoutPollOptions == null ? void 0 : timeoutPollOptions.immediate)
        resume();
    tryOnScopeDispose(pause);
    return {
        isActive: isActive,
        pause: pause,
        resume: resume
    };
}
function useTimestamp(options) {
    if (options === void 0) { options = {}; }
    var _j = options.controls, exposeControls = _j === void 0 ? false : _j, _k = options.offset, offset = _k === void 0 ? 0 : _k, _l = options.immediate, immediate = _l === void 0 ? true : _l, _m = options.interval, interval = _m === void 0 ? "requestAnimationFrame" : _m, callback = options.callback;
    var ts = ref(timestamp() + offset);
    var update = function () { return ts.value = timestamp() + offset; };
    var cb = callback ? function () {
        update();
        callback(ts.value);
    } : update;
    var controls = interval === "requestAnimationFrame" ? useRafFn(cb, { immediate: immediate }) : useIntervalFn(cb, interval, { immediate: immediate });
    if (exposeControls) {
        return __assign({ timestamp: ts }, controls);
    }
    else {
        return ts;
    }
}
function useTitle(newTitle, options) {
    if (newTitle === void 0) { newTitle = null; }
    if (options === void 0) { options = {}; }
    var _a, _b, _c;
    var _j = options.document, document = _j === void 0 ? defaultDocument : _j, _k = options.restoreOnUnmount, restoreOnUnmount = _k === void 0 ? function (t) { return t; } : _k;
    var originalTitle = (_a = document == null ? void 0 : document.title) != null ? _a : "";
    var title = toRef((_b = newTitle != null ? newTitle : document == null ? void 0 : document.title) != null ? _b : null);
    var isReadonly = newTitle && typeof newTitle === "function";
    function format(t) {
        if (!("titleTemplate" in options))
            return t;
        var template = options.titleTemplate || "%s";
        return typeof template === "function" ? template(t) : toValue(template).replace(/%s/g, t);
    }
    watch(title, function (t, o) {
        if (t !== o && document)
            document.title = format(typeof t === "string" ? t : "");
    }, { immediate: true });
    if (options.observe && !options.titleTemplate && document && !isReadonly) {
        useMutationObserver((_c = document.head) == null ? void 0 : _c.querySelector("title"), function () {
            if (document && document.title !== title.value)
                title.value = format(document.title);
        }, { childList: true });
    }
    tryOnBeforeUnmount(function () {
        if (restoreOnUnmount) {
            var restoredTitle = restoreOnUnmount(originalTitle, title.value || "");
            if (restoredTitle != null && document)
                document.title = restoredTitle;
        }
    });
    return title;
}
var _TransitionPresets = {
    easeInSine: [0.12, 0, 0.39, 0],
    easeOutSine: [0.61, 1, 0.88, 1],
    easeInOutSine: [0.37, 0, 0.63, 1],
    easeInQuad: [0.11, 0, 0.5, 0],
    easeOutQuad: [0.5, 1, 0.89, 1],
    easeInOutQuad: [0.45, 0, 0.55, 1],
    easeInCubic: [0.32, 0, 0.67, 0],
    easeOutCubic: [0.33, 1, 0.68, 1],
    easeInOutCubic: [0.65, 0, 0.35, 1],
    easeInQuart: [0.5, 0, 0.75, 0],
    easeOutQuart: [0.25, 1, 0.5, 1],
    easeInOutQuart: [0.76, 0, 0.24, 1],
    easeInQuint: [0.64, 0, 0.78, 0],
    easeOutQuint: [0.22, 1, 0.36, 1],
    easeInOutQuint: [0.83, 0, 0.17, 1],
    easeInExpo: [0.7, 0, 0.84, 0],
    easeOutExpo: [0.16, 1, 0.3, 1],
    easeInOutExpo: [0.87, 0, 0.13, 1],
    easeInCirc: [0.55, 0, 1, 0.45],
    easeOutCirc: [0, 0.55, 0.45, 1],
    easeInOutCirc: [0.85, 0, 0.15, 1],
    easeInBack: [0.36, 0, 0.66, -0.56],
    easeOutBack: [0.34, 1.56, 0.64, 1],
    easeInOutBack: [0.68, -0.6, 0.32, 1.6]
};
var TransitionPresets = /* @__PURE__ */ Object.assign({}, { linear: identity }, _TransitionPresets);
function createEasingFunction(_j) {
    var _k = __read(_j, 4), p0 = _k[0], p1 = _k[1], p2 = _k[2], p3 = _k[3];
    var a = function (a1, a2) { return 1 - 3 * a2 + 3 * a1; };
    var b = function (a1, a2) { return 3 * a2 - 6 * a1; };
    var c = function (a1) { return 3 * a1; };
    var calcBezier = function (t, a1, a2) { return ((a(a1, a2) * t + b(a1, a2)) * t + c(a1)) * t; };
    var getSlope = function (t, a1, a2) { return 3 * a(a1, a2) * t * t + 2 * b(a1, a2) * t + c(a1); };
    var getTforX = function (x) {
        var aGuessT = x;
        for (var i = 0; i < 4; ++i) {
            var currentSlope = getSlope(aGuessT, p0, p2);
            if (currentSlope === 0)
                return aGuessT;
            var currentX = calcBezier(aGuessT, p0, p2) - x;
            aGuessT -= currentX / currentSlope;
        }
        return aGuessT;
    };
    return function (x) { return p0 === p1 && p2 === p3 ? x : calcBezier(getTforX(x), p1, p3); };
}
function lerp(a, b, alpha) {
    return a + alpha * (b - a);
}
function toVec(t) {
    return (typeof t === "number" ? [t] : t) || [];
}
function executeTransition(source, from, to, options) {
    if (options === void 0) { options = {}; }
    var _a, _b;
    var fromVal = toValue(from);
    var toVal = toValue(to);
    var v1 = toVec(fromVal);
    var v2 = toVec(toVal);
    var duration = (_a = toValue(options.duration)) != null ? _a : 1e3;
    var startedAt = Date.now();
    var endAt = Date.now() + duration;
    var trans = typeof options.transition === "function" ? options.transition : (_b = toValue(options.transition)) != null ? _b : identity;
    var ease = typeof trans === "function" ? trans : createEasingFunction(trans);
    return new Promise(function (resolve) {
        source.value = fromVal;
        var tick = function () {
            var _a2;
            if ((_a2 = options.abort) == null ? void 0 : _a2.call(options)) {
                resolve();
                return;
            }
            var now = Date.now();
            var alpha = ease((now - startedAt) / duration);
            var arr = toVec(source.value).map(function (n, i) { return lerp(v1[i], v2[i], alpha); });
            if (Array.isArray(source.value))
                source.value = arr.map(function (n, i) {
                    var _a3, _b2;
                    return lerp((_a3 = v1[i]) != null ? _a3 : 0, (_b2 = v2[i]) != null ? _b2 : 0, alpha);
                });
            else if (typeof source.value === "number")
                source.value = arr[0];
            if (now < endAt) {
                requestAnimationFrame(tick);
            }
            else {
                source.value = toVal;
                resolve();
            }
        };
        tick();
    });
}
function useTransition(source, options) {
    var _this = this;
    if (options === void 0) { options = {}; }
    var currentId = 0;
    var sourceVal = function () {
        var v = toValue(source);
        return typeof v === "number" ? v : v.map(toValue);
    };
    var outputRef = ref(sourceVal());
    watch(sourceVal, function (to) { return __awaiter(_this, void 0, void 0, function () {
        var _a, _b, id, toVal;
        return __generator(this, function (_j) {
            switch (_j.label) {
                case 0:
                    if (toValue(options.disabled))
                        return [2 /*return*/];
                    id = ++currentId;
                    if (!options.delay) return [3 /*break*/, 2];
                    return [4 /*yield*/, promiseTimeout(toValue(options.delay))];
                case 1:
                    _j.sent();
                    _j.label = 2;
                case 2:
                    if (id !== currentId)
                        return [2 /*return*/];
                    toVal = Array.isArray(to) ? to.map(toValue) : toValue(to);
                    (_a = options.onStarted) == null ? void 0 : _a.call(options);
                    return [4 /*yield*/, executeTransition(outputRef, outputRef.value, toVal, __assign(__assign({}, options), { abort: function () {
                                var _a2;
                                return id !== currentId || ((_a2 = options.abort) == null ? void 0 : _a2.call(options));
                            } }))];
                case 3:
                    _j.sent();
                    (_b = options.onFinished) == null ? void 0 : _b.call(options);
                    return [2 /*return*/];
            }
        });
    }); }, { deep: true });
    watch(function () { return toValue(options.disabled); }, function (disabled) {
        if (disabled) {
            currentId++;
            outputRef.value = sourceVal();
        }
    });
    tryOnScopeDispose(function () {
        currentId++;
    });
    return computed(function () { return toValue(options.disabled) ? sourceVal() : outputRef.value; });
}
function useUrlSearchParams(mode, options) {
    if (mode === void 0) { mode = "history"; }
    if (options === void 0) { options = {}; }
    var _j = options.initialValue, initialValue = _j === void 0 ? {} : _j, _k = options.removeNullishValues, removeNullishValues = _k === void 0 ? true : _k, _l = options.removeFalsyValues, removeFalsyValues = _l === void 0 ? false : _l, _m = options.write, enableWrite = _m === void 0 ? true : _m, _o = options.window, window = _o === void 0 ? defaultWindow : _o;
    if (!window)
        return reactive(initialValue);
    var state = reactive({});
    function getRawParams() {
        if (mode === "history") {
            return window.location.search || "";
        }
        else if (mode === "hash") {
            var hash = window.location.hash || "";
            var index = hash.indexOf("?");
            return index > 0 ? hash.slice(index) : "";
        }
        else {
            return (window.location.hash || "").replace(/^#/, "");
        }
    }
    function constructQuery(params) {
        var stringified = params.toString();
        if (mode === "history")
            return "".concat(stringified ? "?".concat(stringified) : "").concat(window.location.hash || "");
        if (mode === "hash-params")
            return "".concat(window.location.search || "").concat(stringified ? "#".concat(stringified) : "");
        var hash = window.location.hash || "#";
        var index = hash.indexOf("?");
        if (index > 0)
            return "".concat(hash.slice(0, index)).concat(stringified ? "?".concat(stringified) : "");
        return "".concat(hash).concat(stringified ? "?".concat(stringified) : "");
    }
    function read() {
        return new URLSearchParams(getRawParams());
    }
    function updateState(params) {
        var e_18, _j;
        var unusedKeys = new Set(Object.keys(state));
        try {
            for (var _k = __values(params.keys()), _l = _k.next(); !_l.done; _l = _k.next()) {
                var key = _l.value;
                var paramsForKey = params.getAll(key);
                state[key] = paramsForKey.length > 1 ? paramsForKey : params.get(key) || "";
                unusedKeys.delete(key);
            }
        }
        catch (e_18_1) { e_18 = { error: e_18_1 }; }
        finally {
            try {
                if (_l && !_l.done && (_j = _k.return)) _j.call(_k);
            }
            finally { if (e_18) throw e_18.error; }
        }
        Array.from(unusedKeys).forEach(function (key) { return delete state[key]; });
    }
    var _p = pausableWatch(state, function () {
        var params = new URLSearchParams("");
        Object.keys(state).forEach(function (key) {
            var mapEntry = state[key];
            if (Array.isArray(mapEntry))
                mapEntry.forEach(function (value) { return params.append(key, value); });
            else if (removeNullishValues && mapEntry == null)
                params.delete(key);
            else if (removeFalsyValues && !mapEntry)
                params.delete(key);
            else
                params.set(key, mapEntry);
        });
        write(params);
    }, { deep: true }), pause = _p.pause, resume = _p.resume;
    function write(params, shouldUpdate) {
        pause();
        if (shouldUpdate)
            updateState(params);
        window.history.replaceState(window.history.state, window.document.title, window.location.pathname + constructQuery(params));
        resume();
    }
    function onChanged() {
        if (!enableWrite)
            return;
        write(read(), true);
    }
    useEventListener(window, "popstate", onChanged, false);
    if (mode !== "history")
        useEventListener(window, "hashchange", onChanged, false);
    var initial = read();
    if (initial.keys().next().value)
        updateState(initial);
    else
        Object.assign(state, initialValue);
    return state;
}
function useUserMedia(options) {
    if (options === void 0) { options = {}; }
    var _a, _b;
    var enabled = ref((_a = options.enabled) != null ? _a : false);
    var autoSwitch = ref((_b = options.autoSwitch) != null ? _b : true);
    var constraints = ref(options.constraints);
    var _j = options.navigator, navigator = _j === void 0 ? defaultNavigator : _j;
    var isSupported = useSupported(function () {
        var _a2;
        return (_a2 = navigator == null ? void 0 : navigator.mediaDevices) == null ? void 0 : _a2.getUserMedia;
    });
    var stream = shallowRef();
    function getDeviceOptions(type) {
        switch (type) {
            case "video": {
                if (constraints.value)
                    return constraints.value.video || false;
                break;
            }
            case "audio": {
                if (constraints.value)
                    return constraints.value.audio || false;
                break;
            }
        }
    }
    function _start() {
        return __awaiter(this, void 0, void 0, function () {
            var _j;
            return __generator(this, function (_k) {
                switch (_k.label) {
                    case 0:
                        if (!isSupported.value || stream.value)
                            return [2 /*return*/];
                        _j = stream;
                        return [4 /*yield*/, navigator.mediaDevices.getUserMedia({
                                video: getDeviceOptions("video"),
                                audio: getDeviceOptions("audio")
                            })];
                    case 1:
                        _j.value = _k.sent();
                        return [2 /*return*/, stream.value];
                }
            });
        });
    }
    function _stop() {
        var _a2;
        (_a2 = stream.value) == null ? void 0 : _a2.getTracks().forEach(function (t) { return t.stop(); });
        stream.value = void 0;
    }
    function stop() {
        _stop();
        enabled.value = false;
    }
    function start() {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_j) {
                switch (_j.label) {
                    case 0: return [4 /*yield*/, _start()];
                    case 1:
                        _j.sent();
                        if (stream.value)
                            enabled.value = true;
                        return [2 /*return*/, stream.value];
                }
            });
        });
    }
    function restart() {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_j) {
                switch (_j.label) {
                    case 0:
                        _stop();
                        return [4 /*yield*/, start()];
                    case 1: return [2 /*return*/, _j.sent()];
                }
            });
        });
    }
    watch(enabled, function (v) {
        if (v)
            _start();
        else
            _stop();
    }, { immediate: true });
    watch(constraints, function () {
        if (autoSwitch.value && stream.value)
            restart();
    }, { immediate: true });
    tryOnScopeDispose(function () {
        stop();
    });
    return {
        isSupported: isSupported,
        stream: stream,
        start: start,
        stop: stop,
        restart: restart,
        constraints: constraints,
        enabled: enabled,
        autoSwitch: autoSwitch
    };
}
function useVModel(props, key, emit, options) {
    if (options === void 0) { options = {}; }
    var _a, _b, _c, _d, _e;
    var _j = options.clone, clone = _j === void 0 ? false : _j, _k = options.passive, passive = _k === void 0 ? false : _k, eventName = options.eventName, _l = options.deep, deep = _l === void 0 ? false : _l, defaultValue = options.defaultValue, shouldEmit = options.shouldEmit;
    var vm = getCurrentInstance();
    var _emit = emit || (vm == null ? void 0 : vm.emit) || ((_a = vm == null ? void 0 : vm.$emit) == null ? void 0 : _a.bind(vm)) || ((_c = (_b = vm == null ? void 0 : vm.proxy) == null ? void 0 : _b.$emit) == null ? void 0 : _c.bind(vm == null ? void 0 : vm.proxy));
    var event = eventName;
    if (!key) {
        if (isVue2) {
            var modelOptions = (_e = (_d = vm == null ? void 0 : vm.proxy) == null ? void 0 : _d.$options) == null ? void 0 : _e.model;
            key = (modelOptions == null ? void 0 : modelOptions.value) || "value";
            if (!eventName)
                event = (modelOptions == null ? void 0 : modelOptions.event) || "input";
        }
        else {
            key = "modelValue";
        }
    }
    event = event || "update:".concat(key.toString());
    var cloneFn = function (val) { return !clone ? val : typeof clone === "function" ? clone(val) : cloneFnJSON(val); };
    var getValue = function () { return isDef(props[key]) ? cloneFn(props[key]) : defaultValue; };
    var triggerEmit = function (value) {
        if (shouldEmit) {
            if (shouldEmit(value))
                _emit(event, value);
        }
        else {
            _emit(event, value);
        }
    };
    if (passive) {
        var initialValue = getValue();
        var proxy_1 = ref(initialValue);
        var isUpdating_1 = false;
        watch(function () { return props[key]; }, function (v) {
            if (!isUpdating_1) {
                isUpdating_1 = true;
                proxy_1.value = cloneFn(v);
                nextTick(function () { return isUpdating_1 = false; });
            }
        });
        watch(proxy_1, function (v) {
            if (!isUpdating_1 && (v !== props[key] || deep))
                triggerEmit(v);
        }, { deep: deep });
        return proxy_1;
    }
    else {
        return computed({
            get: function () {
                return getValue();
            },
            set: function (value) {
                triggerEmit(value);
            }
        });
    }
}
function useVModels(props, emit, options) {
    if (options === void 0) { options = {}; }
    var ret = {};
    for (var key in props) {
        ret[key] = useVModel(props, key, emit, options);
    }
    return ret;
}
function useVibrate(options) {
    var _j = options || {}, _k = _j.pattern, pattern = _k === void 0 ? [] : _k, _l = _j.interval, interval = _l === void 0 ? 0 : _l, _m = _j.navigator, navigator = _m === void 0 ? defaultNavigator : _m;
    var isSupported = useSupported(function () { return typeof navigator !== "undefined" && "vibrate" in navigator; });
    var patternRef = toRef(pattern);
    var intervalControls;
    var vibrate = function (pattern2) {
        if (pattern2 === void 0) { pattern2 = patternRef.value; }
        if (isSupported.value)
            navigator.vibrate(pattern2);
    };
    var stop = function () {
        if (isSupported.value)
            navigator.vibrate(0);
        intervalControls == null ? void 0 : intervalControls.pause();
    };
    if (interval > 0) {
        intervalControls = useIntervalFn(vibrate, interval, {
            immediate: false,
            immediateCallback: false
        });
    }
    return {
        isSupported: isSupported,
        pattern: pattern,
        intervalControls: intervalControls,
        vibrate: vibrate,
        stop: stop
    };
}
function useVirtualList(list, options) {
    var _j = "itemHeight" in options ? useVerticalVirtualList(options, list) : useHorizontalVirtualList(options, list), containerStyle = _j.containerStyle, wrapperProps = _j.wrapperProps, scrollTo = _j.scrollTo, calculateRange = _j.calculateRange, currentList = _j.currentList, containerRef = _j.containerRef;
    return {
        list: currentList,
        scrollTo: scrollTo,
        containerProps: {
            ref: containerRef,
            onScroll: function () {
                calculateRange();
            },
            style: containerStyle
        },
        wrapperProps: wrapperProps
    };
}
function useVirtualListResources(list) {
    var containerRef = ref(null);
    var size = useElementSize(containerRef);
    var currentList = ref([]);
    var source = shallowRef(list);
    var state = ref({ start: 0, end: 10 });
    return { state: state, source: source, currentList: currentList, size: size, containerRef: containerRef };
}
function createGetViewCapacity(state, source, itemSize) {
    return function (containerSize) {
        if (typeof itemSize === "number")
            return Math.ceil(containerSize / itemSize);
        var _j = state.value.start, start = _j === void 0 ? 0 : _j;
        var sum = 0;
        var capacity = 0;
        for (var i = start; i < source.value.length; i++) {
            var size = itemSize(i);
            sum += size;
            capacity = i;
            if (sum > containerSize)
                break;
        }
        return capacity - start;
    };
}
function createGetOffset(source, itemSize) {
    return function (scrollDirection) {
        if (typeof itemSize === "number")
            return Math.floor(scrollDirection / itemSize) + 1;
        var sum = 0;
        var offset = 0;
        for (var i = 0; i < source.value.length; i++) {
            var size = itemSize(i);
            sum += size;
            if (sum >= scrollDirection) {
                offset = i;
                break;
            }
        }
        return offset + 1;
    };
}
function createCalculateRange(type, overscan, getOffset, getViewCapacity, _j) {
    var containerRef = _j.containerRef, state = _j.state, currentList = _j.currentList, source = _j.source;
    return function () {
        var element = containerRef.value;
        if (element) {
            var offset = getOffset(type === "vertical" ? element.scrollTop : element.scrollLeft);
            var viewCapacity = getViewCapacity(type === "vertical" ? element.clientHeight : element.clientWidth);
            var from = offset - overscan;
            var to = offset + viewCapacity + overscan;
            state.value = {
                start: from < 0 ? 0 : from,
                end: to > source.value.length ? source.value.length : to
            };
            currentList.value = source.value.slice(state.value.start, state.value.end).map(function (ele, index) { return ({
                data: ele,
                index: index + state.value.start
            }); });
        }
    };
}
function createGetDistance(itemSize, source) {
    return function (index) {
        if (typeof itemSize === "number") {
            var size2 = index * itemSize;
            return size2;
        }
        var size = source.value.slice(0, index).reduce(function (sum, _, i) { return sum + itemSize(i); }, 0);
        return size;
    };
}
function useWatchForSizes(size, list, containerRef, calculateRange) {
    watch([size.width, size.height, list, containerRef], function () {
        calculateRange();
    });
}
function createComputedTotalSize(itemSize, source) {
    return computed(function () {
        if (typeof itemSize === "number")
            return source.value.length * itemSize;
        return source.value.reduce(function (sum, _, index) { return sum + itemSize(index); }, 0);
    });
}
var scrollToDictionaryForElementScrollKey = {
    horizontal: "scrollLeft",
    vertical: "scrollTop"
};
function createScrollTo(type, calculateRange, getDistance, containerRef) {
    return function (index) {
        if (containerRef.value) {
            containerRef.value[scrollToDictionaryForElementScrollKey[type]] = getDistance(index);
            calculateRange();
        }
    };
}
function useHorizontalVirtualList(options, list) {
    var resources = useVirtualListResources(list);
    var state = resources.state, source = resources.source, currentList = resources.currentList, size = resources.size, containerRef = resources.containerRef;
    var containerStyle = { overflowX: "auto" };
    var itemWidth = options.itemWidth, _j = options.overscan, overscan = _j === void 0 ? 5 : _j;
    var getViewCapacity = createGetViewCapacity(state, source, itemWidth);
    var getOffset = createGetOffset(source, itemWidth);
    var calculateRange = createCalculateRange("horizontal", overscan, getOffset, getViewCapacity, resources);
    var getDistanceLeft = createGetDistance(itemWidth, source);
    var offsetLeft = computed(function () { return getDistanceLeft(state.value.start); });
    var totalWidth = createComputedTotalSize(itemWidth, source);
    useWatchForSizes(size, list, containerRef, calculateRange);
    var scrollTo = createScrollTo("horizontal", calculateRange, getDistanceLeft, containerRef);
    var wrapperProps = computed(function () {
        return {
            style: {
                height: "100%",
                width: "".concat(totalWidth.value - offsetLeft.value, "px"),
                marginLeft: "".concat(offsetLeft.value, "px"),
                display: "flex"
            }
        };
    });
    return {
        scrollTo: scrollTo,
        calculateRange: calculateRange,
        wrapperProps: wrapperProps,
        containerStyle: containerStyle,
        currentList: currentList,
        containerRef: containerRef
    };
}
function useVerticalVirtualList(options, list) {
    var resources = useVirtualListResources(list);
    var state = resources.state, source = resources.source, currentList = resources.currentList, size = resources.size, containerRef = resources.containerRef;
    var containerStyle = { overflowY: "auto" };
    var itemHeight = options.itemHeight, _j = options.overscan, overscan = _j === void 0 ? 5 : _j;
    var getViewCapacity = createGetViewCapacity(state, source, itemHeight);
    var getOffset = createGetOffset(source, itemHeight);
    var calculateRange = createCalculateRange("vertical", overscan, getOffset, getViewCapacity, resources);
    var getDistanceTop = createGetDistance(itemHeight, source);
    var offsetTop = computed(function () { return getDistanceTop(state.value.start); });
    var totalHeight = createComputedTotalSize(itemHeight, source);
    useWatchForSizes(size, list, containerRef, calculateRange);
    var scrollTo = createScrollTo("vertical", calculateRange, getDistanceTop, containerRef);
    var wrapperProps = computed(function () {
        return {
            style: {
                width: "100%",
                height: "".concat(totalHeight.value - offsetTop.value, "px"),
                marginTop: "".concat(offsetTop.value, "px")
            }
        };
    });
    return {
        calculateRange: calculateRange,
        scrollTo: scrollTo,
        containerStyle: containerStyle,
        wrapperProps: wrapperProps,
        currentList: currentList,
        containerRef: containerRef
    };
}
function useWakeLock(options) {
    if (options === void 0) { options = {}; }
    var _j = options.navigator, navigator = _j === void 0 ? defaultNavigator : _j, _k = options.document, document = _k === void 0 ? defaultDocument : _k;
    var wakeLock;
    var isSupported = useSupported(function () { return navigator && "wakeLock" in navigator; });
    var isActive = ref(false);
    function onVisibilityChange() {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_j) {
                switch (_j.label) {
                    case 0:
                        if (!isSupported.value || !wakeLock)
                            return [2 /*return*/];
                        if (!(document && document.visibilityState === "visible")) return [3 /*break*/, 2];
                        return [4 /*yield*/, navigator.wakeLock.request("screen")];
                    case 1:
                        wakeLock = _j.sent();
                        _j.label = 2;
                    case 2:
                        isActive.value = !wakeLock.released;
                        return [2 /*return*/];
                }
            });
        });
    }
    if (document)
        useEventListener(document, "visibilitychange", onVisibilityChange, { passive: true });
    function request(type) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_j) {
                switch (_j.label) {
                    case 0:
                        if (!isSupported.value)
                            return [2 /*return*/];
                        return [4 /*yield*/, navigator.wakeLock.request(type)];
                    case 1:
                        wakeLock = _j.sent();
                        isActive.value = !wakeLock.released;
                        return [2 /*return*/];
                }
            });
        });
    }
    function release() {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_j) {
                switch (_j.label) {
                    case 0:
                        if (!isSupported.value || !wakeLock)
                            return [2 /*return*/];
                        return [4 /*yield*/, wakeLock.release()];
                    case 1:
                        _j.sent();
                        isActive.value = !wakeLock.released;
                        wakeLock = null;
                        return [2 /*return*/];
                }
            });
        });
    }
    return {
        isSupported: isSupported,
        isActive: isActive,
        request: request,
        release: release
    };
}
function useWebNotification(options) {
    var _this = this;
    if (options === void 0) { options = {}; }
    var _j = options.window, window = _j === void 0 ? defaultWindow : _j, _k = options.requestPermissions, _requestForPermissions = _k === void 0 ? true : _k;
    var defaultWebNotificationOptions = options;
    var isSupported = useSupported(function () {
        if (!window || !("Notification" in window))
            return false;
        try {
            new Notification("");
        }
        catch (e) {
            return false;
        }
        return true;
    });
    var permissionGranted = ref(isSupported.value && "permission" in Notification && Notification.permission === "granted");
    var notification = ref(null);
    var ensurePermissions = function () { return __awaiter(_this, void 0, void 0, function () {
        var result;
        return __generator(this, function (_j) {
            switch (_j.label) {
                case 0:
                    if (!isSupported.value)
                        return [2 /*return*/];
                    if (!(!permissionGranted.value && Notification.permission !== "denied")) return [3 /*break*/, 2];
                    return [4 /*yield*/, Notification.requestPermission()];
                case 1:
                    result = _j.sent();
                    if (result === "granted")
                        permissionGranted.value = true;
                    _j.label = 2;
                case 2: return [2 /*return*/, permissionGranted.value];
            }
        });
    }); };
    var _l = createEventHook(), onClick = _l.on, clickTrigger = _l.trigger;
    var _m = createEventHook(), onShow = _m.on, showTrigger = _m.trigger;
    var _o = createEventHook(), onError = _o.on, errorTrigger = _o.trigger;
    var _p = createEventHook(), onClose = _p.on, closeTrigger = _p.trigger;
    var show = function (overrides) { return __awaiter(_this, void 0, void 0, function () {
        var options2;
        return __generator(this, function (_j) {
            if (!isSupported.value || !permissionGranted.value)
                return [2 /*return*/];
            options2 = Object.assign({}, defaultWebNotificationOptions, overrides);
            notification.value = new Notification(options2.title || "", options2);
            notification.value.onclick = clickTrigger;
            notification.value.onshow = showTrigger;
            notification.value.onerror = errorTrigger;
            notification.value.onclose = closeTrigger;
            return [2 /*return*/, notification.value];
        });
    }); };
    var close = function () {
        if (notification.value)
            notification.value.close();
        notification.value = null;
    };
    if (_requestForPermissions)
        tryOnMounted(ensurePermissions);
    tryOnScopeDispose(close);
    if (isSupported.value && window) {
        var document_2 = window.document;
        useEventListener(document_2, "visibilitychange", function (e) {
            e.preventDefault();
            if (document_2.visibilityState === "visible") {
                close();
            }
        });
    }
    return {
        isSupported: isSupported,
        notification: notification,
        ensurePermissions: ensurePermissions,
        permissionGranted: permissionGranted,
        show: show,
        close: close,
        onClick: onClick,
        onShow: onShow,
        onError: onError,
        onClose: onClose
    };
}
var DEFAULT_PING_MESSAGE = "ping";
function resolveNestedOptions(options) {
    if (options === true)
        return {};
    return options;
}
function useWebSocket(url, options) {
    if (options === void 0) { options = {}; }
    var onConnected = options.onConnected, onDisconnected = options.onDisconnected, onError = options.onError, onMessage = options.onMessage, _j = options.immediate, immediate = _j === void 0 ? true : _j, _k = options.autoClose, autoClose = _k === void 0 ? true : _k, _l = options.protocols, protocols = _l === void 0 ? [] : _l;
    var data = ref(null);
    var status = ref("CLOSED");
    var wsRef = ref();
    var urlRef = toRef(url);
    var heartbeatPause;
    var heartbeatResume;
    var explicitlyClosed = false;
    var retried = 0;
    var bufferedData = [];
    var pongTimeoutWait;
    var _sendBuffer = function () {
        var e_19, _j;
        if (bufferedData.length && wsRef.value && status.value === "OPEN") {
            try {
                for (var bufferedData_1 = __values(bufferedData), bufferedData_1_1 = bufferedData_1.next(); !bufferedData_1_1.done; bufferedData_1_1 = bufferedData_1.next()) {
                    var buffer = bufferedData_1_1.value;
                    wsRef.value.send(buffer);
                }
            }
            catch (e_19_1) { e_19 = { error: e_19_1 }; }
            finally {
                try {
                    if (bufferedData_1_1 && !bufferedData_1_1.done && (_j = bufferedData_1.return)) _j.call(bufferedData_1);
                }
                finally { if (e_19) throw e_19.error; }
            }
            bufferedData = [];
        }
    };
    var resetHeartbeat = function () {
        clearTimeout(pongTimeoutWait);
        pongTimeoutWait = void 0;
    };
    var close = function (code, reason) {
        if (code === void 0) { code = 1e3; }
        if (!isClient || !wsRef.value)
            return;
        explicitlyClosed = true;
        resetHeartbeat();
        heartbeatPause == null ? void 0 : heartbeatPause();
        wsRef.value.close(code, reason);
        wsRef.value = void 0;
    };
    var send = function (data2, useBuffer) {
        if (useBuffer === void 0) { useBuffer = true; }
        if (!wsRef.value || status.value !== "OPEN") {
            if (useBuffer)
                bufferedData.push(data2);
            return false;
        }
        _sendBuffer();
        wsRef.value.send(data2);
        return true;
    };
    var _init = function () {
        if (explicitlyClosed || typeof urlRef.value === "undefined")
            return;
        var ws = new WebSocket(urlRef.value, protocols);
        wsRef.value = ws;
        status.value = "CONNECTING";
        ws.onopen = function () {
            status.value = "OPEN";
            onConnected == null ? void 0 : onConnected(ws);
            heartbeatResume == null ? void 0 : heartbeatResume();
            _sendBuffer();
        };
        ws.onclose = function (ev) {
            status.value = "CLOSED";
            onDisconnected == null ? void 0 : onDisconnected(ws, ev);
            if (!explicitlyClosed && options.autoReconnect) {
                var _j = resolveNestedOptions(options.autoReconnect), _k = _j.retries, retries = _k === void 0 ? -1 : _k, _l = _j.delay, delay = _l === void 0 ? 1e3 : _l, onFailed = _j.onFailed;
                retried += 1;
                if (typeof retries === "number" && (retries < 0 || retried < retries))
                    setTimeout(_init, delay);
                else if (typeof retries === "function" && retries())
                    setTimeout(_init, delay);
                else
                    onFailed == null ? void 0 : onFailed();
            }
        };
        ws.onerror = function (e) {
            onError == null ? void 0 : onError(ws, e);
        };
        ws.onmessage = function (e) {
            if (options.heartbeat) {
                resetHeartbeat();
                var _j = resolveNestedOptions(options.heartbeat).message, message = _j === void 0 ? DEFAULT_PING_MESSAGE : _j;
                if (e.data === message)
                    return;
            }
            data.value = e.data;
            onMessage == null ? void 0 : onMessage(ws, e);
        };
    };
    if (options.heartbeat) {
        var _m = resolveNestedOptions(options.heartbeat), _o = _m.message, message_1 = _o === void 0 ? DEFAULT_PING_MESSAGE : _o, _p = _m.interval, interval = _p === void 0 ? 1e3 : _p, _q = _m.pongTimeout, pongTimeout_1 = _q === void 0 ? 1e3 : _q;
        var _r = useIntervalFn(function () {
            send(message_1, false);
            if (pongTimeoutWait != null)
                return;
            pongTimeoutWait = setTimeout(function () {
                close();
                explicitlyClosed = false;
            }, pongTimeout_1);
        }, interval, { immediate: false }), pause = _r.pause, resume = _r.resume;
        heartbeatPause = pause;
        heartbeatResume = resume;
    }
    if (autoClose) {
        if (isClient)
            useEventListener("beforeunload", function () { return close(); });
        tryOnScopeDispose(close);
    }
    var open = function () {
        if (!isClient && !isWorker)
            return;
        close();
        explicitlyClosed = false;
        retried = 0;
        _init();
    };
    if (immediate)
        open();
    watch(urlRef, open);
    return {
        data: data,
        status: status,
        close: close,
        send: send,
        open: open,
        ws: wsRef
    };
}
function useWebWorker(arg0, workerOptions, options) {
    var _j = (options != null ? options : {}).window, window = _j === void 0 ? defaultWindow : _j;
    var data = ref(null);
    var worker = shallowRef();
    var post = function () {
        var _j;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!worker.value)
            return;
        (_j = worker.value).postMessage.apply(_j, __spreadArray([], __read(args), false));
    };
    var terminate = function terminate2() {
        if (!worker.value)
            return;
        worker.value.terminate();
    };
    if (window) {
        if (typeof arg0 === "string")
            worker.value = new Worker(arg0, workerOptions);
        else if (typeof arg0 === "function")
            worker.value = arg0();
        else
            worker.value = arg0;
        worker.value.onmessage = function (e) {
            data.value = e.data;
        };
        tryOnScopeDispose(function () {
            if (worker.value)
                worker.value.terminate();
        });
    }
    return {
        data: data,
        post: post,
        terminate: terminate,
        worker: worker
    };
}
function jobRunner(userFunc) {
    return function (e) {
        var userFuncArgs = e.data[0];
        return Promise.resolve(userFunc.apply(void 0, userFuncArgs)).then(function (result) {
            postMessage(["SUCCESS", result]);
        }).catch(function (error) {
            postMessage(["ERROR", error]);
        });
    };
}
function depsParser(deps, localDeps) {
    if (deps.length === 0 && localDeps.length === 0)
        return "";
    var depsString = deps.map(function (dep) { return "'".concat(dep, "'"); }).toString();
    var depsFunctionString = localDeps.filter(function (dep) { return typeof dep === "function"; }).map(function (fn) {
        var str = fn.toString();
        if (str.trim().startsWith("function")) {
            return str;
        }
        else {
            var name = fn.name;
            return "const ".concat(name, " = ").concat(str);
        }
    }).join(";");
    var importString = "importScripts(".concat(depsString, ");");
    return "".concat(depsString.trim() === "" ? "" : importString, " ").concat(depsFunctionString);
}
function createWorkerBlobUrl(fn, deps, localDeps) {
    var blobCode = "".concat(depsParser(deps, localDeps), "; onmessage=(").concat(jobRunner, ")(").concat(fn, ")");
    var blob = new Blob([blobCode], { type: "text/javascript" });
    var url = URL.createObjectURL(blob);
    return url;
}
function useWebWorkerFn(fn, options) {
    if (options === void 0) { options = {}; }
    var _j = options.dependencies, dependencies = _j === void 0 ? [] : _j, _k = options.localDependencies, localDependencies = _k === void 0 ? [] : _k, timeout = options.timeout, _l = options.window, window = _l === void 0 ? defaultWindow : _l;
    var worker = ref();
    var workerStatus = ref("PENDING");
    var promise = ref({});
    var timeoutId = ref();
    var workerTerminate = function (status) {
        if (status === void 0) { status = "PENDING"; }
        if (worker.value && worker.value._url && window) {
            worker.value.terminate();
            URL.revokeObjectURL(worker.value._url);
            promise.value = {};
            worker.value = void 0;
            window.clearTimeout(timeoutId.value);
            workerStatus.value = status;
        }
    };
    workerTerminate();
    tryOnScopeDispose(workerTerminate);
    var generateWorker = function () {
        var blobUrl = createWorkerBlobUrl(fn, dependencies, localDependencies);
        var newWorker = new Worker(blobUrl);
        newWorker._url = blobUrl;
        newWorker.onmessage = function (e) {
            var _j = promise.value, _k = _j.resolve, resolve = _k === void 0 ? function () {
            } : _k, _l = _j.reject, reject = _l === void 0 ? function () {
            } : _l;
            var _m = __read(e.data, 2), status = _m[0], result = _m[1];
            switch (status) {
                case "SUCCESS":
                    resolve(result);
                    workerTerminate(status);
                    break;
                default:
                    reject(result);
                    workerTerminate("ERROR");
                    break;
            }
        };
        newWorker.onerror = function (e) {
            var _j = promise.value.reject, reject = _j === void 0 ? function () {
            } : _j;
            e.preventDefault();
            reject(e);
            workerTerminate("ERROR");
        };
        if (timeout) {
            timeoutId.value = setTimeout(function () { return workerTerminate("TIMEOUT_EXPIRED"); }, timeout);
        }
        return newWorker;
    };
    var callWorker = function () {
        var fnArgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            fnArgs[_i] = arguments[_i];
        }
        return new Promise(function (resolve, reject) {
            promise.value = {
                resolve: resolve,
                reject: reject
            };
            worker.value && worker.value.postMessage([__spreadArray([], __read(fnArgs), false)]);
            workerStatus.value = "RUNNING";
        });
    };
    var workerFn = function () {
        var fnArgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            fnArgs[_i] = arguments[_i];
        }
        if (workerStatus.value === "RUNNING") {
            console.error("[useWebWorkerFn] You can only run one instance of the worker at a time.");
            return Promise.reject();
        }
        worker.value = generateWorker();
        return callWorker.apply(void 0, __spreadArray([], __read(fnArgs), false));
    };
    return {
        workerFn: workerFn,
        workerStatus: workerStatus,
        workerTerminate: workerTerminate
    };
}
function useWindowFocus(options) {
    if (options === void 0) { options = {}; }
    var _j = options.window, window = _j === void 0 ? defaultWindow : _j;
    if (!window)
        return ref(false);
    var focused = ref(window.document.hasFocus());
    useEventListener(window, "blur", function () {
        focused.value = false;
    });
    useEventListener(window, "focus", function () {
        focused.value = true;
    });
    return focused;
}
function useWindowScroll(options) {
    if (options === void 0) { options = {}; }
    var _j = options.window, window = _j === void 0 ? defaultWindow : _j, _k = options.behavior, behavior = _k === void 0 ? "auto" : _k;
    if (!window) {
        return {
            x: ref(0),
            y: ref(0)
        };
    }
    var internalX = ref(window.scrollX);
    var internalY = ref(window.scrollY);
    var x = computed({
        get: function () {
            return internalX.value;
        },
        set: function (x2) {
            scrollTo({ left: x2, behavior: behavior });
        }
    });
    var y = computed({
        get: function () {
            return internalY.value;
        },
        set: function (y2) {
            scrollTo({ top: y2, behavior: behavior });
        }
    });
    useEventListener(window, "scroll", function () {
        internalX.value = window.scrollX;
        internalY.value = window.scrollY;
    }, {
        capture: false,
        passive: true
    });
    return { x: x, y: y };
}
function useWindowSize(options) {
    if (options === void 0) { options = {}; }
    var _j = options.window, window = _j === void 0 ? defaultWindow : _j, _k = options.initialWidth, initialWidth = _k === void 0 ? Number.POSITIVE_INFINITY : _k, _l = options.initialHeight, initialHeight = _l === void 0 ? Number.POSITIVE_INFINITY : _l, _m = options.listenOrientation, listenOrientation = _m === void 0 ? true : _m, _o = options.includeScrollbar, includeScrollbar = _o === void 0 ? true : _o;
    var width = ref(initialWidth);
    var height = ref(initialHeight);
    var update = function () {
        if (window) {
            if (includeScrollbar) {
                width.value = window.innerWidth;
                height.value = window.innerHeight;
            }
            else {
                width.value = window.document.documentElement.clientWidth;
                height.value = window.document.documentElement.clientHeight;
            }
        }
    };
    update();
    tryOnMounted(update);
    useEventListener("resize", update, { passive: true });
    if (listenOrientation) {
        var matches = useMediaQuery("(orientation: portrait)");
        watch(matches, function () { return update(); });
    }
    return { width: width, height: height };
}
export { DefaultMagicKeysAliasMap, StorageSerializers, TransitionPresets, computedAsync as asyncComputed, breakpointsAntDesign, breakpointsBootstrapV5, breakpointsMasterCss, breakpointsPrimeFlex, breakpointsQuasar, breakpointsSematic, breakpointsTailwind, breakpointsVuetify, breakpointsVuetifyV2, breakpointsVuetifyV3, cloneFnJSON, computedAsync, computedInject, createFetch, createReusableTemplate, createTemplatePromise, createUnrefFn, customStorageEventName, defaultDocument, defaultLocation, defaultNavigator, defaultWindow, executeTransition, formatTimeAgo, getSSRHandler, mapGamepadToXbox360Controller, onClickOutside, onKeyDown, onKeyPressed, onKeyStroke, onKeyUp, onLongPress, onStartTyping, setSSRHandler, templateRef, unrefElement, useActiveElement, useAnimate, useAsyncQueue, useAsyncState, useBase64, useBattery, useBluetooth, useBreakpoints, useBroadcastChannel, useBrowserLocation, useCached, useClipboard, useClipboardItems, useCloned, useColorMode, useConfirmDialog, useCssVar, useCurrentElement, useCycleList, useDark, useDebouncedRefHistory, useDeviceMotion, useDeviceOrientation, useDevicePixelRatio, useDevicesList, useDisplayMedia, useDocumentVisibility, useDraggable, useDropZone, useElementBounding, useElementByPoint, useElementHover, useElementSize, useElementVisibility, useEventBus, useEventListener, useEventSource, useEyeDropper, useFavicon, useFetch, useFileDialog, useFileSystemAccess, useFocus, useFocusWithin, useFps, useFullscreen, useGamepad, useGeolocation, useIdle, useImage, useInfiniteScroll, useIntersectionObserver, useKeyModifier, useLocalStorage, useMagicKeys, useManualRefHistory, useMediaControls, useMediaQuery, useMemoize, useMemory, useMounted, useMouse, useMouseInElement, useMousePressed, useMutationObserver, useNavigatorLanguage, useNetwork, useNow, useObjectUrl, useOffsetPagination, useOnline, usePageLeave, useParallax, useParentElement, usePerformanceObserver, usePermission, usePointer, usePointerLock, usePointerSwipe, usePreferredColorScheme, usePreferredContrast, usePreferredDark, usePreferredLanguages, usePreferredReducedMotion, usePrevious, useRafFn, useRefHistory, useResizeObserver, useScreenOrientation, useScreenSafeArea, useScriptTag, useScroll, useScrollLock, useSessionStorage, useShare, useSorted, useSpeechRecognition, useSpeechSynthesis, useStepper, useStorage, useStorageAsync, useStyleTag, useSupported, useSwipe, useTemplateRefsList, useTextDirection, useTextSelection, useTextareaAutosize, useThrottledRefHistory, useTimeAgo, useTimeoutPoll, useTimestamp, useTitle, useTransition, useUrlSearchParams, useUserMedia, useVModel, useVModels, useVibrate, useVirtualList, useWakeLock, useWebNotification, useWebSocket, useWebWorker, useWebWorkerFn, useWindowFocus, useWindowScroll, useWindowSize };
